[
  {
    "id": 1,
    "uuid": "9818ecda-9cbf-4f2a-9af8-8136ef39cfcd",
    "hitokoto": "与众不同的生活方式很累人呢，因为找不到借口。",
    "type": "a",
    "from": "幸运星",
    "from_who": null,
    "creator": "跳舞的果果",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 22
  },
  {
    "id": 2,
    "uuid": "4e71bc61-9f2e-49e1-a62f-d4b8ad9716c6",
    "hitokoto": "面对就好，去经历就好。",
    "type": "a",
    "from": "花伞菌",
    "from_who": null,
    "creator": "umbrella",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 11
  },
  {
    "id": 3,
    "uuid": "8ea19537-2bae-4f64-8296-b8f1eed8006a",
    "hitokoto": "将愿望倾入不愿忘却的回忆中……",
    "type": "a",
    "from": "ef-a tale of memories",
    "from_who": null,
    "creator": "lqsasa",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 15
  },
  {
    "id": 4,
    "uuid": "a2a6645b-a631-4a7c-a5c3-d835e4775c17",
    "hitokoto": "美好的人眼里映出的世界也是美好的。",
    "type": "a",
    "from": "ARIA",
    "from_who": null,
    "creator": "misaki",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 17
  },
  {
    "id": 5,
    "uuid": "1905d15f-9ade-454f-8478-3b169c8dee61",
    "hitokoto": "看似美好的东西，往往藏着陷阱。",
    "type": "a",
    "from": "只有神知道的世界",
    "from_who": null,
    "creator": "紫月岚",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 15
  },
  {
    "id": 6,
    "uuid": "124cdf23-bbbb-4724-adc0-02e8aedf8f17",
    "hitokoto": "天空是连着的，如果我们也能各自发光的话，无论距离有多远，都能看到彼此努力的身影。",
    "type": "a",
    "from": "龙虎斗",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 40
  },
  {
    "id": 7,
    "uuid": "f0ae41d9-25ab-4960-9506-22171dcd1504",
    "hitokoto": "恋ではなく、爱でもなく、もっとずっと 深く重い。",
    "type": "a",
    "from": "sweet   pool",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 24
  },
  {
    "id": 8,
    "uuid": "3b2e6049-5dca-4cfe-9b4a-f16b6db17c38",
    "hitokoto": "花开花落，再灿烂的星光也会消失。",
    "type": "a",
    "from": "圣斗士星矢",
    "from_who": null,
    "creator": "水幻之音",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 9,
    "uuid": "afbaeea5-b6ab-4d9f-b08a-abc65a9d87cc",
    "hitokoto": "挡着在我们面前的是巨大庞然的人生，阻隔在我们中间的是广阔无际的时间，对于他们，我们无能为力……",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "zjl4835751",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 47
  },
  {
    "id": 10,
    "uuid": "aa833615-6333-439c-8ca3-1a067e884d58",
    "hitokoto": "我是一个经常笑的人，可我不是经常开心的人。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 11,
    "uuid": "27f3fd8b-53c6-4976-b6ad-1d56653d9a03",
    "hitokoto": "努力是不会背叛自己的，虽然梦想有时会背叛自己。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "百花残",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 23
  },
  {
    "id": 12,
    "uuid": "21876029-7f74-4d10-86d8-70c724248f5d",
    "hitokoto": "人经历风浪是会变得更强，可是船不同，日积月累的只有伤痛。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "Jonse",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 28
  },
  {
    "id": 13,
    "uuid": "1c496696-7d7c-4dde-b8be-3a71cea020ab",
    "hitokoto": "真相只有一个！",
    "type": "a",
    "from": "柯南",
    "from_who": null,
    "creator": "freejishu",
    "creator_uid": 1,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 7
  },
  {
    "id": 14,
    "uuid": "d862941f-5404-45c8-84fa-aa97eb9db92d",
    "hitokoto": "用你的笑容去改变这个世界，别让这个世界改变了你的笑容。",
    "type": "a",
    "from": "网络",
    "from_who": null,
    "creator": "酱七",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 27
  },
  {
    "id": 15,
    "uuid": "a4c37812-1fff-4d66-98c1-1b5ecf687e1e",
    "hitokoto": "我有在反省，但我不后悔。",
    "type": "a",
    "from": "物语系列",
    "from_who": null,
    "creator": "billykingzero",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 16,
    "uuid": "489cf466-ef41-4ea3-b26f-bf454a02efbb",
    "hitokoto": "我没有梦想，但是我能保护！",
    "type": "a",
    "from": "假面骑士555",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 13
  },
  {
    "id": 17,
    "uuid": "c893e847-d381-4d3e-93ae-60292fab099a",
    "hitokoto": "或许只需一滴露水，便能守护这绽放的花朵。",
    "type": "a",
    "from": "反叛的鲁鲁修",
    "from_who": null,
    "creator": "夜夜天天",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 18,
    "uuid": "5632f221-4e22-43c0-a90a-ef8581b8e27b",
    "hitokoto": "我不会让任何人看到我软弱的一面。",
    "type": "a",
    "from": "桔梗",
    "from_who": null,
    "creator": "星之彼岸",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 19,
    "uuid": "48fd5061-dc77-419c-8beb-b96d71f930ff",
    "hitokoto": "当你想做一件事，却无能为力的时候，是最痛苦的。",
    "type": "a",
    "from": "高达SEED",
    "from_who": null,
    "creator": "矢野加奈",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 23
  },
  {
    "id": 20,
    "uuid": "d05ae153-c17d-4546-8ccb-347bead06b0a",
    "hitokoto": "我的腿让我停下，可是心却不允许我那么做。",
    "type": "a",
    "from": "钢之炼金术师",
    "from_who": null,
    "creator": "Sakamoto",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 21,
    "uuid": "cac611d0-0426-445f-afcd-d5a84a00d9a7",
    "hitokoto": "我手中的魔法，是守护挚爱的力量，是坚定这个信念所必须的力量，我一定会拯救你的，无论在何时、何地。",
    "type": "a",
    "from": "魔法少女奈叶",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 48
  },
  {
    "id": 22,
    "uuid": "829dc7e0-0ce8-43f0-9fd1-854c84f0e212",
    "hitokoto": "比任何人都要了解自己，比任何人都要关爱自己。喜欢上这样的人，并没有什么奇怪的呢。",
    "type": "a",
    "from": "初音岛",
    "from_who": null,
    "creator": "xiao2009cn",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 40
  },
  {
    "id": 23,
    "uuid": "3e9dd0cc-09ee-4e63-b124-1f39d2d25a23",
    "hitokoto": "像平常的你一样引发奇迹吧-",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "ludk60",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 13
  },
  {
    "id": 24,
    "uuid": "4e3fdb14-fedb-46de-99a4-68ed0de48ff6",
    "hitokoto": "既不回头，何必不忘；既然无缘，何须誓言；今日种种，似水无痕；明夕何夕，君已陌路。",
    "type": "a",
    "from": "仙剑奇侠传",
    "from_who": null,
    "creator": "赵吟风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 40
  },
  {
    "id": 25,
    "uuid": "91763e77-a127-4670-a5c8-a9b64b8f37e0",
    "hitokoto": "可是就算我们通一千次短信，我们各自的心，大概也只会相互靠近一厘米吧。",
    "type": "a",
    "from": "秒速5厘米",
    "from_who": null,
    "creator": "西泽空",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 34
  },
  {
    "id": 26,
    "uuid": "1ef0d1da-caec-4ac8-9c26-77f746768a9d",
    "hitokoto": "所谓的言语，只有当对方听进去了才开始有意义啊。",
    "type": "a",
    "from": "少年同盟",
    "from_who": null,
    "creator": "alwaysandforever",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 23
  },
  {
    "id": 27,
    "uuid": "8237954d-6628-4f3f-98ae-91ff54ea9f7e",
    "hitokoto": "如果还有来生 ，我无论如何都要来到你身边，我已经没有了其他想要追求的东西，因为没有比你更重要的了。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 49
  },
  {
    "id": 28,
    "uuid": "93b00707-8bb0-4195-8734-56d11f5d055e",
    "hitokoto": "世界上没有一个人能代替另一个人。",
    "type": "a",
    "from": "人型电脑天使心",
    "from_who": null,
    "creator": "夏红莲",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 29,
    "uuid": "e25a1053-e704-4e1b-ac94-f35455137986",
    "hitokoto": "其实，恋爱这种东西，当你看上人家的那一刹那就已经失败了。",
    "type": "a",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "LT2142",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 28
  },
  {
    "id": 31,
    "uuid": "655acf6f-0b90-4284-a288-d197fb2f8a0f",
    "hitokoto": "就是因为你不好，才要留在你身边，给你幸福。",
    "type": "a",
    "from": "哈尔的移动城堡",
    "from_who": null,
    "creator": "空城”旧梦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 32,
    "uuid": "cb7094a4-9d56-4f8e-9ef8-014be3214b77",
    "hitokoto": "微风摇曳着窗帘，夕阳斜射入教室，在那里鼓起勇气告白的少年。即使现在也能清晰地回想起她的声音「当朋友，不行吗？」",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": null,
    "creator": "retaker",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 55
  },
  {
    "id": 33,
    "uuid": "4bbcb914-700e-4d3c-97d9-f8d69ad7bd96",
    "hitokoto": "少罗嗦，你还不如虫子呢！",
    "type": "a",
    "from": "迷糊餐厅",
    "from_who": null,
    "creator": "萌朧意識",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 34,
    "uuid": "5fba6915-a24a-4161-bc64-4913bc06079e",
    "hitokoto": "别人恋爱不成功，你连暗恋都不成功！",
    "type": "a",
    "from": "灌篮高手",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 17
  },
  {
    "id": 35,
    "uuid": "b74864ef-0e60-406b-acd9-303481ae2b03",
    "hitokoto": "就算只有六十亿分之一的机会，我们还是会邂逅。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "灼思",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 22
  },
  {
    "id": 36,
    "uuid": "37520fbc-6e95-4e8e-9ed1-9c73dcf003ad",
    "hitokoto": "魔装少女就是本少爷！",
    "type": "a",
    "from": "这是僵尸吗？",
    "from_who": null,
    "creator": "零之幻想",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 10
  },
  {
    "id": 37,
    "uuid": "b976b183-9404-4968-a60b-e333680c3a91",
    "hitokoto": "无法飞翔的翅膀也是有意义的，因为它是曾经翱翔于天空所留下的珍贵回忆。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "掌中tiger",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 34
  },
  {
    "id": 38,
    "uuid": "c1f4c762-e670-4f3e-8da9-ce93e9438cc8",
    "hitokoto": "勇气，就是即便害怕也会去做。",
    "type": "a",
    "from": "原创",
    "from_who": null,
    "creator": "岛音。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 39,
    "uuid": "75f3383f-b59c-4ce8-a11f-ef07fbf0933f",
    "hitokoto": "如果我不会飞，那我就只是一只普通的猪。",
    "type": "a",
    "from": "红猪",
    "from_who": null,
    "creator": "anythink",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 19
  },
  {
    "id": 40,
    "uuid": "518bdda0-764a-46e4-91ee-12e9613f422b",
    "hitokoto": "要相信同伴，拯救同伴。",
    "type": "a",
    "from": "绯弹的亚里亚",
    "from_who": null,
    "creator": "星野望",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 11
  },
  {
    "id": 42,
    "uuid": "cc752734-613e-4793-8ce2-133995bded8b",
    "hitokoto": "男人许下的诺言就一定要遵守。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "南瓜酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 43,
    "uuid": "b19aef69-c816-47db-9f61-136b3a42f800",
    "hitokoto": "那是，未满45秒的邂逅。",
    "type": "a",
    "from": "EF",
    "from_who": null,
    "creator": "Mion",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 44,
    "uuid": "2056fc13-c2e4-471e-afbe-63e009179f65",
    "hitokoto": "只要有想见面的人，自己就不再是孤单一人。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "夜雨寒",
    "creator_uid": 2638,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 45,
    "uuid": "4d71798f-3c52-4d1b-aa00-be90038f6bbd",
    "hitokoto": "如果聚集负的感情，世界就会陷入负的洪流；反之聚集正的感情，世界就会循着正道而行。",
    "type": "a",
    "from": "钢之炼金术师",
    "from_who": null,
    "creator": "影火虫",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 40
  },
  {
    "id": 46,
    "uuid": "7ade5f7b-a3a6-40af-9121-fbd614ee1617",
    "hitokoto": "廉价的自尊、粗劣的傲气，无论哪个后生小辈都很重视这些东西。",
    "type": "a",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "立花纹",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 29
  },
  {
    "id": 47,
    "uuid": "be86750c-961d-460b-a388-db54e84a4c64",
    "hitokoto": "人不能一个人活下去，不需要任何人的孤独和需要人但得不到的孤独是不一样的。",
    "type": "a",
    "from": "邻座的怪同学",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 36
  },
  {
    "id": 48,
    "uuid": "74298760-a2d5-40d7-872e-c6ed33d7e869",
    "hitokoto": "一个人吃饭，太寂寞了。",
    "type": "a",
    "from": "无头骑士异闻录",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 11
  },
  {
    "id": 49,
    "uuid": "61fa23b3-20bb-4d05-96e7-5329ae79ee59",
    "hitokoto": "欺骗世界，欺骗最初的你。",
    "type": "a",
    "from": "Steins;Gate",
    "from_who": null,
    "creator": "南都夜夜",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 50,
    "uuid": "2c7c30dc-64ff-4f4f-a7db-96b0b7391524",
    "hitokoto": "(」・ω・)」うー！(／・ω・)／にゃー！",
    "type": "a",
    "from": "潜行吧奈亚子",
    "from_who": null,
    "creator": "繋がれた愚者",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 51,
    "uuid": "4a91c264-b984-406d-a0b7-f4543230f566",
    "hitokoto": "世界上没有偶然，有的只是必然。",
    "type": "a",
    "from": "XXXHolic",
    "from_who": null,
    "creator": "279120482",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 15
  },
  {
    "id": 52,
    "uuid": "d13432b7-c963-4c27-86be-26d8e6b2168d",
    "hitokoto": "从小好女色的男人的想像力比不上狗。",
    "type": "a",
    "from": "寒蝉鸣泣之时",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 17
  },
  {
    "id": 53,
    "uuid": "f5cd3ad0-cadb-4d69-8863-cae3f9c62dc7",
    "hitokoto": "你愿意陪我走到地狱的底端吗？",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "icecai123",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 55,
    "uuid": "0742b29c-c8d2-4ba3-b5ce-277a5b07bf39",
    "hitokoto": "和哥哥的便当比起来夜空的薯片就像大便一样！只会给我大便的大便夜空是笨蛋～笨蛋～",
    "type": "a",
    "from": "我的朋友很少",
    "from_who": null,
    "creator": "初语",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 39
  },
  {
    "id": 56,
    "uuid": "69a12c25-31f4-4fea-a196-3dac120253b0",
    "hitokoto": "即使如此，我也有我想保护的世界！",
    "type": "a",
    "from": "高达seed",
    "from_who": null,
    "creator": "幻、天使",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 57,
    "uuid": "675b1acd-4616-44d8-b209-fa58eba7423c",
    "hitokoto": "我很好奇！",
    "type": "a",
    "from": "冰菓",
    "from_who": null,
    "creator": "久野原",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 5
  },
  {
    "id": 58,
    "uuid": "1f327822-7bcb-4fb6-9c5c-b991732196af",
    "hitokoto": "仍是那么熟悉的味道，只是用墓土和骨灰作成的身体，已经不再有体温。",
    "type": "a",
    "from": "犬夜叉",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 32
  },
  {
    "id": 59,
    "uuid": "3c967e49-a7f4-4fca-98e6-f7a40c717650",
    "hitokoto": "我是要成为海贼王的男人！",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 60,
    "uuid": "2efaf6ae-f563-4d33-912a-59a71da0274a",
    "hitokoto": "做不到的话，不过就是一死 。但是，赢了就能活下去，要是不战斗就赢不了。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "吢月",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 35
  },
  {
    "id": 61,
    "uuid": "06707ada-c168-43c6-a728-1b348c2e6598",
    "hitokoto": "忘记本身就是一件不可能的事。",
    "type": "a",
    "from": "我们的存在",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 62,
    "uuid": "ae378708-b121-4434-8a04-4209f487615a",
    "hitokoto": "我们的夏天仍未结束。",
    "type": "a",
    "from": "王牌投手",
    "from_who": null,
    "creator": "新月",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 10
  },
  {
    "id": 63,
    "uuid": "19d576ea-b602-43a1-ae78-72341c5770d9",
    "hitokoto": "雨，何时停？",
    "type": "a",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "LT2142",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 6
  },
  {
    "id": 64,
    "uuid": "6d0c9f38-ec2c-4ce9-9c74-6f92c172ece5",
    "hitokoto": "在走廊上跌倒会流鼻血，在人生中跌倒会流眼泪。",
    "type": "a",
    "from": "龙虎斗",
    "from_who": null,
    "creator": "雪白封印",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 22
  },
  {
    "id": 65,
    "uuid": "34d77457-a762-415b-8c33-0dd8a177f65c",
    "hitokoto": "有被杀的觉悟，才有资格开枪。",
    "type": "a",
    "from": "反叛的鲁路修",
    "from_who": null,
    "creator": "SweatHeart",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 66,
    "uuid": "a11fa441-7869-4172-b919-8fb2938e6b17",
    "hitokoto": "已经无法回到过去了。也不知道将来会是什么模样。",
    "type": "a",
    "from": "文学少女",
    "from_who": null,
    "creator": "万至阳",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 23
  },
  {
    "id": 67,
    "uuid": "5bc511f9-df6a-4705-b40d-880a015eacde",
    "hitokoto": "不要哀求，学会争取；若是如此，终有所获。",
    "type": "a",
    "from": "交响诗篇",
    "from_who": null,
    "creator": "空色の风琴",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 68,
    "uuid": "64d0aab9-5fe4-4534-8055-452d64530fa6",
    "hitokoto": "リア充死ね！",
    "type": "a",
    "from": "我的朋友很少",
    "from_who": null,
    "creator": "ryo",
    "creator_uid": 1482,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 6
  },
  {
    "id": 69,
    "uuid": "62853b17-cb51-4fc5-baf6-811c97469b45",
    "hitokoto": "拿着刀并且可以让人们变得幸福的只有料理人。",
    "type": "a",
    "from": "假面骑士kabuto",
    "from_who": null,
    "creator": "アリス",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 70,
    "uuid": "b2db9423-448f-4e03-9d40-759490239028",
    "hitokoto": "我会跟她结婚，并不是因为她是计算机，而是因为她就是她。同样的，我会喜欢你，也是因为你就是你。",
    "type": "a",
    "from": "人型电脑天使心",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 46
  },
  {
    "id": 71,
    "uuid": "fffc59c6-f5d4-482d-9c2f-7dc5a330209b",
    "hitokoto": "越是试着忘记，越是记得深刻。",
    "type": "a",
    "from": "天空之城",
    "from_who": null,
    "creator": "anythink",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 72,
    "uuid": "ad0639fb-d48c-49df-be24-a5d41dfa241c",
    "hitokoto": "喜欢上你，爱上你，真是太好了，谢谢。",
    "type": "a",
    "from": "龙虎斗",
    "from_who": null,
    "creator": "xiaozhusirs",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 18
  },
  {
    "id": 73,
    "uuid": "51b25849-1e38-4d8a-a44c-dd6687afcaeb",
    "hitokoto": "我对普通的人类没有兴趣，你们只要是有外星人、未来人、异世界人、超能力者， 就尽管来找我吧！以上！",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "xdcr2507",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 48
  },
  {
    "id": 74,
    "uuid": "5f2b9801-cb51-4618-9901-dc1a1dbb9b1f",
    "hitokoto": "既然如此，就再努力一次吧。别在这里愁眉不展，也不要再自欺欺人，重新来过！",
    "type": "a",
    "from": "某科学的超电磁炮",
    "from_who": null,
    "creator": "№1‰の薇恩",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 36
  },
  {
    "id": 75,
    "uuid": "f9ac75d1-85b3-44b6-bf35-d93cf60f40c7",
    "hitokoto": "若隐若现才是艺术！",
    "type": "a",
    "from": "问题儿童来自异世界",
    "from_who": null,
    "creator": "言叶",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 9
  },
  {
    "id": 76,
    "uuid": "f6c46ab8-602c-4fe8-ab8c-e6306605c3ed",
    "hitokoto": "我想要握紧的并不是匕首或是什么，只不过是他的掌心而已。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "万事屋神乐酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 27
  },
  {
    "id": 77,
    "uuid": "9ba7fda0-1912-4d67-8d49-331893b81ac3",
    "hitokoto": "下一次重逢，将是何年何月？天空必将见证。",
    "type": "a",
    "from": "SOLA",
    "from_who": null,
    "creator": "掌中tiger",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 78,
    "uuid": "3e3995d7-2c4a-4104-8744-76031d252d25",
    "hitokoto": "就连一直都无容身之地的我……也不是可以任意舍弃的生命。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 27
  },
  {
    "id": 79,
    "uuid": "f6aa4116-5a0f-4ab0-807a-bf3838a5fd23",
    "hitokoto": "所以，他们的祭典还没结束。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "阿布碳。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 13
  },
  {
    "id": 80,
    "uuid": "64723500-dd8b-4d66-abd0-b12f4ec94e30",
    "hitokoto": "比自己，比梦想更重要的东西永远都存在着...",
    "type": "a",
    "from": "钢之炼金术师",
    "from_who": null,
    "creator": "hccs",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 22
  },
  {
    "id": 81,
    "uuid": "65b8a4a9-b2f9-427a-9fd1-91b92da5faab",
    "hitokoto": "选择道路的时候怎么犹豫都没有关系，但决定之后就一定要坚持到底！",
    "type": "a",
    "from": "青之驱魔师",
    "from_who": null,
    "creator": "..控、",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 31
  },
  {
    "id": 82,
    "uuid": "2ed6c1f4-8b58-498a-aac6-fadf41bcd5d6",
    "hitokoto": "煩い！煩い！煩い！",
    "type": "a",
    "from": "灼眼的夏娜",
    "from_who": null,
    "creator": "yeyifangg",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 9
  },
  {
    "id": 83,
    "uuid": "bc57394d-172d-453b-a96f-00fce7b53d5e",
    "hitokoto": "重要的是无论我们选择哪条路，都要担负起选择的责任。",
    "type": "a",
    "from": "蜂蜜与四叶草",
    "from_who": null,
    "creator": "funkyholic",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 25
  },
  {
    "id": 84,
    "uuid": "43a0bbc2-3b94-48bb-9c7f-76a8a84b1f0f",
    "hitokoto": "因为无法再见面，所以要笑着说再见。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 17
  },
  {
    "id": 85,
    "uuid": "ad660068-57eb-4c10-9c95-c067107829f2",
    "hitokoto": "无论乌云有多浓厚，星星也一定还在，只是暂时看不到了而已。",
    "type": "a",
    "from": "电波女与青春男",
    "from_who": null,
    "creator": "电波吧L君",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 28
  },
  {
    "id": 86,
    "uuid": "e48c683b-a2e5-4cfd-9b73-4ae76ca9155b",
    "hitokoto": "如果我拥有如同小狗一样的尾巴的话，肯定会高兴得遮掩不住地摇来摇去吧。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Akechi",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 34
  },
  {
    "id": 87,
    "uuid": "ec41e81f-97d9-4505-83b4-0a3503a4fa26",
    "hitokoto": "在我年轻的时候，不知道什么是恐惧，可偏偏是你的温柔，让我害怕。",
    "type": "a",
    "from": "东京爱情故事",
    "from_who": null,
    "creator": "garlicbetty",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 31
  },
  {
    "id": 88,
    "uuid": "a682339d-b791-4e9f-b8d9-e0cdb964122a",
    "hitokoto": "你不会死的，因为我会保护你.",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "绤谷少年。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 14
  },
  {
    "id": 89,
    "uuid": "bfec6bf7-9435-4ef5-90f2-0bebfa4a46be",
    "hitokoto": "只是相谈就会开心起来，沉浸在温柔的眼神当中，竭尽全力的思念，悄悄地奉献。",
    "type": "a",
    "from": "School Days",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 36
  },
  {
    "id": 90,
    "uuid": "9fb82343-bf15-4f4f-8908-b817759615aa",
    "hitokoto": "我们虽然距离很远很远，非常非常的远，但是思念或许真的可以穿越时间和距离。",
    "type": "a",
    "from": "星之声",
    "from_who": null,
    "creator": "仰望最初",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 36
  },
  {
    "id": 91,
    "uuid": "a9898ff7-ffe0-4d91-86fe-8894fecf331a",
    "hitokoto": "梦想是否无聊并不是别人来决定的，不管是什么样的梦想，自己拼命努力去追寻才是最重要的。",
    "type": "a",
    "from": "守护甜心",
    "from_who": null,
    "creator": "默默然",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 42
  },
  {
    "id": 92,
    "uuid": "79b0ca81-d5ef-4825-b4d6-64dd2dac6345",
    "hitokoto": "胜而不灭，霸而不辱，这才是真正的征服。",
    "type": "a",
    "from": "fate zero",
    "from_who": null,
    "creator": "以风之名",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 19
  },
  {
    "id": 93,
    "uuid": "7f8f2c32-22c0-4fb3-91e0-eb0cf4a5100a",
    "hitokoto": "我相信十年后的八月，我们还能再相遇。",
    "type": "a",
    "from": "secret base ～君がくれたもの～",
    "from_who": null,
    "creator": "ツ绯/D誓言↙",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 18
  },
  {
    "id": 94,
    "uuid": "c6a6e894-1c98-4f36-b241-5076b6d124ba",
    "hitokoto": "相信十年后的八月，我们还会相遇。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 95,
    "uuid": "fcae356a-9ac1-477a-b523-3d528bb3beea",
    "hitokoto": "你的心可以属于耶稣，但你的屁股永远属于陆战队！",
    "type": "a",
    "from": "魔法少女陆战队",
    "from_who": null,
    "creator": "jordan2004a",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 23
  },
  {
    "id": 96,
    "uuid": "f34514e0-2ed2-4d6e-bfca-c6cb29d9e2aa",
    "hitokoto": "看到的感受到的永远都不会消失永远都不会忘记，与各种各样的相遇一同永存。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 35
  },
  {
    "id": 97,
    "uuid": "4fee5af0-2e54-496c-9399-75cc0cbe70d1",
    "hitokoto": "我们走过风走过雨，就是没能走进彼此的内心。",
    "type": "a",
    "from": "自分",
    "from_who": null,
    "creator": "漠伦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 98,
    "uuid": "a8808f16-1688-44df-9841-102ce9775f8d",
    "hitokoto": "烦恼这东西，是只有活着的人，才有的特权哦。",
    "type": "a",
    "from": "我们的存在",
    "from_who": null,
    "creator": "伊达樱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 99,
    "uuid": "155654de-02dd-48fb-b39b-ca016cdf3934",
    "hitokoto": "当朋友是不需要什么资格的。",
    "type": "a",
    "from": "全职猎人",
    "from_who": null,
    "creator": "绤谷少年。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 13
  },
  {
    "id": 100,
    "uuid": "3ad880e4-995e-4972-aa78-ceb0369ed1dc",
    "hitokoto": "年华无多时，恋爱吧男子！",
    "type": "a",
    "from": "源君物语",
    "from_who": null,
    "creator": "当希望破灭时__",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 12
  },
  {
    "id": 101,
    "uuid": "b213f024-fcff-4a7d-b57b-4fdb4fc23b77",
    "hitokoto": "求你，保护那孩子，消除灾厄，抹除祸事。哪怕⋯⋯那是我自己……",
    "type": "a",
    "from": "食灵",
    "from_who": null,
    "creator": "游啊游の猪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 30
  },
  {
    "id": 102,
    "uuid": "4eaa7e07-0004-425b-9c5c-95bd4a417e3f",
    "hitokoto": "如果你不能击败你的敌人，那么就加入他们。",
    "type": "a",
    "from": "加菲猫",
    "from_who": null,
    "creator": "xi4oh4o",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 20
  },
  {
    "id": 103,
    "uuid": "e6bfeab1-f0aa-4916-ae81-c69375885c0e",
    "hitokoto": "我们都在命运之湖上荡舟划桨，波浪起伏着而我们无法逃脱孤航。但是假使我们迷失了方向，波浪将指引我们穿越另一天的曙光。",
    "type": "a",
    "from": "死神",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 57
  },
  {
    "id": 104,
    "uuid": "10b2e013-ff7b-4934-9979-ffdc3e847886",
    "hitokoto": "我们所过的每个平凡的日常，也许就是连续发生的奇迹。",
    "type": "a",
    "from": "日常",
    "from_who": null,
    "creator": "桜花幻影",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 25
  },
  {
    "id": 105,
    "uuid": "574091b0-1dd7-437c-9a92-d897973d6118",
    "hitokoto": "最近困扰我的是小小的分别，总会带来一丝寂寞。短暂的相遇和分别那一分一秒的时间都让我想要无比珍惜。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 48
  },
  {
    "id": 106,
    "uuid": "54bc6f77-2f80-4209-8f44-292d07533bc3",
    "hitokoto": "倘若只是为了驱赶心中的寂寞，找谁都可以的。",
    "type": "a",
    "from": "秒速5厘米",
    "from_who": null,
    "creator": "ggdog",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 21
  },
  {
    "id": 107,
    "uuid": "00ae6650-3ae8-401f-927b-651a39564fb6",
    "hitokoto": "即使从梦中醒来，还会有回忆留下。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 16
  },
  {
    "id": 108,
    "uuid": "5248f4e5-6e01-4750-9685-525951a68d94",
    "hitokoto": "能够原谅女人的，才是男人。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "798750776",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 13
  },
  {
    "id": 109,
    "uuid": "4ef69bfc-11b6-4541-bfa2-d800e47e3a47",
    "hitokoto": "我会继续等着你，就算是一万二千年。",
    "type": "a",
    "from": "创圣的大天使EVOL",
    "from_who": null,
    "creator": "19920214",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 17
  },
  {
    "id": 110,
    "uuid": "d51a8655-f299-4f56-9f43-8c1f8891d83f",
    "hitokoto": "不管看到什么样的过去，都请不要迷失自己，不管你变成什么样子，我都是你的同伴。",
    "type": "a",
    "from": "angel beats",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 38
  },
  {
    "id": 111,
    "uuid": "08f25fd6-d7e0-4a19-a0e6-98c89ceca1b6",
    "hitokoto": "悲伤教会了我喜悦。",
    "type": "a",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "LT2142",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 9
  },
  {
    "id": 112,
    "uuid": "cdd89906-d679-4ba7-b848-f5540f552078",
    "hitokoto": "我到底要以怎么样的速度生活才能与你再次相遇？",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "跳舞的果果",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605909",
    "length": 22
  },
  {
    "id": 113,
    "uuid": "d0e49a51-476b-4586-a4de-b88f99bb61ed",
    "hitokoto": "我的船上没有手下，只有伙伴。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "明雪嫣",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 14
  },
  {
    "id": 114,
    "uuid": "36235319-d821-49fe-ac5a-7d2048939e31",
    "hitokoto": "就是因为抱有不现实的理想，所以才总是做出如此极端的事情！",
    "type": "a",
    "from": "逆袭的夏亚",
    "from_who": null,
    "creator": "言靈",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 28
  },
  {
    "id": 115,
    "uuid": "69eec9df-5096-4b83-b9b7-51fc41267592",
    "hitokoto": "要是因为烦恼很痛苦，就选择了轻松的选项，将来一定会后悔。",
    "type": "a",
    "from": "樱花庄的宠物女孩",
    "from_who": null,
    "creator": "青熊兽真烦人",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 28
  },
  {
    "id": 116,
    "uuid": "f9865621-6f35-4be2-a7d0-5b869fcaedc2",
    "hitokoto": "呐，知道么，樱花飘落的速度，是每秒五厘米哦~",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "烤飞鱼的土豆",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 22
  },
  {
    "id": 117,
    "uuid": "9432be2c-cbb4-4d38-8a26-06cdd542f72d",
    "hitokoto": "知道活着的痛苦处的人就能对人温柔，这和软弱是不一样的。",
    "type": "a",
    "from": "eva",
    "from_who": null,
    "creator": "林志广",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 27
  },
  {
    "id": 118,
    "uuid": "8ada268b-6e37-47f7-9216-53dd8d84b864",
    "hitokoto": "比起悲伤来说，无法分享快乐这件事，要更加的寂寞吧。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "林志广",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 25
  },
  {
    "id": 119,
    "uuid": "a9463f29-790d-42c5-8832-1691eef1ab74",
    "hitokoto": "如果你执意追寻着我的幻影，总有一天会被真正的我打败。",
    "type": "a",
    "from": "棋魂",
    "from_who": null,
    "creator": "炎羽",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 26
  },
  {
    "id": 120,
    "uuid": "e4fec659-6092-4395-8dcb-2885bf20a524",
    "hitokoto": "乔巴，一个男人，有时候是不能逃避战斗的，尤其是当伙伴的梦想被人嘲笑的时候。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "灰之言",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 37
  },
  {
    "id": 121,
    "uuid": "9b834943-8908-40c8-9557-086496eac2cc",
    "hitokoto": "你的那双手呢，是为了紧紧抓住什么而存在的哦。",
    "type": "a",
    "from": "仰望半月的夜空",
    "from_who": null,
    "creator": "shijiongyuan",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 22
  },
  {
    "id": 122,
    "uuid": "59e823b9-718d-4017-9311-c79255d9c9dc",
    "hitokoto": "去死两次！",
    "type": "a",
    "from": "迷途猫",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 5
  },
  {
    "id": 123,
    "uuid": "b5ea47f4-a332-410f-97d4-5609452f93dc",
    "hitokoto": "世界は恋に落ちている。",
    "type": "a",
    "from": "青春之旅OP（我的世界已坠入爱河）",
    "from_who": null,
    "creator": "咖啡少年不加糖",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 11
  },
  {
    "id": 124,
    "uuid": "29819f1c-c51d-4d8c-8c91-45069434356f",
    "hitokoto": "自身不先改变的话，一切都不会改变。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "misora",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 17
  },
  {
    "id": 125,
    "uuid": "83ff15e3-9a1f-443c-baca-f6d42e56289f",
    "hitokoto": "就算是对我抱有敌意的人，也是被某个人深爱着而降生在这个世界上的。",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "红叶乘风我愿",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 32
  },
  {
    "id": 126,
    "uuid": "346880cc-a317-4e2a-af37-cef2bb634910",
    "hitokoto": "人生最糟糕的事，一个是饿肚子，一个是孤独。",
    "type": "a",
    "from": "夏日大作战",
    "from_who": null,
    "creator": "空城”旧梦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 21
  },
  {
    "id": 127,
    "uuid": "9d09511a-4bb5-4351-bb29-32e57494e3c4",
    "hitokoto": "我不是萝莉控，是妹控啊！",
    "type": "a",
    "from": "我的妹妹不可能那么可爱第二季",
    "from_who": null,
    "creator": "梁钲恒",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 12
  },
  {
    "id": 128,
    "uuid": "bf8cd453-e6f9-4dc4-af2f-24b60f74f29a",
    "hitokoto": "呐，我们好像是，被宇宙和地球拆散的恋人似的。",
    "type": "a",
    "from": "星之声",
    "from_who": null,
    "creator": "yeyifangg",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 22
  },
  {
    "id": 129,
    "uuid": "86e6245a-2559-4dda-8602-d4c2b3b1d8f0",
    "hitokoto": "一天吐槽太多次的话，梗也是会用完的。",
    "type": "a",
    "from": "我的脑内恋爱选项",
    "from_who": null,
    "creator": "hsk",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 18
  },
  {
    "id": 130,
    "uuid": "8055016c-813e-41f2-bb85-18cdf3cca6e8",
    "hitokoto": "自己的感觉，不说出来，别人也不会懂，如果不懂，就应该互相沟通。",
    "type": "a",
    "from": "好想告诉你",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 31
  },
  {
    "id": 131,
    "uuid": "0e7926fc-f73f-44b8-ad09-0430a8f47764",
    "hitokoto": "心，可是很重的。",
    "type": "a",
    "from": "哈尔的移动城堡",
    "from_who": null,
    "creator": "fujiyta",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 8
  },
  {
    "id": 132,
    "uuid": "3edea0b7-6f21-46a9-b33f-6ff2b8c86f29",
    "hitokoto": "不能逃避，不能逃避，不能逃避，不能逃避……",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "憾天之泪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 21
  },
  {
    "id": 133,
    "uuid": "5687dea3-b91a-43d6-a1ed-ce7c15304ac3",
    "hitokoto": "以盐水作配菜，糖水做主食，就有种奢侈的感觉呢。",
    "type": "a",
    "from": "笨蛋测验召唤兽",
    "from_who": null,
    "creator": "伊织刹那",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 23
  },
  {
    "id": 134,
    "uuid": "2268c328-52c5-45ad-801c-26b66b088dcb",
    "hitokoto": "就算鼻血流尽，也不能放弃妄想。",
    "type": "a",
    "from": "摇曳百合",
    "from_who": null,
    "creator": "守护那份情",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 15
  },
  {
    "id": 135,
    "uuid": "5db7fbfe-d3e1-4cb0-91c8-522ea6ec0211",
    "hitokoto": "爱，其实很简单，困难的是去接受它。",
    "type": "a",
    "from": "通灵王",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 17
  },
  {
    "id": 136,
    "uuid": "1c886cf4-a9b2-482f-a98f-d1302f00feb6",
    "hitokoto": "我们不应该根据背负的罪孽来选择道路，而应在选择的道路上背负自己的罪孽。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 35
  },
  {
    "id": 137,
    "uuid": "5a86516b-f4d8-4c7b-9f09-e0a33d496241",
    "hitokoto": "只要微笑就可以了。",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "卍谷",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 9
  },
  {
    "id": 138,
    "uuid": "99c0b766-0c8b-4328-adb4-4e421252a20b",
    "hitokoto": "因为我喜欢你，喜欢得想吃掉你啊！",
    "type": "a",
    "from": "有顶天家族",
    "from_who": null,
    "creator": "丶Jan",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 16
  },
  {
    "id": 139,
    "uuid": "4fde13a2-ae6f-4993-b3a8-cdc648a4e882",
    "hitokoto": "求求你，不要对我这么温柔！",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "被流放de蟹子",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 13
  },
  {
    "id": 140,
    "uuid": "7296d484-34a8-4b57-a282-81d864844fee",
    "hitokoto": "我觉得你很幸福，因为你可以选择爱我或不爱我，而我只能选择爱你或更爱你。",
    "type": "a",
    "from": "School Days",
    "from_who": null,
    "creator": "天與地的巡禮",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 35
  },
  {
    "id": 141,
    "uuid": "34eeb213-1713-4c42-8eee-8297f94ecd30",
    "hitokoto": "失去的东西虽然拿不回来，但是，忘记的事情是可以想起来的。",
    "type": "a",
    "from": "TOUCH",
    "from_who": null,
    "creator": "星野月瞳",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 28
  },
  {
    "id": 142,
    "uuid": "c9129283-a479-4537-bd94-ba7a4fea8998",
    "hitokoto": "你还是这么冷漠啊。不过，仅此而已的话，我是不会泄气的。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 27
  },
  {
    "id": 143,
    "uuid": "11090ff9-387a-4460-ae0d-6667e007a410",
    "hitokoto": "我能够允许你逃避过去，不过至少从现在或者明天开始都不要再逃避。",
    "type": "a",
    "from": "无头骑士异闻录",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 31
  },
  {
    "id": 144,
    "uuid": "afc77440-3696-4425-b236-6e9db32ca6c5",
    "hitokoto": "正因为听不见和看不到，所以风子才会做这样的事情。",
    "type": "a",
    "from": "clannad",
    "from_who": null,
    "creator": "悠光喵~~",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 24
  },
  {
    "id": 145,
    "uuid": "466905b6-fa34-4642-9e11-2c315634949a",
    "hitokoto": "什么都无所谓只想在你身边，什么都无所谓只想和你说话，什么都无所谓所以请你不要逃避。",
    "type": "a",
    "from": "好想告诉你",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 41
  },
  {
    "id": 146,
    "uuid": "f76d6796-6f7c-4b01-96c6-a81eebe30110",
    "hitokoto": "我并不羡慕别人的人生，这就是所谓幸福。",
    "type": "a",
    "from": "幸运星",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 19
  },
  {
    "id": 147,
    "uuid": "0b892e71-b083-4bfd-89bb-26a3ae25af15",
    "hitokoto": "人能够在心里郁积那么多的事情，而他们又会忘记那么多的事情，真是不可思议……",
    "type": "a",
    "from": "最终幻想",
    "from_who": null,
    "creator": "域水结界",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 37
  },
  {
    "id": 148,
    "uuid": "485efc22-0184-4ded-90ac-bc6586b31cda",
    "hitokoto": "我要拼，装上假牙也要拼！",
    "type": "a",
    "from": "灌篮高手",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 12
  },
  {
    "id": 149,
    "uuid": "5aec3ff8-403a-4ce6-a3eb-c67ee69c5f90",
    "hitokoto": "人一生会遇到约2920万人，两个人相爱的概率是0.000049。所以你不爱我，我不怪你。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "青熊兽真烦人",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 44
  },
  {
    "id": 150,
    "uuid": "0c881eaf-11ef-4fc5-b1ad-75865804d330",
    "hitokoto": "我的内心就和厕纸一样单纯！",
    "type": "a",
    "from": "Little Busters!",
    "from_who": null,
    "creator": "科迪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 13
  },
  {
    "id": 151,
    "uuid": "59d30aa6-4970-4b7e-b3ec-9d781ba559f0",
    "hitokoto": "我的眼睛，就是为了寻找你而存在的。",
    "type": "a",
    "from": "H2O",
    "from_who": null,
    "creator": "雾雨魔里纱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 17
  },
  {
    "id": 152,
    "uuid": "799143a2-77a5-4bd1-9f4e-23a01b705b1f",
    "hitokoto": "烈焰中舞动的火花，将赐予邪恶异性交往以天罚。",
    "type": "a",
    "from": "潜行吧！奈亚子W",
    "from_who": null,
    "creator": "1272146309@qq.com",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 22
  },
  {
    "id": 153,
    "uuid": "1b17b850-0364-4954-9e7b-17eec0dc3af6",
    "hitokoto": "All for one，one for all.",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "青熊兽真烦人",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 24
  },
  {
    "id": 154,
    "uuid": "4cfdcc00-61cb-4ccf-9824-ea591110734d",
    "hitokoto": "老是低着头，幸福可是会离你而去的喔。",
    "type": "a",
    "from": "我们的仙境",
    "from_who": null,
    "creator": "南风之弦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 18
  },
  {
    "id": 155,
    "uuid": "4d06f251-f55d-48da-81c3-e815be4a3f8c",
    "hitokoto": "羁绊是那不可切断的深切联系。即使分离，心与心也紧紧的连在一起。",
    "type": "a",
    "from": "假面骑士kabuto",
    "from_who": null,
    "creator": "アリス",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 31
  },
  {
    "id": 156,
    "uuid": "407e95b4-8bd1-4978-a47b-28ddd916c51a",
    "hitokoto": "对不起，风太大，我没有听清楚……",
    "type": "a",
    "from": "东京巴比伦",
    "from_who": null,
    "creator": "水幻之音",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 16
  },
  {
    "id": 157,
    "uuid": "6b02f3a6-42d2-4c6c-b772-1aa2bc2606c9",
    "hitokoto": "你知道雪为什么是白色的吗？因为她忘记了本来的颜色。",
    "type": "a",
    "from": "反叛的鲁路修",
    "from_who": null,
    "creator": "掌中tiger",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 25
  },
  {
    "id": 158,
    "uuid": "f0078a23-56d4-4232-984b-acc0b97e3360",
    "hitokoto": "人生在世何其痛苦，所以咖啡至少该甜一点。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "以风之名",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 20
  },
  {
    "id": 159,
    "uuid": "45bc9a3e-cd9e-4f8c-a8d4-fae3080f2502",
    "hitokoto": "我想让自己强大起来，因为至少我已经有幸和想要保护的人相遇了。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 30
  },
  {
    "id": 160,
    "uuid": "1acec84b-2944-43cd-9dd6-2473285f2308",
    "hitokoto": "我只是做了我能做的事，没有时间想将来。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 19
  },
  {
    "id": 161,
    "uuid": "c1fe6172-b25e-4e79-87c1-7c01c9bd670f",
    "hitokoto": "一天最大任务莫过于，好好睡觉，好好醒来。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 20
  },
  {
    "id": 162,
    "uuid": "e477a25e-12b2-4788-9ec9-f33877ce6a82",
    "hitokoto": "不相信人咬不到肚脐的，咬破肚脐去死如何？",
    "type": "a",
    "from": "海猫鸣泣之时",
    "from_who": null,
    "creator": "凌小雅",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 20
  },
  {
    "id": 163,
    "uuid": "b680e319-6f08-487b-ae78-3ddbd1ecbf34",
    "hitokoto": "一直保持微笑是有诀窍的，那就是，在想哭的时候放声大哭。",
    "type": "a",
    "from": "天使领域",
    "from_who": null,
    "creator": "夏未安",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 27
  },
  {
    "id": 164,
    "uuid": "5c6b553e-5e85-472a-982a-ca6c35a67c5e",
    "hitokoto": "女人的武器不是眼泪，而是微笑。",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 15
  },
  {
    "id": 165,
    "uuid": "9832d39e-f9a5-45e8-ba98-0805b236127f",
    "hitokoto": "十步做一死，千里不留行，事了拂衣去，深藏功与名~",
    "type": "a",
    "from": "侠客行",
    "from_who": null,
    "creator": "Lozye",
    "creator_uid": 71,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 24
  },
  {
    "id": 166,
    "uuid": "5fd37704-7380-4028-82f5-9207038c6863",
    "hitokoto": "只要有你，我便无所不能。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "饼干",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 12
  },
  {
    "id": 167,
    "uuid": "6bde2850-5773-47ac-80e0-a72f6dbe0dd4",
    "hitokoto": "不相信自己的人，连努力的价值都没有。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "泠树",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 18
  },
  {
    "id": 168,
    "uuid": "3f994ed8-6313-4fb3-8976-452cf2720989",
    "hitokoto": "我只对现实世界绝望过，却未对自己绝望过！",
    "type": "a",
    "from": "只有神知道的世界",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 20
  },
  {
    "id": 169,
    "uuid": "2d61ff18-3e41-4690-b0da-84bcd16eaa9f",
    "hitokoto": "虚伪的眼泪，会伤害别人，虚伪的笑容，会伤害自己。",
    "type": "a",
    "from": "反叛的鲁鲁修",
    "from_who": null,
    "creator": "雪丶风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605910",
    "length": 24
  },
  {
    "id": 170,
    "uuid": "860a9ac2-d106-46d0-8e43-1988874cf97a",
    "hitokoto": "我除了投三分，就什么都没有了……",
    "type": "a",
    "from": "灌篮高手",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 16
  },
  {
    "id": 171,
    "uuid": "a6443692-34bc-45e6-b80b-c6d1ef27fd40",
    "hitokoto": "(눈_눈)",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 5
  },
  {
    "id": 172,
    "uuid": "603ca9d1-bc8c-44bf-bd53-655b2ce2ec9a",
    "hitokoto": "我在人生的道路上迷失了。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 12
  },
  {
    "id": 173,
    "uuid": "fa848266-746c-459f-b73f-389edb883ce3",
    "hitokoto": "历史虽然会一再重演，但人类却无法回到过去。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 21
  },
  {
    "id": 174,
    "uuid": "1bb792fc-c2e4-49e0-9493-ae907831312f",
    "hitokoto": "观察铅笔和橡皮，哪个是攻哪个是受，请写出它们晚上的对话。",
    "type": "a",
    "from": "学生会的一己之见",
    "from_who": null,
    "creator": "牧瀨、紅莉棲",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 28
  },
  {
    "id": 175,
    "uuid": "9c3f4ddc-1117-4885-ae7d-156cbc0d7e48",
    "hitokoto": "龙儿是我的，谁都不准碰！",
    "type": "a",
    "from": "龙虎斗",
    "from_who": null,
    "creator": "游啊游の猪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 12
  },
  {
    "id": 176,
    "uuid": "2c36daad-4e0a-453e-9fc8-1cf9829a27b9",
    "hitokoto": "贫乳是社会地位的象征。是具有稀有价值的！",
    "type": "a",
    "from": "幸运星",
    "from_who": null,
    "creator": "无限通行",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 20
  },
  {
    "id": 177,
    "uuid": "8492e105-9b7b-4a93-8eee-829524bad008",
    "hitokoto": "想要试着去相互接近，但最后还是无法敞开心扉，结果就是擦肩而过……",
    "type": "a",
    "from": "文学少女",
    "from_who": null,
    "creator": "芽衣洛",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 32
  },
  {
    "id": 178,
    "uuid": "f4652819-98d0-4e82-bd9a-5dc130c70741",
    "hitokoto": "扎古不论怎么化妆都不可能变成高达的。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "アルム",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 18
  },
  {
    "id": 179,
    "uuid": "d9459346-fceb-4639-b6ac-e52478e1450a",
    "hitokoto": "我在未来等你。",
    "type": "a",
    "from": "穿越时空的少女",
    "from_who": null,
    "creator": "库腐腐",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 7
  },
  {
    "id": 180,
    "uuid": "da7ddca1-c46b-403a-ae2b-9424ea697b26",
    "hitokoto": "一般来说，时间会把悲伤冲淡，可是在人的生命中，会有那么一两个特殊的存在，他们的逝去，你永远也不会习惯。",
    "type": "a",
    "from": "冥王神话",
    "from_who": null,
    "creator": "立花纹",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 51
  },
  {
    "id": 181,
    "uuid": "f7653cf2-74d5-435c-8a98-585dc5817220",
    "hitokoto": "懂得认输是非常重要的，不尝到失败的不甘，也就不会明白跌倒后怎么爬起来，更不可能再向前迈进。",
    "type": "a",
    "from": "笨蛋测验召唤兽",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 45
  },
  {
    "id": 182,
    "uuid": "984c59d0-0f74-4ce7-b9dd-2ecfb39dd490",
    "hitokoto": "要改变别人的心真是件很难办的事，不过改变自己要容易一点。",
    "type": "a",
    "from": "XXXHolic",
    "from_who": null,
    "creator": "E聋魍魉",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 28
  },
  {
    "id": 183,
    "uuid": "c634dd17-a6a5-4f45-88f0-5df0b49e0a0a",
    "hitokoto": "我喜欢你们！超喜欢的！大家和我交往吧！绝对会让你们幸福的！",
    "type": "a",
    "from": "学生会的一己之见",
    "from_who": null,
    "creator": "yeyifangg",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 29
  },
  {
    "id": 184,
    "uuid": "ca4b6d34-3235-4004-a591-5299a29b900b",
    "hitokoto": "美丽的不是这个世界，而是看世界的你的眼神。",
    "type": "a",
    "from": "吸血鬼骑士",
    "from_who": null,
    "creator": "燿燿",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 21
  },
  {
    "id": 185,
    "uuid": "e37566b4-89dd-47f1-900d-364020f7217d",
    "hitokoto": "世界这么大，人生这么长，总会有那么一个人，让你想要温柔的对待。",
    "type": "a",
    "from": "哈尔的移动城堡",
    "from_who": null,
    "creator": "anythink",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 31
  },
  {
    "id": 186,
    "uuid": "dc348c10-2bed-4a82-9eb1-40d4e4c4b2a6",
    "hitokoto": "成功率不到2%，那剩下的用勇气来补足吧！",
    "type": "a",
    "from": "勇者王",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 20
  },
  {
    "id": 187,
    "uuid": "64e35bd0-fa2b-4cbc-a089-e8caa36406cd",
    "hitokoto": "我一直都在你身边 ，一直都在。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "Samurai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 15
  },
  {
    "id": 188,
    "uuid": "3ccd0da4-3ca0-4253-b9d3-7001e18d7077",
    "hitokoto": "重要的不是你做了多少事，而是你放了多少心思进去。",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 24
  },
  {
    "id": 190,
    "uuid": "7b7503b4-8132-4893-8ad8-8e012afed8d2",
    "hitokoto": "哭泣并不能改变任何事情。",
    "type": "a",
    "from": "推理之绊",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 12
  },
  {
    "id": 191,
    "uuid": "f25e9a31-1ab2-4eaf-bd79-4734e472e2d6",
    "hitokoto": "代表月亮消灭你！",
    "type": "a",
    "from": "美少女战士",
    "from_who": null,
    "creator": "edvda",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 8
  },
  {
    "id": 192,
    "uuid": "002a54c7-424b-4630-9e4c-12ba8304ea9b",
    "hitokoto": "不要，我现在暂时留在他身边，直到那转瞬即逝的日子到来。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 27
  },
  {
    "id": 193,
    "uuid": "6ca872a0-cf3e-493a-9654-4093f178f703",
    "hitokoto": "就算是自私……我也希望那些人能够永远都有笑容……",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 24
  },
  {
    "id": 194,
    "uuid": "78eb210e-890e-4fa2-b0a8-102e9f2f75bb",
    "hitokoto": "我们开始一起攀登，这长长的，长长的坡道。",
    "type": "a",
    "from": "Clannad",
    "from_who": null,
    "creator": "被流放de蟹子",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 20
  },
  {
    "id": 195,
    "uuid": "4eb05d13-ec09-4882-b797-768935dd6b17",
    "hitokoto": "应该可以了吧，我已经很努力了，应该可以抵达终点了……",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "绤谷少年。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 26
  },
  {
    "id": 196,
    "uuid": "01d6ed0c-214b-41ee-aa90-7b61eb124de3",
    "hitokoto": "离别并不痛苦，因为我们都微笑着。",
    "type": "a",
    "from": "青之驱魔师",
    "from_who": null,
    "creator": "腹黑小兔",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 16
  },
  {
    "id": 197,
    "uuid": "7c69a3ac-27ac-4309-b125-c97d4c5f3421",
    "hitokoto": "只要能努力，就应当去努力；只要还能前进，就要向前走去。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605911",
    "length": 27
  },
  {
    "id": 198,
    "uuid": "a4d44263-63e1-456d-ae96-6bd5df99c1d4",
    "hitokoto": "邂逅本身，就是一种奇迹啊。",
    "type": "a",
    "from": "游魂",
    "from_who": null,
    "creator": "以风之名",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 13
  },
  {
    "id": 199,
    "uuid": "c4823238-b3c0-425e-924b-f6fb93fbbe4d",
    "hitokoto": "与其被自己的本性牵着走而痛苦，倒不如试着改变自己。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 25
  },
  {
    "id": 200,
    "uuid": "424a3fbc-abf9-4000-a554-57be0c8858b1",
    "hitokoto": "爱迪生说过：“要把BOSS打倒就要准备足够的等级。”",
    "type": "a",
    "from": "学生会的一己之见",
    "from_who": null,
    "creator": "牧瀨、紅莉棲",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 26
  },
  {
    "id": 201,
    "uuid": "2525c25f-300c-41c2-8ddf-fffcbecb4801",
    "hitokoto": "世界并不完美，却因此而美丽。",
    "type": "a",
    "from": "奇诺之旅",
    "from_who": null,
    "creator": "suicideXD",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 14
  },
  {
    "id": 202,
    "uuid": "f42afe74-9b1e-46a8-a4f2-7b02ff9d49b5",
    "hitokoto": "我们的心就像那天空一样，永不分离。",
    "type": "a",
    "from": "缘之空",
    "from_who": null,
    "creator": "佰千莫",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 17
  },
  {
    "id": 203,
    "uuid": "d0636115-0ee8-4f34-90f8-78f221aba423",
    "hitokoto": "和我定下契约，成为魔法少女吧！",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "泠血·黑月",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 15
  },
  {
    "id": 204,
    "uuid": "6abf1dbb-d3aa-4da3-91d4-bc0c3e085b2d",
    "hitokoto": "一直注视着你，似近似远，总是触碰不到。",
    "type": "a",
    "from": "来自风平浪静的明天",
    "from_who": null,
    "creator": "Dadicatus545",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 19
  },
  {
    "id": 205,
    "uuid": "8fa3b4ad-aec0-463f-a993-27fb8be370c4",
    "hitokoto": "我知道的，面码……自己已经死掉这点事，还是知道的……",
    "type": "a",
    "from": "我们仍未知道那天所看见的花的名字",
    "from_who": null,
    "creator": "迷途羊",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 26
  },
  {
    "id": 206,
    "uuid": "e67ba51a-7685-490e-b79c-16f89b538fc3",
    "hitokoto": "共道人间惆怅事，不知今夕是何年。",
    "type": "a",
    "from": "周秦行纪",
    "from_who": null,
    "creator": "wuxiaodeid",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 16
  },
  {
    "id": 207,
    "uuid": "0254c91c-6b7d-4e80-b4ea-ba2dcd863e7e",
    "hitokoto": "旅行唯有出发前最愉快，狗儿唯有叫声最吓人，女人唯有背影最美丽。",
    "type": "a",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "立花纹",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 31
  },
  {
    "id": 208,
    "uuid": "530a0e32-7132-451e-a014-71c884eb654e",
    "hitokoto": "无论你在哪里，就算我看不见你，我也会一直注视着你。",
    "type": "a",
    "from": "妖精的尾巴",
    "from_who": null,
    "creator": "龙猫龙猫龙猫你好傻",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 25
  },
  {
    "id": 209,
    "uuid": "30042146-31a4-4b5e-920a-caba417afae4",
    "hitokoto": "我不渴望什么在别的城市迎来的春天，只要和你在一起的春天就好，只要和你在一起就好",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 39
  },
  {
    "id": 210,
    "uuid": "28e0fd0a-bb30-4e5b-a0f3-5cf0460ff96e",
    "hitokoto": "我的愿望是—幸福地活着，幸福地死去。",
    "type": "a",
    "from": "神不在的星期天",
    "from_who": null,
    "creator": "19920214",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 18
  },
  {
    "id": 211,
    "uuid": "09c56d12-cf30-406d-ad59-1418cd65e7fb",
    "hitokoto": "今天你最后遇见的那个人有在微笑吗？",
    "type": "a",
    "from": "幸运星",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 17
  },
  {
    "id": 212,
    "uuid": "7c0d5739-75c7-4884-8c12-e7a5c66d4708",
    "hitokoto": "我的终点，与幸福同在。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "掌中tiger",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 11
  },
  {
    "id": 214,
    "uuid": "90d75885-6474-4560-8240-90f7e2831593",
    "hitokoto": "我问你：你是我的Master吗？",
    "type": "a",
    "from": "命运守护夜",
    "from_who": null,
    "creator": "跳舞的果果",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 16
  },
  {
    "id": 215,
    "uuid": "b83e013f-167f-4e09-918e-32ce6b82273b",
    "hitokoto": "私だって今日こそ... 遠野くんに告白するんだ。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605912",
    "length": 24
  },
  {
    "id": 216,
    "uuid": "0af4c848-52b5-4127-bf8c-d4316aaf2174",
    "hitokoto": "时间并不存在，存在的只有此刻。",
    "type": "a",
    "from": "魔女猎人",
    "from_who": null,
    "creator": "绝聊",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 15
  },
  {
    "id": 217,
    "uuid": "e8c1ec6c-e58a-4690-a439-7b5434d7a50a",
    "hitokoto": "没有期盼就不会出现奇迹。",
    "type": "a",
    "from": "古城荆棘王",
    "from_who": null,
    "creator": "M崽",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 12
  },
  {
    "id": 218,
    "uuid": "010a8d98-0c69-485d-adcd-dfffd5016b70",
    "hitokoto": "受尽苦难而不厌，此乃阿修罗之道。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "q84751202",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 16
  },
  {
    "id": 219,
    "uuid": "d3970e47-5d2a-4a9c-9885-06ce5c7dfdbf",
    "hitokoto": "如果你都不知道自己想去哪里，那去哪里都是一样的。",
    "type": "a",
    "from": "柴郡猫",
    "from_who": null,
    "creator": "Oxalis",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 24
  },
  {
    "id": 220,
    "uuid": "4c8cb094-dc7b-4893-92b9-3e518680f960",
    "hitokoto": "明天，不是你想要就能有的。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "なつめ たかし",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 13
  },
  {
    "id": 221,
    "uuid": "fdaebee4-7d16-47ba-a48a-167a11803421",
    "hitokoto": "明明只是活着，哀伤却无处不在……",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Rewrite",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 16
  },
  {
    "id": 222,
    "uuid": "c00075a8-9a10-4f5c-bd25-ec7798836074",
    "hitokoto": "错误可不是为了别人才改的过来的，要为了自己才能改正。",
    "type": "a",
    "from": "XXXHolic",
    "from_who": null,
    "creator": "神之翼者",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 26
  },
  {
    "id": 223,
    "uuid": "4450354b-56bb-43bb-93e1-e5b68b0e59ee",
    "hitokoto": "男人从小的时候就是无药可救的。",
    "type": "a",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "LT2142",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 15
  },
  {
    "id": 224,
    "uuid": "3327cb40-8fc4-4405-a399-a7b29f13fc54",
    "hitokoto": "如果我是那雨滴的话，那么，我能够像把不曾交汇的天空与大地连接起来那样，把某人的心串联起来吗？",
    "type": "a",
    "from": "死神",
    "from_who": null,
    "creator": "毒药toxic",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 46
  },
  {
    "id": 225,
    "uuid": "60ddf7a4-46c9-44be-bb42-49511ce63979",
    "hitokoto": "真可悲，你什么都不知道，在这个世界上没有什么是不重要的！",
    "type": "a",
    "from": "最终幻想",
    "from_who": null,
    "creator": "qslzlancer",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 28
  },
  {
    "id": 226,
    "uuid": "08655808-43a4-435c-9c79-3512f09b4953",
    "hitokoto": "前天是小兔子，昨天是小鹿，今天是你。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "和你说88",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 18
  },
  {
    "id": 227,
    "uuid": "6aba3393-ea28-49f8-b919-2e1a7c25e9a2",
    "hitokoto": "用我的左手将你那个不可理喻的幻想粉碎掉！",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "akirayc",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605913",
    "length": 20
  },
  {
    "id": 228,
    "uuid": "74df6753-7c81-4f04-98d1-04eaae5fbbcc",
    "hitokoto": "堕入黑暗裏的可怜影子啊，停止伤害他人的行为吧，犯下罪行的灵魂……想死一次么？",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "游啊游の猪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 38
  },
  {
    "id": 229,
    "uuid": "b3620d38-115d-49ad-82ab-406e1c862c96",
    "hitokoto": "男人变态有什么错！",
    "type": "a",
    "from": "寒蝉鸣泣之时",
    "from_who": null,
    "creator": "哀音",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 9
  },
  {
    "id": 230,
    "uuid": "4549fe7e-a0cd-4ee0-8ff5-bfe842e5da71",
    "hitokoto": "人们只是用好人来称呼对自己有用的人而以，不存在对所有人都有用的人。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "占星术杀人魔法",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 33
  },
  {
    "id": 231,
    "uuid": "b002e92d-8530-40d3-8bb0-ae89109bf4ef",
    "hitokoto": "真正的危机不是机器人像人一样思考，而是人像机器一样思考。",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 28
  },
  {
    "id": 232,
    "uuid": "4679351f-e2fd-4018-9bdc-7335908ed416",
    "hitokoto": "人は一生、中二病なんだ。",
    "type": "a",
    "from": "中二病也要谈恋爱",
    "from_who": null,
    "creator": "tabrithzmh",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 12
  },
  {
    "id": 233,
    "uuid": "a7b061c2-472e-4a46-b5b7-f8d35e21ec51",
    "hitokoto": "能够轻易就放弃的梦想，有存在的价值么？",
    "type": "a",
    "from": "守护甜心",
    "from_who": null,
    "creator": "亂紅蓮",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 19
  },
  {
    "id": 234,
    "uuid": "3fca03d8-90c5-4ee2-b75f-d0581ff02c6b",
    "hitokoto": "没有谁能够永远坚强下去的，每个人都会有疲累的无法站起的时候。世间的故事，就是为了这一刻而存在的哦。",
    "type": "a",
    "from": "文学少女",
    "from_who": null,
    "creator": "酱七",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 49
  },
  {
    "id": 235,
    "uuid": "32949069-3efe-4de2-950f-5f3c9443882c",
    "hitokoto": "只要你在，我便无所不能。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "570964968",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605914",
    "length": 12
  },
  {
    "id": 236,
    "uuid": "c8d086a5-5cb1-4bf0-95aa-b53cdd7c9264",
    "hitokoto": "24岁的阿升你好，我是15岁的美加子，我现在也还是非常、非常的喜欢阿升哦！",
    "type": "a",
    "from": "星之声",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605915",
    "length": 37
  },
  {
    "id": 237,
    "uuid": "d54dc596-e3db-4996-886b-e3bf38659575",
    "hitokoto": "比希望更炙热，比绝望更深邃，这就是爱啊。",
    "type": "a",
    "from": "魔法少女小圆-叛逆的物语",
    "from_who": null,
    "creator": "chaucerling",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605915",
    "length": 20
  },
  {
    "id": 238,
    "uuid": "232eb5a1-ff6a-4329-b7b8-f4f60b3fd5d0",
    "hitokoto": "如果你愿意的话，让我带您去吧，这座小镇，愿望实现的地方……",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "沙茶酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605915",
    "length": 29
  },
  {
    "id": 239,
    "uuid": "c6e24fbe-824d-4046-83d0-819047a5bd64",
    "hitokoto": "窃人者，自失其宝。",
    "type": "a",
    "from": "假面骑士kabuto",
    "from_who": null,
    "creator": "アリス",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605916",
    "length": 9
  },
  {
    "id": 240,
    "uuid": "a3fe28ee-7509-46d2-8168-015918a81909",
    "hitokoto": "有你在的日子才是我的日常。",
    "type": "a",
    "from": "琴浦小姐",
    "from_who": null,
    "creator": "红叶乘风我愿",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605916",
    "length": 13
  },
  {
    "id": 241,
    "uuid": "7eb3bf73-f940-474c-b862-4dfc5041b582",
    "hitokoto": "男人就应该保持冷静，沸腾的水只会被蒸发掉。",
    "type": "a",
    "from": "假面骑士kabuto",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605916",
    "length": 21
  },
  {
    "id": 242,
    "uuid": "f798e0d0-273a-45c9-bf5a-b93c6093224e",
    "hitokoto": "嗯，一个人也要加油，我是坚强的孩子。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "cloverxue",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605916",
    "length": 18
  },
  {
    "id": 243,
    "uuid": "aa7c61e1-907b-425a-9de6-cdb6b3dd7563",
    "hitokoto": "时间带着明显的恶意，缓缓在我的头顶流逝。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605917",
    "length": 20
  },
  {
    "id": 244,
    "uuid": "1d75d441-898a-4ae1-91b8-c73a7d52f91b",
    "hitokoto": "人的记忆本来就是暧昧的，不值得信任。",
    "type": "a",
    "from": "叛逆的鲁鲁修R2",
    "from_who": null,
    "creator": "奇迹之梦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605917",
    "length": 18
  },
  {
    "id": 245,
    "uuid": "b5709917-4395-4779-8498-7e9b316d7cb1",
    "hitokoto": "有光的地方必有影，有影的地方也必定有光，绝望的颜色越是浓重，一定会有光芒耀眼的希望。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605918",
    "length": 42
  },
  {
    "id": 246,
    "uuid": "6a0eedba-4597-41c7-a226-7a7effbd5a72",
    "hitokoto": "时间可以治愈？如果时间也病了怎么办？",
    "type": "a",
    "from": "寒蝉鸣泣之时",
    "from_who": null,
    "creator": "“萌”字~好~",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605918",
    "length": 18
  },
  {
    "id": 247,
    "uuid": "d8a135a2-065a-4043-86f7-ae7796939a9c",
    "hitokoto": "无论在哪里遇到你，我都会喜欢上你。",
    "type": "a",
    "from": "AngleBeats!",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605919",
    "length": 17
  },
  {
    "id": 248,
    "uuid": "b5f75769-1ce2-4c2a-8da2-74cc5dc5b3fe",
    "hitokoto": "取少量学生放入试管，加入过量作业，生成学霸溶液和不溶于水的学渣。过滤，在学渣中加入过量浓试卷，学渣迅速溶解且产生气泡，学霸则无明显现象。",
    "type": "a",
    "from": "网络",
    "from_who": null,
    "creator": "luguoo",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605919",
    "length": 68
  },
  {
    "id": 249,
    "uuid": "fc593314-7e08-4b25-8984-ea7444736387",
    "hitokoto": "如果你死了，那什么也改变不了，可如果你还活着，那就能改变一些事情。",
    "type": "a",
    "from": "最游记",
    "from_who": null,
    "creator": "雪丶风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605920",
    "length": 33
  },
  {
    "id": 251,
    "uuid": "71d60b43-9386-4e9a-8027-64934754c5f5",
    "hitokoto": "鲁鲁修，你知道雪花为什么是白色的吗？因为已经忘记自己本来是什么颜色啊。",
    "type": "a",
    "from": "叛逆的鲁鲁修",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605920",
    "length": 35
  },
  {
    "id": 252,
    "uuid": "ccd34656-4a72-4e6a-ad7c-5c6d9117f367",
    "hitokoto": "燃烧吧，我的小宇宙！",
    "type": "a",
    "from": "圣斗士星矢",
    "from_who": null,
    "creator": "跳舞的果果",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605921",
    "length": 10
  },
  {
    "id": 253,
    "uuid": "b49825ee-2fd3-4a3b-ac61-3c2f0c3431d0",
    "hitokoto": "无法逃避的是自我，而无法挽回的是过去。",
    "type": "a",
    "from": "机动战士高达",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605921",
    "length": 19
  },
  {
    "id": 254,
    "uuid": "13c5cf0b-6305-4eec-b19a-e7fd0c8e743b",
    "hitokoto": "做出一副温柔的样子来折磨人不是更令人难受吗？",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "alwaysandforever",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605923",
    "length": 22
  },
  {
    "id": 255,
    "uuid": "454e939f-525c-49c9-bd24-5c04c8eded90",
    "hitokoto": "有些事情我不看透，不是我笨，只是我太善良。",
    "type": "a",
    "from": "樱桃小丸子",
    "from_who": null,
    "creator": "岛音。",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605924",
    "length": 21
  },
  {
    "id": 256,
    "uuid": "05120ffd-1adf-46dc-b0ba-5265d9f698d8",
    "hitokoto": "有时语言就像把利刃，使用不当，就会成为凶器。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": null,
    "creator": "D.C.",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605925",
    "length": 22
  },
  {
    "id": 257,
    "uuid": "776dc426-7fce-45e7-8f97-9dc9ccaf892d",
    "hitokoto": "如果能够重生的话，我想，我想成为水母。想成为只是在海里自由地摇摇摆摆的水母。",
    "type": "a",
    "from": "海月姬",
    "from_who": null,
    "creator": "羽叔",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605926",
    "length": 38
  },
  {
    "id": 258,
    "uuid": "3cb0d0e0-0330-4001-8ddc-0d611089bc88",
    "hitokoto": "所谓的人类，可是连短短的十分钟也等不起的。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "林志广",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605929",
    "length": 21
  },
  {
    "id": 260,
    "uuid": "c3e5fa24-1b33-4532-8ac0-2bcba75e2080",
    "hitokoto": "梦总是有会醒来的时候，不会醒的梦总有一天会变成悲伤。",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "林志广",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605932",
    "length": 26
  },
  {
    "id": 261,
    "uuid": "73c4c400-243b-4369-9675-1bc93a1eb12c",
    "hitokoto": "能哭的地方只有厕所和爸爸的怀里。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "jik1203",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605934",
    "length": 16
  },
  {
    "id": 262,
    "uuid": "e6fa8f0a-73dd-4193-82b7-8a5e1b1c9341",
    "hitokoto": "你再怎么称赞我，我也不会高兴的，你这个混蛋~",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "雪丶风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605936",
    "length": 22
  },
  {
    "id": 263,
    "uuid": "855a3caa-7f98-472b-8139-602575ac7134",
    "hitokoto": "除了爱你，我什么都可以。",
    "type": "a",
    "from": "命运守护夜",
    "from_who": null,
    "creator": "南风之弦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605946",
    "length": 12
  },
  {
    "id": 264,
    "uuid": "fe383828-434d-47b1-b8ff-6f6cf5fda6b5",
    "hitokoto": "败者死于绝望，胜者死于渴望。",
    "type": "a",
    "from": "戏言系列",
    "from_who": null,
    "creator": "哀川润",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605966",
    "length": 14
  },
  {
    "id": 265,
    "uuid": "ccf09eae-383a-4580-be0e-3bd800205767",
    "hitokoto": "给，一辈子朋友劵。",
    "type": "a",
    "from": "日常",
    "from_who": null,
    "creator": "单数",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605973",
    "length": 9
  },
  {
    "id": 266,
    "uuid": "fc978e48-1982-4d45-b21a-94da73586449",
    "hitokoto": "一个人走在路上，形单影只。回首望去，大家都留在远方。回过头来继续前行，这便是所谓坚强。",
    "type": "a",
    "from": "AngelBeats",
    "from_who": null,
    "creator": "Vocamelloid",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468605991",
    "length": 43
  },
  {
    "id": 267,
    "uuid": "0699776f-064c-49a6-83d9-17de85075fe1",
    "hitokoto": "无知而又纯洁的岁月是任何人都曾拥有的，世界上没有一成不变的事物，所以只要以其他方式找到自己的快乐就行了。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "尚昱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606002",
    "length": 52
  },
  {
    "id": 268,
    "uuid": "82ae2f30-5792-4c34-9ff0-54bf7b8dcb60",
    "hitokoto": "沒有永远下不停的雨。",
    "type": "a",
    "from": "秋之回憶",
    "from_who": null,
    "creator": "akirayc",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606003",
    "length": 10
  },
  {
    "id": 269,
    "uuid": "85140537-08ad-4049-9f80-cc51ebbec570",
    "hitokoto": "不习惯的事越来越多，但我仍在前进……就算步伐很小，我也在一步一步的前进。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606007",
    "length": 36
  },
  {
    "id": 270,
    "uuid": "9bfca6ab-d413-4c08-b114-b5d8f319daf8",
    "hitokoto": "算了，和你说话感觉就像是大姨妈来了。",
    "type": "a",
    "from": "龙虎斗",
    "from_who": null,
    "creator": "33",
    "creator_uid": 4429,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606073",
    "length": 18
  },
  {
    "id": 271,
    "uuid": "10d5b57c-cd23-4e4d-9de4-4e097ca65a27",
    "hitokoto": "“像你这样的白痴是怎么活过来的？”“因为我很自信。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "陈亚",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606080",
    "length": 25
  },
  {
    "id": 272,
    "uuid": "9b32b99b-cfd3-46a7-8d93-777a999e9d24",
    "hitokoto": "梦想是什么，梦想是现实的延续；现实是什么，现实是梦想的终结。",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "kigoo",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606153",
    "length": 30
  },
  {
    "id": 273,
    "uuid": "68b0294f-2188-4c1c-9293-a88ebe13f005",
    "hitokoto": "Time waits for no one.",
    "type": "a",
    "from": "穿越时空的少女",
    "from_who": null,
    "creator": "沙茶酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606219",
    "length": 22
  },
  {
    "id": 274,
    "uuid": "cd6bcf8f-5634-47f7-9108-bd6ee646b188",
    "hitokoto": "时间是伟大的作家，总会写下完美的结局。",
    "type": "a",
    "from": "秋之回忆",
    "from_who": null,
    "creator": "LT2142",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468606332",
    "length": 19
  },
  {
    "id": 278,
    "uuid": "05f32468-ae30-490d-852f-f64b915afb7e",
    "hitokoto": "真正让我难受的，大概是因为让你看到如此狼狈的自己。",
    "type": "a",
    "from": "元气少女缘结神",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949092",
    "length": 25
  },
  {
    "id": 488,
    "uuid": "a849ac47-6317-4459-b256-6f755f30857c",
    "hitokoto": "淅淅沥沥的雨，即便能填满路上的水坑，也填不满心中的空洞。",
    "type": "a",
    "from": "神圣之门",
    "from_who": null,
    "creator": "freejishu",
    "creator_uid": 1,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1471870312",
    "length": 28
  },
  {
    "id": 490,
    "uuid": "958238ca-d2b9-4ea5-9790-26fd0852e5ac",
    "hitokoto": "我们总是在注意错过太多，却不注意自己拥有多少。",
    "type": "a",
    "from": "我们仍未知道那天所看见的花的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1471875152",
    "length": 23
  },
  {
    "id": 512,
    "uuid": "ecf48e0e-f69e-43c9-9096-c313c8fa0b22",
    "hitokoto": "不管前方的路有多苦，只要走的方向正确，不管多么崎岖不平，都比站在原地更接近幸福。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543268",
    "length": 40
  },
  {
    "id": 513,
    "uuid": "585416af-b6f9-4018-8348-e7528f2f811e",
    "hitokoto": "活在现实中的人是错的，而那些哭泣的人才是正确的，孤独的我们才有人类的样子",
    "type": "a",
    "from": "angel beats",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543167",
    "length": 36
  },
  {
    "id": 514,
    "uuid": "a22f67bb-b6eb-4e4a-8866-8335357428ef",
    "hitokoto": "不管是怎样的回忆，都是我们活过的人生。",
    "type": "a",
    "from": "angel beats",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543149",
    "length": 19
  },
  {
    "id": 515,
    "uuid": "87bb095d-0849-46cf-9810-08c2773bd539",
    "hitokoto": "我不知道离别的滋味是这样凄凉，我不知道说声再见要这么坚强。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543282",
    "length": 29
  },
  {
    "id": 516,
    "uuid": "080358a9-c125-4471-8129-c8fe444363c2",
    "hitokoto": "人生就是一列开往坟墓的列车，路途上会有很多站，很难有人可以自始至终陪着走完。当陪你的人要下车时，即使不舍也该心存感激，然后挥手道别。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543249",
    "length": 66
  },
  {
    "id": 517,
    "uuid": "84f357c9-473a-438b-bffd-95b1d5ce5f2c",
    "hitokoto": "曾经发生过的事情不可能忘记，只不过是想不起而已。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472543299",
    "length": 24
  },
  {
    "id": 518,
    "uuid": "6dc36d1d-64ea-429b-93c0-040a4019c56c",
    "hitokoto": "人永远不知道，谁哪次不经意的跟你说了再见之后，就真的不会再见了。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472544607",
    "length": 32
  },
  {
    "id": 519,
    "uuid": "2f1a6540-f9c5-4862-ba2f-0710701e2895",
    "hitokoto": "有阳光的地方就会有阴影，所以有阴影的地方也一定会有阳光。绝望的颜色越是浓厚，在哪里也一定会存在耀眼的希望之光。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550342",
    "length": 55
  },
  {
    "id": 520,
    "uuid": "3cd9eb46-cb20-471d-92d0-f754a965c7c9",
    "hitokoto": "与其想着怎么美丽地牺牲,倒不如想着怎么漂亮地活到最后一刻。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550398",
    "length": 29
  },
  {
    "id": 521,
    "uuid": "21bfd9da-f461-4f07-91be-2bbd0c468176",
    "hitokoto": "人就是要以自卑为跳板才能跳得更高。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550433",
    "length": 17
  },
  {
    "id": 522,
    "uuid": "d7c0d898-ceaa-480b-9d10-fc4833135c2a",
    "hitokoto": "为了终止绝望的连锁，希望她能化为照亮正确道路的灯火。",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550070",
    "length": 26
  },
  {
    "id": 523,
    "uuid": "db0a436d-a724-4ae8-ab5b-f190ba21dd6f",
    "hitokoto": "死亡只要在人生的终点尝试一次就够了~",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550150",
    "length": 18
  },
  {
    "id": 524,
    "uuid": "eb282e35-409b-4f7f-971b-c7f226eff54c",
    "hitokoto": "真正重要的东西，总是没有的人比拥有的人清楚。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550195",
    "length": 22
  },
  {
    "id": 525,
    "uuid": "0699b216-ef8f-43bf-b777-b1d5d89976b1",
    "hitokoto": "吾于冥河沉浮,受尽命运捉弄，纵然汝将忘吾，吾亦伴汝身旁。",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550287",
    "length": 28
  },
  {
    "id": 526,
    "uuid": "ec2668e8-1f0e-43c8-a300-6b967bf385d9",
    "hitokoto": "关于自己的生活，我和你都不是读者，而是作者。至少结局，还是能自己说了算的。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550314",
    "length": 37
  },
  {
    "id": 527,
    "uuid": "105ebbf8-1a79-4431-8e1b-bca012c35e9f",
    "hitokoto": "努力可是要默默藏起来的。",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551065",
    "length": 12
  },
  {
    "id": 528,
    "uuid": "e2b61c2f-88e1-409d-86d7-51ce606a0a3f",
    "hitokoto": "拥有和舍弃都很痛苦，既然无论怎样都会痛苦的话，我宁可选择守护它而痛苦。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550499",
    "length": 35
  },
  {
    "id": 529,
    "uuid": "656a3a83-0867-459b-90ea-9e05044010db",
    "hitokoto": "只要有你想要保护的东西，那就拔剑好了。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550533",
    "length": 19
  },
  {
    "id": 531,
    "uuid": "b04cdba9-cc80-4ddf-bc86-7b0b8cf35bd9",
    "hitokoto": "所谓的王，乃最贪婪，最豪爽，最易怒之人。且清且浊，追求极致人生。为臣者，因之而仰慕，追随其左右。因此，臣民才会有称王之志，追寻自己的理想。",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472550972",
    "length": 69
  },
  {
    "id": 532,
    "uuid": "aad933ed-65de-4d4b-b64b-631211b1ebec",
    "hitokoto": "不过傲慢分为两种。一种是能力过于低下，还有一种是志向异常远大的。前者显得非常愚蠢，后者是难得一见的珍贵种类。",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551003",
    "length": 54
  },
  {
    "id": 533,
    "uuid": "cc282b85-eefb-4760-9456-32711ad29cb6",
    "hitokoto": "梦存高远，志在争霸，这股热情确实值得赞许。但所谓梦，终有一天是要醒来的。",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551139",
    "length": 36
  },
  {
    "id": 534,
    "uuid": "767899d6-651d-4ef6-87c7-376828ae6846",
    "hitokoto": "“把剑放下，成为本王的妻子吧。”",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551170",
    "length": 16
  },
  {
    "id": 535,
    "uuid": "9bf10314-a2b9-435d-b59f-01763359a38a",
    "hitokoto": "区区一只趴在地上的蝼蚁，谁允许你抬起头的， 虫子就要有虫子的样子，低头伏地然后去死。",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551203",
    "length": 42
  },
  {
    "id": 536,
    "uuid": "ba8a069b-27db-466f-ae87-12583c683444",
    "hitokoto": "即使你忘记了我，我也不会遗忘你。",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551243",
    "length": 16
  },
  {
    "id": 537,
    "uuid": "1ba597d6-7333-42c6-81d1-c36ceede8c64",
    "hitokoto": "不是别人，是我，承认了你的价值。",
    "type": "a",
    "from": "fate/zero",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551373",
    "length": 16
  },
  {
    "id": 538,
    "uuid": "c26a7169-c637-4cb7-b5e5-0cb76f8beee3",
    "hitokoto": "世界上 ，没有一拳解决不了的事，如果有，那就两拳。",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551393",
    "length": 25
  },
  {
    "id": 539,
    "uuid": "d7f78cf7-7939-49a4-ad12-b45313fd5bc1",
    "hitokoto": "明天的事，交给明天的我。",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551437",
    "length": 12
  },
  {
    "id": 540,
    "uuid": "7e365e02-18f0-451d-b359-b8a9f52b6a4f",
    "hitokoto": "在灾难面前，如果连英雄都逃跑了，那还有谁能站出来？",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551464",
    "length": 25
  },
  {
    "id": 541,
    "uuid": "b67dbbc9-5aaa-4a6f-a941-6eb100262aaf",
    "hitokoto": "我不是因为需要你们评论几句才去当英雄的，而是因为我想去当所以我才当的。",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551491",
    "length": 35
  },
  {
    "id": 542,
    "uuid": "896f5044-4b09-4323-9c0f-9cb38fa855d5",
    "hitokoto": "由变态化身成为变态，也就是真·变态，也就是说，完全变态呢。",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551518",
    "length": 29
  },
  {
    "id": 543,
    "uuid": "aa285cfa-7477-4daa-ae06-6cd1e8d01b7a",
    "hitokoto": "我秃了，我也变强了",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472551554",
    "length": 9
  },
  {
    "id": 544,
    "uuid": "5a884057-6821-401f-9866-48885795e4e3",
    "hitokoto": "为了做一名真正的绅士，即使明知必输无疑，也要有勇气接受挑战！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472552395",
    "length": 30
  },
  {
    "id": 545,
    "uuid": "fc6573c2-3e95-4b94-9e20-139b581ddd0b",
    "hitokoto": "JOJO，我不想再做人了！！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472552471",
    "length": 14
  },
  {
    "id": 546,
    "uuid": "9f262a3f-b90a-450d-aee1-61a2c1058d4c",
    "hitokoto": "春天是胖次的季节。",
    "type": "a",
    "from": "电器街漫画店",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472553274",
    "length": 9
  },
  {
    "id": 547,
    "uuid": "4d64e855-f522-471a-847e-1199205927c7",
    "hitokoto": "我只是个兴趣使然的英雄。",
    "type": "a",
    "from": "一拳超人",
    "from_who": null,
    "creator": "没了",
    "creator_uid": 12,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472553078",
    "length": 12
  },
  {
    "id": 550,
    "uuid": "2edd9fb9-92f5-4310-8e12-eca5f1c161dd",
    "hitokoto": "不要为自己的努力道歉，这样太对不起自己了！",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472977678",
    "length": 21
  },
  {
    "id": 553,
    "uuid": "cffac50e-7a43-45c7-9aaf-6b18e78efd07",
    "hitokoto": "这个世界上没有奇迹，有的只是偶然和必然，以及是谁在做些什么。一直期望着能出现奇迹的人们是不会发生奇迹",
    "type": "a",
    "from": "悠久之翼",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472977332",
    "length": 50
  },
  {
    "id": 554,
    "uuid": "eb3ac928-87c0-429b-82b1-96b738849220",
    "hitokoto": "伤害别人的人，就要有被伤害的觉悟！",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978151",
    "length": 17
  },
  {
    "id": 555,
    "uuid": "8e83bf2a-b539-496f-a7a2-ebf3ccfbfb42",
    "hitokoto": "即使你忘记我，我也不会遗忘你！",
    "type": "a",
    "from": "从零开始的异世界生活",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978279",
    "length": 15
  },
  {
    "id": 556,
    "uuid": "c484eb2d-0110-46cd-a3f3-f6e89fd05384",
    "hitokoto": "我不管这个世上的人怎么说我，我只想依照我的信念做事，绝不后悔，不管现在将来都一样。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978028",
    "length": 41
  },
  {
    "id": 557,
    "uuid": "66faec6a-59a1-4493-a7d8-b9bfddb42024",
    "hitokoto": "人生中有些事你不竭尽所能去做，你永远不知道自己有多出色！",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978097",
    "length": 28
  },
  {
    "id": 558,
    "uuid": "93e9bcce-253f-4fe7-b300-0aaabfef5d5f",
    "hitokoto": "正因为生命有限，所以才显得重要，正因为生命有限，所以才更应该努力不懈！",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978465",
    "length": 35
  },
  {
    "id": 559,
    "uuid": "14d100e6-bec2-41bc-a121-63de13171496",
    "hitokoto": "人，只有在放弃战斗的时候才算输，只要坚持战斗，就还没输！",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978607",
    "length": 28
  },
  {
    "id": 560,
    "uuid": "e0f70ab5-c128-4b99-b202-c7978ace3a26",
    "hitokoto": "世间本就没有真实的对与错，也没有绝对的善与恶。地狱天堂，一念之间。",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472979527",
    "length": 33
  },
  {
    "id": 561,
    "uuid": "24d5204f-a8d7-47c4-af0e-e672a10ca1a4",
    "hitokoto": "天才的字典里，没有不可能这三个字。",
    "type": "a",
    "from": "灌篮高手",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472979457",
    "length": 17
  },
  {
    "id": 562,
    "uuid": "1c5d60b0-cd1b-4145-82a6-971b7ddfc531",
    "hitokoto": "奇迹不是免费的，如果你祈求了希望，也会散播出同等的绝望。",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472979605",
    "length": 28
  },
  {
    "id": 563,
    "uuid": "1fb5e373-d600-437b-ba12-61f0b0bc191b",
    "hitokoto": "此生无悔入东方，来世愿生幻想乡！",
    "type": "a",
    "from": "东方project",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978957",
    "length": 16
  },
  {
    "id": 564,
    "uuid": "601d5f7a-8693-4d76-900a-5ff671a85b84",
    "hitokoto": "只要是活着的东西，就算是神我也会杀给你看。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472979300",
    "length": 21
  },
  {
    "id": 565,
    "uuid": "fc796714-6ab6-4e2e-9f49-ec4fc58a77b0",
    "hitokoto": "我手里拿着刀，没法抱你，我放下刀，没法保护你！",
    "type": "a",
    "from": "死神",
    "from_who": null,
    "creator": "贝贝",
    "creator_uid": 22,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472978727",
    "length": 23
  },
  {
    "id": 566,
    "uuid": "baf4f47d-409a-4365-8bb0-1bcced30f8be",
    "hitokoto": "不好意思，我喜欢的是艾米莉亚",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "Queen",
    "creator_uid": 15,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1472993068",
    "length": 14
  },
  {
    "id": 567,
    "uuid": "c5dbc76b-5d03-4bfa-b150-d38c7fcfae21",
    "hitokoto": "前进吧，星星在你的头上闪耀哦！",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562414",
    "length": 15
  },
  {
    "id": 577,
    "uuid": "46b9ae4e-63dc-48c0-997c-4d558c1f7548",
    "hitokoto": "星星只有在夜里才璀璨夺目啊。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562126",
    "length": 14
  },
  {
    "id": 578,
    "uuid": "e2f504b6-791b-44b7-94c9-b3c6fec8d319",
    "hitokoto": "Eloim Essaim Eloim Essaim 请聆听我的请求。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473561915",
    "length": 34
  },
  {
    "id": 590,
    "uuid": "502e600f-90f0-448d-a74a-03a20982fb55",
    "hitokoto": "於此漆黑世界之中，直至光明遍地之时！All Hail Lelouch！",
    "type": "a",
    "from": "反叛的鲁路修",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473508346",
    "length": 35
  },
  {
    "id": 595,
    "uuid": "5bf79da7-eb5c-4dcc-ad73-cb602d946fd4",
    "hitokoto": "只有用心才能看到本质，最重要的东西眼睛是无法看到的。",
    "type": "a",
    "from": "LE",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473560619",
    "length": 26
  },
  {
    "id": 596,
    "uuid": "3d651084-e661-4af5-bb59-37892288edb9",
    "hitokoto": "春天的最后一场雪，你我的最后一次相聚，能遇见你是最幸福的事了，就此分别吧！请继续向前，迎接樱花漫溢的四月，但请不要忘记我，友人A……",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473561869",
    "length": 66
  },
  {
    "id": 597,
    "uuid": "6889b429-4529-4820-ba03-8a26a57ad7d3",
    "hitokoto": "喜欢的人喜欢别人不是很正常吗。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473561830",
    "length": 15
  },
  {
    "id": 598,
    "uuid": "98c9705b-ab76-4576-8773-599559fa0eef",
    "hitokoto": "男人只要去行动就好，做得到或做不到，女孩子会来告诉你的。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562026",
    "length": 28
  },
  {
    "id": 600,
    "uuid": "13b360c4-a2c4-4dd5-b3ff-29e30433b0db",
    "hitokoto": "或许前路永夜，即便如此我也要前进，因为星光即使微弱也会为我照亮前路。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473561757",
    "length": 34
  },
  {
    "id": 601,
    "uuid": "ddcfb677-4d67-4938-9aec-77448eeb5b6f",
    "hitokoto": "英雄意味着强大，英雄意味着孤独，最后一幕一定是英雄渐行渐远，我的英雄也是那样的存在。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562069",
    "length": 42
  },
  {
    "id": 602,
    "uuid": "7816950a-73b2-4e12-b431-4202c128511a",
    "hitokoto": "迎接我们的也许是漆黑一片的夜路，即便如此，也要相信自己，勇往直前。 星空会为我们在这条道路上点缀出淡淡星光。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473562291",
    "length": 54
  },
  {
    "id": 605,
    "uuid": "7bf1aa56-ef43-4100-928a-a14d89647d08",
    "hitokoto": "君の名を 今追いかけるよ",
    "type": "a",
    "from": "君の名は。",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473702570",
    "length": 12
  },
  {
    "id": 606,
    "uuid": "13189ed9-25c1-4326-82db-059a4f117d1d",
    "hitokoto": "谢谢你至今为止都容忍我的任性，我是你的妹妹真的太好了。",
    "type": "a",
    "from": "俺妹",
    "from_who": null,
    "creator": "yeye",
    "creator_uid": 29,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1473904576",
    "length": 27
  },
  {
    "id": 607,
    "uuid": "38e4eedf-cc4d-4935-b5b4-3863ec092855",
    "hitokoto": "那东西既然被你知道了，我就没脸活下去了，只有一死了之了！可是我还不想死，所以只好把你杀了啊！",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082674",
    "length": 46
  },
  {
    "id": 608,
    "uuid": "84c52bf8-235e-4af9-a26f-9c06a7722a81",
    "hitokoto": "笨蛋吉娃娃（バカチワワ）",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082736",
    "length": 12
  },
  {
    "id": 609,
    "uuid": "5c9f37fe-4d60-4ee7-b9df-046f61dba4ec",
    "hitokoto": "吵死了吵死了!",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082780",
    "length": 7
  },
  {
    "id": 610,
    "uuid": "79612a04-5b73-4028-a47d-74c4b699ca85",
    "hitokoto": "回家后我得好好找你人生咨询一下！",
    "type": "a",
    "from": "高坂桐乃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081925",
    "length": 16
  },
  {
    "id": 611,
    "uuid": "7817772c-b92b-4bf8-9537-0d7ca4415a77",
    "hitokoto": "Angel大河大人，为了大家能有一个幸福快乐的圣诞，无论是一层皮还是两层皮都给你剥下来，直到最后全裸都没问题的觉悟都做好了！",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082846",
    "length": 62
  },
  {
    "id": 612,
    "uuid": "7437a548-b121-4c91-8b72-a4929fc6bf9d",
    "hitokoto": "告白当天就要H什么的，真是没办法的男人呢。",
    "type": "a",
    "from": "高坂桐乃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081985",
    "length": 21
  },
  {
    "id": 613,
    "uuid": "85463c82-c001-4e0f-bf68-976d12b972d8",
    "hitokoto": "桐乃非常非常不愿意你有女朋友，但是你还愿意和我复合吗。开...开玩笑的，你不要回答我不然我真的会死\"",
    "type": "a",
    "from": "五更琉璃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082279",
    "length": 50
  },
  {
    "id": 614,
    "uuid": "978ce95a-096c-4df8-97e1-3d83813067ca",
    "hitokoto": "“我要诅咒！诅咒所有相爱的情侣！诅咒神圣的夜晚！诅咒这整个世界（世界：怪我咯？）！对所有的现充挥下破坏的铁锤！我会让你尝尝……我生涯最大的诅咒！”",
    "type": "a",
    "from": "千叶の堕天圣黑猫",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082355",
    "length": 73
  },
  {
    "id": 615,
    "uuid": "bfe8f21f-b116-4598-9e0c-e2e5ecf0cf96",
    "hitokoto": "喂？FFF团团长须川亮吗？这有一个要入团的！",
    "type": "a",
    "from": "五更琉璃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082403",
    "length": 22
  },
  {
    "id": 616,
    "uuid": "28ed7a15-7854-48e9-b9b1-1de07143c9d3",
    "hitokoto": "最有名的莫过于想死一次吗。",
    "type": "a",
    "from": "阎魔爱",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475084090",
    "length": 13
  },
  {
    "id": 617,
    "uuid": "ab536e97-e782-4af9-934c-e0c8958b9be1",
    "hitokoto": "哥哥也可以喜欢上我之外的女孩子，但只有音梦是不可以的！",
    "type": "a",
    "from": "芳乃樱对朝仓纯",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475083776",
    "length": 27
  },
  {
    "id": 619,
    "uuid": "ceda3dbb-ecb1-4855-94a5-cdf947a49bac",
    "hitokoto": "我也做个好孩子，成为这幸福光景的一部分，想成为闪耀在圣诞节的城市里，其中一张幸福的笑脸。",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082877",
    "length": 44
  },
  {
    "id": 620,
    "uuid": "e6fff355-f68b-4a7a-a0ad-a5678876f94e",
    "hitokoto": "龙儿是我的！谁都不准碰！",
    "type": "a",
    "from": "逢坂大河",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082907",
    "length": 12
  },
  {
    "id": 621,
    "uuid": "007d2dda-5b54-460d-88df-c151c4e43866",
    "hitokoto": "以后继续来一起练习打篮球",
    "type": "a",
    "from": "湊智花",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080882",
    "length": 12
  },
  {
    "id": 622,
    "uuid": "e9f8777d-95f5-4607-829f-1931ba0472a8",
    "hitokoto": "请不要跟我搭话。我讨厌你！",
    "type": "a",
    "from": "八九寺真宵",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081483",
    "length": 13
  },
  {
    "id": 623,
    "uuid": "3ef9700b-92b5-433b-a162-3599c8bdda54",
    "hitokoto": "风子参上！",
    "type": "a",
    "from": "伊吹风子",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081562",
    "length": 5
  },
  {
    "id": 624,
    "uuid": "2271d199-988e-49fc-b818-4bcf73f9c8b2",
    "hitokoto": "男生送的礼物要方便拿来换钱才好吧！",
    "type": "a",
    "from": "来栖加奈子",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081628",
    "length": 17
  },
  {
    "id": 625,
    "uuid": "9189db76-f819-45e6-a2c4-24a42dfec740",
    "hitokoto": "你是笨蛋吗？",
    "type": "a",
    "from": "小桐桐（きりりん）",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081754",
    "length": 6
  },
  {
    "id": 626,
    "uuid": "0cb78591-b662-4007-b916-4ef793744582",
    "hitokoto": "我跟喜欢成人游戏一样喜欢你",
    "type": "a",
    "from": "高坂桐乃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081851",
    "length": 13
  },
  {
    "id": 627,
    "uuid": "71289512-f358-4cfe-a673-3a1f18592e12",
    "hitokoto": "最喜欢你了唷！！ 开玩笑的！！啊--！好害羞 有机会的话会再写信给你。 希望那时，能变得更加坦率捏~",
    "type": "a",
    "from": "久保由利香致小泉花阳",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475073078",
    "length": 50
  },
  {
    "id": 628,
    "uuid": "3df1a406-dda0-4bd7-98dd-1186e0cf7ff4",
    "hitokoto": "最后，士郎……你要去打的話……必须給我贏！你要是死了话……我饶不了你……",
    "type": "a",
    "from": "遠坂凜",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080964",
    "length": 36
  },
  {
    "id": 629,
    "uuid": "0428f3d0-6d6e-42e0-a766-8d63d7a4dc19",
    "hitokoto": "最后好想有个拥抱....，可是...那种事情怎么能说得出口.....",
    "type": "a",
    "from": "露西",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475081389",
    "length": 34
  },
  {
    "id": 633,
    "uuid": "5339626f-e953-4e35-b429-a981bc6ee0ee",
    "hitokoto": "受虐狂的娇小美少年……真想带回家去养一段时间啊。",
    "type": "a",
    "from": "赤井林檎",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475082964",
    "length": 24
  },
  {
    "id": 634,
    "uuid": "f0cb7a48-5c56-4806-b26e-df7974c792ba",
    "hitokoto": "希望老师像帮我一样帮帮れいジ",
    "type": "a",
    "from": "九重凛",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080724",
    "length": 14
  },
  {
    "id": 635,
    "uuid": "db8f481e-bde7-4b4d-9ed5-b1dc2e00df81",
    "hitokoto": "在排练的休息时间里要好好补充水分和盐分哦！",
    "type": "a",
    "from": "三森铃子致海未",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072675",
    "length": 21
  },
  {
    "id": 636,
    "uuid": "2174b7f9-322b-47dc-964c-a567e27f1500",
    "hitokoto": "得到更多人的认可，带著大家的爱意加油哦！",
    "type": "a",
    "from": "内田彩致南小鸟",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072831",
    "length": 20
  },
  {
    "id": 637,
    "uuid": "9f01a441-bd5f-4112-b8b6-3eb35a1574b4",
    "hitokoto": "重新再说一次，至今为止，真的谢谢你。 然后，今后也请多指教了。",
    "type": "a",
    "from": "楠田亞衣奈致东条希",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072951",
    "length": 31
  },
  {
    "id": 638,
    "uuid": "d7b75a3c-e022-4a9a-b7d3-4710646a99f0",
    "hitokoto": "笨蛋、笨蛋！",
    "type": "a",
    "from": "星野琉璃",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475079528",
    "length": 6
  },
  {
    "id": 639,
    "uuid": "fdb94cb9-552e-486c-a34e-f1e73c44b1f8",
    "hitokoto": "没问题，绝对没问题",
    "type": "a",
    "from": "木之本樱（无敌咒语）",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475079679",
    "length": 9
  },
  {
    "id": 640,
    "uuid": "4fdf5c09-049c-4840-9ec7-cccd72443c4b",
    "hitokoto": "凡人、笨蛋！",
    "type": "a",
    "from": "维多利加·德·布洛瓦",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475079808",
    "length": 6
  },
  {
    "id": 641,
    "uuid": "ea648ce0-d7dc-4067-9fbb-e83357db0230",
    "hitokoto": "笨蛋,蠢货",
    "type": "a",
    "from": "南千秋",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475079932",
    "length": 5
  },
  {
    "id": 643,
    "uuid": "0527a582-a7fe-43c3-a711-49b2455cc81b",
    "hitokoto": "我绝对会成为火影。我从来都是有话直说，这就是我的忍道！",
    "type": "a",
    "from": "漩涡鸣人",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080357",
    "length": 27
  },
  {
    "id": 644,
    "uuid": "e20ce0c6-69cc-45f8-a674-d6ee3ffb565b",
    "hitokoto": "Fightだよじゃねつの！",
    "type": "a",
    "from": "高坂穗乃果",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072174",
    "length": 13
  },
  {
    "id": 646,
    "uuid": "f13a3715-9c61-46b8-b4c5-abccee850dcb",
    "hitokoto": "哦~",
    "type": "a",
    "from": "袴田日向",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475080775",
    "length": 2
  },
  {
    "id": 647,
    "uuid": "ba4e43b6-f9b7-44ae-a846-56a75a6d72c4",
    "hitokoto": "绝对要一起去吃拉面喵~",
    "type": "a",
    "from": "星空凛",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072516",
    "length": 11
  },
  {
    "id": 650,
    "uuid": "e8c079cc-e5ca-4fee-8b66-e80f2818b263",
    "hitokoto": "不管你在世界的哪个地方，我一定会，再次去见你的。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475387467",
    "length": 24
  },
  {
    "id": 651,
    "uuid": "30cceae1-3df0-4aef-a7e7-566ace9add1e",
    "hitokoto": "描线一笔接一笔，白色的素描本上渐渐萌生黑意。即便如此，还无法照准记忆中的风景。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475387493",
    "length": 39
  },
  {
    "id": 652,
    "uuid": "76c1e08c-95d9-41c5-b52e-99d0a9abcf37",
    "hitokoto": "你会哭着笑，笑着哭，是因为你的心，早已超越了自己啊。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475387594",
    "length": 26
  },
  {
    "id": 653,
    "uuid": "38294934-cbbd-4437-a4c9-31e178da2943",
    "hitokoto": "醒来的时候 不知道自己为什么哭 时常会有的事情 做过的梦总是回想不起 只是 一种有什么消失的丧失感",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475387610",
    "length": 49
  },
  {
    "id": 654,
    "uuid": "b1a0b321-4509-40f6-b3d5-eb17c9f8b281",
    "hitokoto": "以彗星为龙，以彗星为绳结。描绘出割裂的彗星舞动的形态。又是一轮岁月。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388066",
    "length": 34
  },
  {
    "id": 655,
    "uuid": "b3928418-1530-45b0-b952-840301afe644",
    "hitokoto": "聚拢，成形，捻转，回绕，时而返回，暂歇，再联结。这就是组纽。这就是时间。这就是，联结",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388163",
    "length": 42
  },
  {
    "id": 656,
    "uuid": "e5aa4746-5485-45f0-85a8-be6bea880fcd",
    "hitokoto": "从你的前前前世开始，我就开始找寻你",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388215",
    "length": 17
  },
  {
    "id": 657,
    "uuid": "dbc3350e-0bae-4b88-99e9-97df49580312",
    "hitokoto": "假如我们相遇，肯定一眼就能认出彼此",
    "type": "a",
    "from": "你的名字",
    "from_who": "宫水三叶",
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388232",
    "length": 17
  },
  {
    "id": 658,
    "uuid": "62628339-dff5-4416-8360-3a0868b2dfc0",
    "hitokoto": "从现在开始，我将追寻你的名字。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388274",
    "length": 15
  },
  {
    "id": 659,
    "uuid": "e3377733-1d4c-4b6c-bc79-2e24f008d283",
    "hitokoto": "我，将某个人，唯一的某个人，试图锁定。我，",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388286",
    "length": 21
  },
  {
    "id": 660,
    "uuid": "4728a74b-35cc-4dca-be6a-209cc07a70ad",
    "hitokoto": "散落至四方。又或是升起至四方。在无法确认这一事实的浮游感中，彗星耀辉在夜空。彗星裂开，碎片落下。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475388306",
    "length": 48
  },
  {
    "id": 665,
    "uuid": "88b2b740-33da-4ca7-8f8b-8ce50015e7c0",
    "hitokoto": "喜欢喜欢轻飘飘喜欢喜欢轻飘飘让我们一起来！",
    "type": "a",
    "from": "Printemps",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475607469",
    "length": 21
  },
  {
    "id": 675,
    "uuid": "344e0993-8cb7-4c8c-95fe-9130a5a8b8e4",
    "hitokoto": "みんなで作る、最高のライブ！",
    "type": "a",
    "from": "LoveLive! The School idol Movie",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475517837",
    "length": 14
  },
  {
    "id": 678,
    "uuid": "62ecee56-83a6-4435-88cd-74d8235c1a6c",
    "hitokoto": "凛：450拿来 海：自由女神Shoot！ 希：其实有点像邪神果",
    "type": "a",
    "from": "乙姬心恋宫殿",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475532695",
    "length": 31
  },
  {
    "id": 680,
    "uuid": "6becfd93-5d1d-44e2-ba0c-f35085fb65df",
    "hitokoto": "脱！！巨乳！",
    "type": "a",
    "from": "暗杀教室",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476023614",
    "length": 6
  },
  {
    "id": 701,
    "uuid": "5c556eef-e10d-4cc0-8cbf-fb36dae2ce06",
    "hitokoto": "前天是小兔子,昨天是小鹿,今天是你",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "OnlyKotomi",
    "creator_uid": 76,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1476584523",
    "length": 17
  },
  {
    "id": 706,
    "uuid": "b64a74bd-8df9-4122-961a-c813beb4aab7",
    "hitokoto": "有些事情我不看透，不是我太笨，只是我太善良。",
    "type": "a",
    "from": "樱桃小丸子",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1474191685",
    "length": 22
  },
  {
    "id": 708,
    "uuid": "8cce7da4-bdd7-42e1-98d0-b6f87ca0b0e5",
    "hitokoto": "彼方为谁，无我有问 ；九月露湿，待君之前",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "moe",
    "creator_uid": 94,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477825585",
    "length": 20
  },
  {
    "id": 709,
    "uuid": "b2870941-0c93-40e6-be59-5922aaf82abc",
    "hitokoto": "会起反作用是吧……明明是想保护，却伤害了；明明想要哭泣， 却微笑着。",
    "type": "a",
    "from": "吸血鬼骑士",
    "from_who": null,
    "creator": "moe",
    "creator_uid": 94,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477825464",
    "length": 34
  },
  {
    "id": 710,
    "uuid": "91516e55-77d3-4d71-9989-fdef1abaeabf",
    "hitokoto": "我不是天生的王者 但我骨子里流动着不让我低头的血液",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "moe",
    "creator_uid": 94,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477825702",
    "length": 25
  },
  {
    "id": 711,
    "uuid": "59772bb1-85c6-44a9-b7b1-6fae9c150947",
    "hitokoto": "不要停止奔跑，不要回顾来路，来路无可眷恋，值得期待的只有前方。",
    "type": "a",
    "from": "马男波杰克",
    "from_who": null,
    "creator": "moe",
    "creator_uid": 94,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1477825806",
    "length": 31
  },
  {
    "id": 712,
    "uuid": "b7e3e7b5-2172-4cab-b749-af34921aee17",
    "hitokoto": "苹果是给那些为了爱选择死亡的人的奖励",
    "type": "a",
    "from": "回转企鹅罐",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 714,
    "uuid": "cc0f02de-cbba-4c45-9f60-6735d4d3435e",
    "hitokoto": "一定要保护自己的梦想，即使牺牲一切。",
    "type": "a",
    "from": "NANA",
    "from_who": "大崎娜娜",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 718,
    "uuid": "9eb3fd73-701f-4481-a1d9-38ef49b01305",
    "hitokoto": "喜欢你，因为我喜欢你，比地球上任何人都，喜欢你...",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 724,
    "uuid": "45bb0e57-ae44-4eb7-b7ad-6f8708205284",
    "hitokoto": "所谓“大家”，就是无视并牺牲了一部分弱势群体后所达到的虚伪的和平与共识。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 36
  },
  {
    "id": 726,
    "uuid": "38bb1173-9f7c-48c5-8349-30e437d60daa",
    "hitokoto": "男人至死都是少年",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 8
  },
  {
    "id": 727,
    "uuid": "d9771567-4df9-4bcf-8f9d-e36d416de148",
    "hitokoto": "润滑油是用来防止磨损的东西。在心中有着润滑油也会活得更加轻松吧。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 32
  },
  {
    "id": 731,
    "uuid": "f0a173df-bb90-4502-b367-31ca403d2e28",
    "hitokoto": "不能逃避，不能逃避，不能逃避，不能逃避…",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 732,
    "uuid": "fbf07acb-5e37-41d8-a4ed-e31b35632623",
    "hitokoto": "我除了投三分，就什么都没有了…",
    "type": "a",
    "from": "灌篮高手",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 733,
    "uuid": "7f27cfaf-e36f-4c4f-a490-367768b6d235",
    "hitokoto": "我会死在这里，我的每一寸肌肤都会腐烂，除了…一寸，这一寸，它是那么的小，那么的脆弱，却是这世上唯一值得拥有的东西，我们决不能失去或者放弃它，我们决不能让别人把它夺走。",
    "type": "a",
    "from": "碧之轨迹",
    "from_who": "盖伊",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 83
  },
  {
    "id": 734,
    "uuid": "14c74462-0324-4451-915a-91181908e8af",
    "hitokoto": "无论是丢下还是被丢下，这两者都是一样痛苦的。",
    "type": "a",
    "from": "水果篮子",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 735,
    "uuid": "625b5579-6961-4ee3-9871-728d7d13c531",
    "hitokoto": "女生口中的「好人」首先百分之百是「怎样都好的人」的意思，再好也不过止于「方便好使的人」。也就是说，不管怎样都是没戏了。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 59
  },
  {
    "id": 739,
    "uuid": "12a28cde-239e-462d-9d1a-8bfa7023ed4d",
    "hitokoto": "今天的风儿有些喧嚣啊。",
    "type": "a",
    "from": "男子高中生的日常",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 740,
    "uuid": "74576c42-9c75-46d7-8b4d-a6015eceed9b",
    "hitokoto": "死对任何人都是残酷的，年轻年老、好人坏人都一样。死是平等的，没哪种死亡是特别残酷的，所以死才可怕。品行、年龄、个性、金钱、美貌，这些东西只在生前才有意义。就因能将一切化为乌有，所以怎样的死都是残酷的。",
    "type": "a",
    "from": "尸鬼",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 100
  },
  {
    "id": 741,
    "uuid": "87799fa0-d9c4-4925-8f4d-abd22439d5c3",
    "hitokoto": "命运的红线一旦断了，就再也不会接上。",
    "type": "a",
    "from": "犬夜叉",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 743,
    "uuid": "f2bb5c0f-b47a-427c-ba62-33539038559a",
    "hitokoto": "活下去的意志是最强的力量！",
    "type": "a",
    "from": "浪客剑心",
    "from_who": "绯村剑心",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 748,
    "uuid": "5ff8de30-c9b0-4e8e-bb60-5ea0ca712adb",
    "hitokoto": "想要试着去相互接近，但最后还是无法敞开心扉，结果就是擦肩而过…",
    "type": "a",
    "from": "文学少女",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 31
  },
  {
    "id": 749,
    "uuid": "a839eb7c-8859-4aa7-84ca-133a29c8a9f6",
    "hitokoto": "男人的爱情是另存为，女人的爱情是覆盖。",
    "type": "a",
    "from": "红",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 750,
    "uuid": "f79ea25f-0a86-46a1-a098-8afaf038a38c",
    "hitokoto": "不逆 不耻 不憾",
    "type": "a",
    "from": "舰队Collection",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 8
  },
  {
    "id": 754,
    "uuid": "6b82caf5-fae8-4fc6-b244-b319a6eb9773",
    "hitokoto": "有话直说就是我的忍道！",
    "type": "a",
    "from": "火影忍者",
    "from_who": "漩涡鸣人",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 757,
    "uuid": "96a3ba09-f5ab-4248-acb8-673d3cc63d14",
    "hitokoto": "就连一直都无容身之地的我…也不是可以任意舍弃的生命。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 761,
    "uuid": "a2209501-fe96-495d-9bf0-093683c6cbbe",
    "hitokoto": "明明只是活着，哀伤却无处不在…",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 762,
    "uuid": "41d15392-083c-4404-8bd9-9266c0f884b6",
    "hitokoto": "为了你,如果是为了你,即使我被困在永远的迷宫中,也没关系.",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 29
  },
  {
    "id": 763,
    "uuid": "f456680a-7082-43a6-a36e-4a200bb11f56",
    "hitokoto": "我不渴望什么在别的城市迎来的春天，只要和你在一起的春天就好，只要和你在一起就好…",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 40
  },
  {
    "id": 765,
    "uuid": "6d045309-a926-449a-8579-3d91c3cd39ae",
    "hitokoto": "“像你这样的白痴是怎么活过来的？”“因为我很自信。“",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 768,
    "uuid": "cdf42ce8-96c0-4e8f-93e4-481dbd9cc527",
    "hitokoto": "汝真是个烂好人",
    "type": "a",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 7
  },
  {
    "id": 772,
    "uuid": "7e8e8277-fcb8-417b-82b0-44c4144c0b6f",
    "hitokoto": "我知道的，面码…自己已经死掉这点事，还是知道的…",
    "type": "a",
    "from": "我们仍未知道那天所看见的花的名字",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 24
  },
  {
    "id": 773,
    "uuid": "d1afdca0-2d72-48a0-8c18-fff6386f658e",
    "hitokoto": "不习惯的事越来越多，但我仍在前进…就算步伐很小，我也在一步一步的前进。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 35
  },
  {
    "id": 774,
    "uuid": "6f480b8d-5d5c-4071-a78e-2dd9738776f6",
    "hitokoto": "刻意保持距离的人是你，虚拟世界里的区区两公尺，对你来说就真的如此遥不可及?",
    "type": "a",
    "from": "加速世界",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 777,
    "uuid": "c6191d7c-a0c5-49dc-b294-dd56c55de195",
    "hitokoto": "想哭的时候能哭出来，也是一种坚强",
    "type": "a",
    "from": "翼年代记",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 778,
    "uuid": "fa344ed4-7de0-408b-a36c-f2a2a8567dfe",
    "hitokoto": "如果你愿意的话，让我带您去吧，这座小镇，愿望实现的地方…",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 28
  },
  {
    "id": 783,
    "uuid": "5c2c392a-12ab-4f2d-9106-e97ce7b10e64",
    "hitokoto": "有伤害人的人存在的话，也会有能抚慰伤痕的人",
    "type": "a",
    "from": "水果篮子",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 784,
    "uuid": "195680f0-23f6-423a-8665-d121b25b2b4c",
    "hitokoto": "会长和往常一样挺着小小的胸部一副自以为了不起的样子套用某本书的内容说道…",
    "type": "a",
    "from": "学生会的一己之见",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 36
  },
  {
    "id": 789,
    "uuid": "34113080-495b-439a-830f-094a7d8c6ac0",
    "hitokoto": "我觉得只要这样继续加油，总有一天能赶上他们的。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "启太",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 23
  },
  {
    "id": 793,
    "uuid": "2be7c875-1ad2-41b0-9eb5-e181b23b0339",
    "hitokoto": "如果你是魔女，我只要化身魔王就可以了。",
    "type": "a",
    "from": "反叛的鲁鲁修",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 795,
    "uuid": "5d5d1a1e-097b-463c-b9d7-0b8d07555b73",
    "hitokoto": "人的一生会遭遇各种各样的事，其中有令人难以置信的事，也有不讲道理的事，但这就是生活。",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 42
  },
  {
    "id": 799,
    "uuid": "55f5e370-1227-4c54-a3e7-dc84b65ab301",
    "hitokoto": "叶え！私たちの夢ー。",
    "type": "a",
    "from": "ラブライブ！",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 800,
    "uuid": "58ba57bf-52ae-4480-8c9b-03dfbef432b4",
    "hitokoto": "人不会对讨厌人要求理由。莫名的生气、莫名的讨厌、莫名的恶心、什么都能成为讨厌人的理由。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 43
  },
  {
    "id": 802,
    "uuid": "41676373-8c2b-46a7-9922-4b723f2e7150",
    "hitokoto": "无论发生什么都不要停下。无论到什么时候都要继续前进。 要一直走下去，直到生命终止的那一刻。",
    "type": "a",
    "from": "驱魔少年",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 45
  },
  {
    "id": 803,
    "uuid": "ceba8d18-808a-484e-9bc7-ee6e0298108b",
    "hitokoto": "堕入黑暗裏的可怜影子啊，停止伤害他人的行为吧，犯下罪行的灵魂…想死一次么？",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 804,
    "uuid": "a2cb628a-87db-4d51-a2ac-7ed8e9e2df9e",
    "hitokoto": "我的生命是属于你的，亚丝娜，我将为你而活。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "桐人",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 811,
    "uuid": "2bcdabe9-9a4f-4fae-bb59-a650694efe58",
    "hitokoto": "“如果我不在了，你会怎样？” “我会去找你” “如果找不见呢？” “我会一直，一直，一直找下去”",
    "type": "a",
    "from": "人鱼森林",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 48
  },
  {
    "id": 820,
    "uuid": "5ea37c6a-5809-4167-af84-e0aab4edad6f",
    "hitokoto": "All for one, one for all.",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 824,
    "uuid": "f1470c7f-f730-45b3-bc45-53b39e95b488",
    "hitokoto": "祈求别人幸福的同时,却不得不去诅咒其他的人,我们魔法少女就是这样的构造吧!",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 829,
    "uuid": "a1e14c82-ce62-4f80-89f6-a67a94ac5715",
    "hitokoto": "人的一生会遭遇各种各样的事，其中有令人难以置信的事，也有不讲道理的事，但都必须予以克服，这就是生活",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 49
  },
  {
    "id": 833,
    "uuid": "7b7dcce7-65bf-4546-817f-dde899f95691",
    "hitokoto": "以为大哭大闹一场就有人来安慰的家伙真是幸福呢。",
    "type": "a",
    "from": "龙与虎",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 23
  },
  {
    "id": 834,
    "uuid": "95c9dc11-6ec9-457a-a675-9be0be854e9a",
    "hitokoto": "时间可以治愈？如果时间也病了怎么办",
    "type": "a",
    "from": "寒蝉明泣之时",
    "from_who": "古手梨花",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 836,
    "uuid": "18cd65f3-e26d-4de5-a2b5-ef429b4a1b58",
    "hitokoto": "如果幸福有形状，该是什么样的呢？它就像玻璃，因为平时察觉不到它的存在，而它却时时在我们身边，最有力的证据就是，只要换一个角度，它就会折射出耀眼的光芒，比谁都过分强调自我的存在。",
    "type": "a",
    "from": "反叛的鲁鲁修",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 88
  },
  {
    "id": 838,
    "uuid": "f0fbf41b-67c3-48b5-bf16-e52095c00ef5",
    "hitokoto": "求你，保护那孩子，消除灾厄，抹除祸事。哪怕…那是我自己…",
    "type": "a",
    "from": "食灵",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 28
  },
  {
    "id": 839,
    "uuid": "0e5a56c7-1777-4c1f-a0fc-9dc676113b52",
    "hitokoto": "不是我，都是社会的错",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 840,
    "uuid": "5fb5b2d1-c54e-4c3c-a807-81ac777a80a7",
    "hitokoto": "El Psy Congroo!",
    "type": "a",
    "from": "命运石之门",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 842,
    "uuid": "23ce48ae-2ffc-4d4b-be8f-fce8408ba212",
    "hitokoto": "红茶的温度和女人心在任何时代都是难以琢磨呢。",
    "type": "a",
    "from": "海猫鸣泣之时",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 845,
    "uuid": "db0950d9-45e0-4fb8-a192-05645eb78384",
    "hitokoto": "并非喜欢、也不是爱。而是更加深刻而沉重的——",
    "type": "a",
    "from": "SWEET POOL",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 846,
    "uuid": "66f48135-3b16-4f30-a8fb-fe4e1eaebeaf",
    "hitokoto": "Oh,please don't let me die. Waiting for your touch.",
    "type": "a",
    "from": "Re：从零开始的异世界生活",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 51
  },
  {
    "id": 848,
    "uuid": "2278a0a8-9f5f-4b23-85ef-3e0f1082aa78",
    "hitokoto": "You Are (Not) Alone;You Can (Not) Advance;You Can (Not) Redo",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 60
  },
  {
    "id": 851,
    "uuid": "ce9e18d0-fbde-48ec-b24b-c8998b88518c",
    "hitokoto": "禁忌算什么！那难道比爱丽丝的命还重要吗？",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "桐人",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 852,
    "uuid": "43553258-abd8-4d00-ba57-c018a63a53ad",
    "hitokoto": "MAKE OUR DREAMS ALIVE",
    "type": "a",
    "from": "ラブライブ！",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 854,
    "uuid": "7a24622f-2440-49ad-967a-a0a1b31d1ecd",
    "hitokoto": "什么都无法舍弃的人，什么都无法改变 。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": "阿尔敏",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 855,
    "uuid": "e698b366-b77c-49e5-ae28-7017e327ca23",
    "hitokoto": "知道人的眼睛为什么长在前面吗？那是因为如果想看到远处的风景的话，就只能向前前进。",
    "type": "a",
    "from": "天元突破：红莲螺岩",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 40
  },
  {
    "id": 857,
    "uuid": "af7907b3-137d-4543-813b-6d14b980f8e2",
    "hitokoto": "春天 马上就要来了  让我与你相遇的春天 就要来了  再也没有你的春天 就要来了",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 40
  },
  {
    "id": 863,
    "uuid": "3dfd2ce4-eb46-400c-b7ad-4abbc366db32",
    "hitokoto": "世间万物，如果一直放着不管的话，便一定会向不好的方向发展。就像即使如何的努力也无法阻止宇宙变冷一样。只是按照‘常理进行’不断积累而构筑出的世界，无论如何也无法脱离物理法则的束缚。",
    "type": "a",
    "from": "虚渊玄",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 89
  },
  {
    "id": 865,
    "uuid": "5bd560fa-9e7c-4b07-adb8-ab47a83252f9",
    "hitokoto": "无可替代的存在什么的不是很可怕吗？一旦失去就再也无法取回；绝对不能容忍失败；无法再一次得到。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 46
  },
  {
    "id": 866,
    "uuid": "5dd8aecb-b869-49da-9711-1216cdaefaad",
    "hitokoto": "其实...根本就没有什么天堂和地狱吧....",
    "type": "a",
    "from": "死亡笔记",
    "from_who": "夜神月",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 867,
    "uuid": "d408b05f-19e2-4278-a8a9-5750d8d2e989",
    "hitokoto": "真正重要的东西，永远都是非常简单的。",
    "type": "a",
    "from": "Clannad",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 870,
    "uuid": "1eae453e-cc37-41b7-b9f6-24df91a4b96a",
    "hitokoto": "我已经准备好了足够挡雨的伞，可是却迟迟没有等到雨的到来，这样的尴尬只是我漫长人生中的小插曲罢了。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 48
  },
  {
    "id": 871,
    "uuid": "8955747e-ddcd-4e4d-8c30-a497450ee9fc",
    "hitokoto": "我觉得在这里干尽坏事的玩家，都是些在现实世界中也烂到骨子里的家伙。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "桐人",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 33
  },
  {
    "id": 874,
    "uuid": "460166bb-b292-4acf-9af4-15ec11eaf898",
    "hitokoto": "是你赢了...哲...",
    "type": "a",
    "from": "黑子的篮球",
    "from_who": "青峰大辉",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 11
  },
  {
    "id": 878,
    "uuid": "c3fd33c9-3fd6-4e8b-a3dd-025a52b66c09",
    "hitokoto": "我们一直在一起，所以最后也想在你身旁。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 879,
    "uuid": "88f55f08-6b8a-4017-bd19-3e7d899568cf",
    "hitokoto": "人们只是用好人来称呼对自己有用的人而以，不存在对所有人都有用的人",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 32
  },
  {
    "id": 880,
    "uuid": "af4dc68f-ad02-48e4-b817-c0aec755c114",
    "hitokoto": "要是太勉强自己的话，总有一天会受伤的",
    "type": "a",
    "from": "吸血鬼骑士",
    "from_who": "玖兰枢",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 882,
    "uuid": "5deb7c4e-3aa9-4006-8120-e3147b7bb9e5",
    "hitokoto": "我本身得不到答案。所以，我希望有能够答出来之物的诞生。",
    "type": "a",
    "from": "Fate/Stay Night",
    "from_who": "言峰绮礼",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 27
  },
  {
    "id": 883,
    "uuid": "dfb61881-c964-428c-a3a1-0e98a918489d",
    "hitokoto": "最初的一步，泪水之后再一次，雕刻的风景线，消逝在黄昏中的风，直到梦的最后。",
    "type": "a",
    "from": "Clannad",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 37
  },
  {
    "id": 885,
    "uuid": "bf19b3ac-8cb6-4463-9049-d99f6a003609",
    "hitokoto": "应该可以了吧，我已经很努力了，应该可以抵达终点了…",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 887,
    "uuid": "b2c511e4-ff7d-4b76-9ee4-097ef3617951",
    "hitokoto": "所谓的奇迹就是要发生之后才会有价值存在的吧",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 888,
    "uuid": "31e561a2-b4f2-4c3b-82e0-d907d837d129",
    "hitokoto": "笑是对身边的事物感到一瞬间的幸福而表现出来的东西。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": "冈崎朋也",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 25
  },
  {
    "id": 889,
    "uuid": "290570fa-8972-4bee-a61c-df06c2ffa7f5",
    "hitokoto": "休息对于生存而言，也是紧要问题",
    "type": "a",
    "from": "虫师",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 896,
    "uuid": "66d74655-e42c-4677-86fe-77128c44edc0",
    "hitokoto": "失礼。噛みました",
    "type": "a",
    "from": "化物语(上)",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 8
  },
  {
    "id": 902,
    "uuid": "f39df08a-97ac-4d7e-9b9a-dafad43975ca",
    "hitokoto": "驱动着这个世界的，并非只有眼睛能够看到的东西。就像只观察结晶回路的轮盘是无法知晓齿轮的运动一样……",
    "type": "a",
    "from": "空之轨迹",
    "from_who": "莱维",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 49
  },
  {
    "id": 905,
    "uuid": "40a206e8-3d5d-4f9e-9069-26fb02110d38",
    "hitokoto": "是个男人就要对自己的人生负责",
    "type": "a",
    "from": "麻辣教师",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 14
  },
  {
    "id": 906,
    "uuid": "ab5b37a1-da13-4a8c-ba0b-67ac123f5001",
    "hitokoto": "我们不是狼，我们只是长着獠牙的羊......",
    "type": "a",
    "from": "羊之歌",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 907,
    "uuid": "564c59ba-1041-432f-8ba5-334bad6f0faf",
    "hitokoto": "没有偶然的必然，只有必然的偶然",
    "type": "a",
    "from": "魔卡少女樱",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 908,
    "uuid": "fa73f369-625a-407c-9a7c-2e09b04da8d8",
    "hitokoto": "我觉得你很幸福，因为你可以选择爱或者不爱我，而我只能选择爱或者更爱你",
    "type": "a",
    "from": "草莓100%",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 34
  },
  {
    "id": 909,
    "uuid": "bd08f23c-b66b-4c97-8a09-cb5429a19bc3",
    "hitokoto": "前天是兔子，昨天是小鹿，今天是你",
    "type": "a",
    "from": "Clannad",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 913,
    "uuid": "5b6f07cf-678c-4194-a7f3-667daf9dc494",
    "hitokoto": "ご無事で何よりです。",
    "type": "a",
    "from": "妖狐X僕ss",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 917,
    "uuid": "19378048-ac08-43b9-adac-17c95111f517",
    "hitokoto": "少年少女 向前走吧。",
    "type": "a",
    "from": "阳炎PROJECT",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 918,
    "uuid": "55127816-d4cf-43be-9ac5-acbb83474424",
    "hitokoto": "过分的神圣，往往比恶魔更加恶质。",
    "type": "a",
    "from": "黑执事",
    "from_who": "塞巴斯蒂安·米卡艾利斯",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 924,
    "uuid": "4d9df727-d9ac-432f-90c4-14ed67770d44",
    "hitokoto": "正因生来一无所有，因此我们能拥有一切。",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 925,
    "uuid": "63c014c7-d8ee-4028-ba4b-cfa10639157a",
    "hitokoto": "我从来都不是什么天才，只是一个普通人，是一个连一个小女孩都保护不了的普通的、渺小的人类啊。",
    "type": "a",
    "from": "钢之炼金术师",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 45
  },
  {
    "id": 927,
    "uuid": "6624559b-4758-4d4a-bb13-808c6cf68b8e",
    "hitokoto": "我不会去统治这片大海，在这片大海上，最自由的人就是海贼王！",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 29
  },
  {
    "id": 930,
    "uuid": "d4726082-b4a6-4064-988e-0977e86c9ed5",
    "hitokoto": "失礼、噛みました",
    "type": "a",
    "from": "化物语",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 8
  },
  {
    "id": 931,
    "uuid": "cb716976-1dd5-4e69-9cc1-74529fa9407c",
    "hitokoto": "她有心，她的心在我这里。",
    "type": "a",
    "from": "人形电脑天使心",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 932,
    "uuid": "a768e618-55ea-4359-b065-c169f094ab24",
    "hitokoto": "努力不会背叛自己，虽然有时会背叛梦想",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 938,
    "uuid": "dd6d30d9-426f-436e-8d73-18767b8ef881",
    "hitokoto": "超频链接",
    "type": "a",
    "from": "加速世界",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 4
  },
  {
    "id": 941,
    "uuid": "457f7af9-e77e-477e-a052-d4049a9bc256",
    "hitokoto": "若没有可依靠之处，便也找不到自己的归宿，躲躲藏藏随波逐流，依附于某物，却又一头撞在看不见的墙壁上。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 49
  },
  {
    "id": 942,
    "uuid": "c429bc13-07ea-41cb-b21f-209ab10474d8",
    "hitokoto": "就算是自私…我也希望那些人能够永远都有笑容…",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 943,
    "uuid": "aa476a13-74c4-40c5-ba27-2f75c89ca376",
    "hitokoto": "挚友的执念烙印此身，无尽的黑暗化为光明，天上天下，一骑当神！",
    "type": "a",
    "from": "天元突破：红莲螺岩",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 30
  },
  {
    "id": 948,
    "uuid": "92a99c19-b34c-4353-8c9f-836e34d01321",
    "hitokoto": "人在直面恐惧的时候，自身的灵魂将会受到考验。降生于这世界，究竟有何所求，要成何事，其本性会暴露无遗。",
    "type": "a",
    "from": "PSYCHO-PASS",
    "from_who": "槙岛圣护",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 50
  },
  {
    "id": 951,
    "uuid": "2eec6879-41a0-4ff7-8ba5-fbcf568e5adb",
    "hitokoto": "整个社会对我都很苛刻。所以至少让我自己宽容一下我自己吧。如果大家都对自己更宽容一点的话。大家都变成废柴就没有废柴了。",
    "type": "a",
    "from": "果然我的青春恋爱喜剧搞错了",
    "from_who": "大老师",
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 58
  },
  {
    "id": 952,
    "uuid": "fef5e149-2022-4c21-8f2b-e972211cb601",
    "hitokoto": "还能再见面吗? 一定能见面的",
    "type": "a",
    "from": "Fantastic Children",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 14
  },
  {
    "id": 956,
    "uuid": "f3fd0703-6958-407e-b321-360fccb2c921",
    "hitokoto": "即使你忘却了我，我也不会遗忘你。",
    "type": "a",
    "from": "菜月昂",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479436120",
    "length": 16
  },
  {
    "id": 957,
    "uuid": "fa0123ce-91e1-43ae-80dd-bf8d9ed21522",
    "hitokoto": "不要伤害自己，别人总会这样做。",
    "type": "a",
    "from": "天国王朝",
    "from_who": null,
    "creator": "Eric",
    "creator_uid": 114,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1479303190",
    "length": 15
  },
  {
    "id": 966,
    "uuid": "cb820985-9323-4a61-8041-9f1839dce291",
    "hitokoto": "我喜欢你，比世界上任何人都喜欢你。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": null,
    "creator": "测试卡",
    "creator_uid": 130,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480238407",
    "length": 17
  },
  {
    "id": 974,
    "uuid": "b86b6d43-1f2f-4b4a-8e79-297a7ed5e707",
    "hitokoto": "人是可以改变一切的，世上的一切。",
    "type": "a",
    "from": "吹响！上低音号",
    "from_who": null,
    "creator": "darudayu",
    "creator_uid": 136,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1480780994",
    "length": 16
  },
  {
    "id": 979,
    "uuid": "bd9e78c6-ee7b-4d8a-bb76-3b9014f62b2f",
    "hitokoto": "所谓的「改变自己，世界就会随之改变」这种事，是不可能的。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 28
  },
  {
    "id": 980,
    "uuid": "a96982a1-087d-45cd-a77f-0bffc9b737f6",
    "hitokoto": "我想成为一个温柔的人，因为曾被温柔的人那样对待，深深了解那种被温柔相待的感觉。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": "夏目",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 39
  },
  {
    "id": 982,
    "uuid": "e370fe5c-16cf-4cfc-9b57-748e6484fcdf",
    "hitokoto": "你喜欢的人已经心有所属不是正常的吗，因为你喜欢他，所以你的眼中就只有她。人啊，总是盲目地去爱。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 47
  },
  {
    "id": 983,
    "uuid": "3e361053-2287-4840-a3a7-cdf192afdefa",
    "hitokoto": "忍者的才能不在于所掌握忍术的多少，而在于永不放弃的毅力.笔直向前绝不违背自己的誓言，还有不管何时都不放弃.",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 53
  },
  {
    "id": 984,
    "uuid": "9f93297a-b7b1-4a83-b26c-90c17f53f868",
    "hitokoto": "我动身踏上旅程，是为了与你道别。",
    "type": "a",
    "from": "追逐繁星的孩子",
    "from_who": null,
    "creator": "2416790970",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 16
  },
  {
    "id": 985,
    "uuid": "0e973d19-dd51-41f1-84cf-e8eabccf5474",
    "hitokoto": "大家即将各自展开旅程，挥别这个没落的城镇。",
    "type": "a",
    "from": "仰望半月的夜空",
    "from_who": "桥本纺",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 21
  },
  {
    "id": 987,
    "uuid": "a77787f0-5a81-4b13-b7ce-833acc9b35d3",
    "hitokoto": "正气和狂气，理性和知性，自信和确信，在悲剧性的不合理世界，故事开始了。",
    "type": "a",
    "from": "绝园的暴风雨",
    "from_who": null,
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 35
  },
  {
    "id": 988,
    "uuid": "d2d91046-5596-430d-b93b-ad40fadc882f",
    "hitokoto": "将所有人类当成玩偶的神,本身居然也是个小丑啊。",
    "type": "a",
    "from": "Fate/Zero",
    "from_who": "蓝胡子",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 23
  },
  {
    "id": 990,
    "uuid": "60b8f261-bb9e-45ab-a5f8-a20dcef9e13b",
    "hitokoto": "即使想放弃，也没法放弃最想要的东西，这就是人",
    "type": "a",
    "from": "悠久之翼",
    "from_who": "雨宫优子的哥哥",
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 22
  },
  {
    "id": 991,
    "uuid": "84d55d6b-1234-45b9-9f6d-80b5b767e56d",
    "hitokoto": "拿起武器，无论顺从还是逃跑，都无法得到自由，既然如此，我们只能战斗，为了自由，站起来吧。",
    "type": "a",
    "from": "妖精的尾巴",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 44
  },
  {
    "id": 992,
    "uuid": "f865bf7d-9967-4404-a147-a435f6a1dde5",
    "hitokoto": "所谓长大成人，就是不断聚了散，散了又聚。为了让彼此不会受伤害而保持一个适当的距离。",
    "type": "a",
    "from": "新世纪福音战士",
    "from_who": null,
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 41
  },
  {
    "id": 993,
    "uuid": "6383dc29-75af-43b3-83ea-43b63de16652",
    "hitokoto": "如果说怪盗是一个技艺精湛，盗取财宝的艺术家，那么侦探就只是跟在怪盗后面吹毛求疵，充其量不过是个评论家。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 51
  },
  {
    "id": 994,
    "uuid": "3bdf16cc-7636-49da-817f-d920fc550a30",
    "hitokoto": "我不相信人类......但是，我相信人类的“可能性”",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 26
  },
  {
    "id": 995,
    "uuid": "5736dd95-1ad9-46d9-a134-6cdaa5cb6b9a",
    "hitokoto": "即使作为代价要夺走我什么，即使接下来等待我的是什么，即使那样，我无论如何都不想失去他。",
    "type": "a",
    "from": "少年阴阳师",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 43
  },
  {
    "id": 996,
    "uuid": "aa783d28-283b-48ff-9ba3-c4129f559273",
    "hitokoto": "据说之所以有人出现在梦中，是因为对方想见你的心情穿过身体，飞进了你的梦中。",
    "type": "a",
    "from": "蜂蜜与四叶草",
    "from_who": "美和子小姐",
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 37
  },
  {
    "id": 997,
    "uuid": "5196826e-e573-4670-a3fd-c1e347fa4a4d",
    "hitokoto": "好梦向来易醒。",
    "type": "a",
    "from": "风之谷",
    "from_who": "宫崎骏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 7
  },
  {
    "id": 998,
    "uuid": "9dff4038-edb2-454d-93ab-52ce14b94596",
    "hitokoto": "追逐梦想的人比抓住梦想的人更能发挥实力。",
    "type": "a",
    "from": "银魂",
    "from_who": "空知英秋",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 20
  },
  {
    "id": 1000,
    "uuid": "d160f69d-ae5a-4d69-af87-7ba723d470f9",
    "hitokoto": "因为世界并不如你想象的那样坏。",
    "type": "a",
    "from": "无头骑士异闻录",
    "from_who": "塞尔提",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 15
  },
  {
    "id": 1001,
    "uuid": "c36f03d6-062b-43bc-af09-98bb2a0e86a2",
    "hitokoto": "人只会看到自己想看到的、听到自己想听到的，我也并不例外。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 28
  },
  {
    "id": 1002,
    "uuid": "4d81b6a7-1a23-449d-b2d4-0d894f67aa24",
    "hitokoto": "美丽的不是这个世界，而是接受了这个世界的你的眼睛。",
    "type": "a",
    "from": "吸血鬼骑士",
    "from_who": "玖兰枢",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 25
  },
  {
    "id": 1003,
    "uuid": "8ea93cd8-5d72-40e9-8446-f6649b31dba3",
    "hitokoto": "干燥的冷气，尘埃的味道，我在其中……踏上旅途。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": "宫园薰",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 23
  },
  {
    "id": 1004,
    "uuid": "3bb47f23-9dbc-4334-9ce6-1ae1bce2186b",
    "hitokoto": "人总有一天都会死的，但正因为生命是有限的，才能够欢喜和悲伤。",
    "type": "a",
    "from": "通灵王",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 30
  },
  {
    "id": 1005,
    "uuid": "08cffe23-ff9e-40c9-960b-5b853ac3a549",
    "hitokoto": "舞台上演员不能无视剧本随便演，华丽地退场才是完成使命。",
    "type": "a",
    "from": "绝园的暴风雨",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1006,
    "uuid": "9097adda-7029-41a7-b8f4-99adfe5a795c",
    "hitokoto": "只顾着追求新事物，却不回顾历史，怎么会有未来。",
    "type": "a",
    "from": "虞美人盛开的山坡",
    "from_who": "宫崎骏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 23
  },
  {
    "id": 1007,
    "uuid": "c3c6cce4-f56c-4e7c-b9a1-2b2fcfbe2a6d",
    "hitokoto": "为什么妈妈就不明白无所事事的忙碌呢。",
    "type": "a",
    "from": "白熊咖啡屋",
    "from_who": "熊猫君",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1008,
    "uuid": "0e3df75d-0548-421d-af80-d5251b444ac5",
    "hitokoto": "好红，每当想起你，枫叶就会被染红。",
    "type": "a",
    "from": "银仙",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1010,
    "uuid": "1dd8e35a-4470-43a0-a491-bf5b265b22af",
    "hitokoto": "也许正义并非太阳，而是如同星星一般的东西，天空中有无数的星星，彼此不断抵消着其他星星的光芒。",
    "type": "a",
    "from": "亚尔斯兰战纪",
    "from_who": "那尔撒斯",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 46
  },
  {
    "id": 1012,
    "uuid": "fdfe1a00-2ad6-4013-85c9-515064bac4b4",
    "hitokoto": "起风了,唯有努力生存。",
    "type": "a",
    "from": "起风了",
    "from_who": "宫崎骏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 11
  },
  {
    "id": 1014,
    "uuid": "cf79798b-eced-44a5-b2d1-824309f76ace",
    "hitokoto": "走过一段路 回头看 原来那些痛得快要死去的事情是可以一笑而过的。",
    "type": "a",
    "from": "黑子的篮球",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 32
  },
  {
    "id": 1015,
    "uuid": "8d338090-256d-4a6d-b4bd-f67703318cb5",
    "hitokoto": "我们都在梦中，一个叫青春的梦里。梦总有一天会醒来，而回忆会一直闪烁。",
    "type": "a",
    "from": "校园迷糊大王",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 34
  },
  {
    "id": 1016,
    "uuid": "ca36ece2-4c03-49b0-8ac6-d99d4fcb5967",
    "hitokoto": "王冠会让戴上它的人高人一头，是地位的象征。但王冠真正的意义是：当灾难从天而降时，我会为你们抵挡一切，永远让你们只看到金色的希望。",
    "type": "a",
    "from": "星游记",
    "from_who": "约士亚",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 64
  },
  {
    "id": 1017,
    "uuid": "0393408f-5e77-4529-98dd-fe39612e6455",
    "hitokoto": "只要怀着理想而行动，就算结果不尽如人意也没有关系。但是如果失去了理想，那就真的一无所有了，连自己珍视的人都保护不了。",
    "type": "a",
    "from": "境界的彼方",
    "from_who": "鸟居奈古梦",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 58
  },
  {
    "id": 1019,
    "uuid": "f2197794-f66b-4c2a-a31b-b8ff40cc2245",
    "hitokoto": "如果要伤害别人的感情才能实现的话，对那个人来说梦想就已经不能称之为梦想了。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": "小五郎",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 37
  },
  {
    "id": 1020,
    "uuid": "fac6bcfe-ba25-441d-a6b6-5a69ad741152",
    "hitokoto": "我不会忘记，一直，都留在我的心间。",
    "type": "a",
    "from": "文学少女",
    "from_who": "井上心叶",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 17
  },
  {
    "id": 1026,
    "uuid": "5f057f3f-670e-4f78-8b9e-189fdf12c625",
    "hitokoto": "当一个胖纸没有什么不好，最起码可以温暖其他的人。",
    "type": "a",
    "from": "龙猫",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 24
  },
  {
    "id": 1028,
    "uuid": "94022709-2cd7-4240-8c8f-7a2bf97c816f",
    "hitokoto": "是鸣人改变了我！是鸣人的笑脸拯救了我！所以，如果是为了保护鸣人，就算死，我也无可畏惧，因为我，最喜欢鸣人了。",
    "type": "a",
    "from": " 火影忍者",
    "from_who": "日向雏田",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 54
  },
  {
    "id": 1030,
    "uuid": "75f6139e-0444-461a-88da-91d6c3350ac4",
    "hitokoto": "总在不停寻觅你的踪影，无论十字路口抑或梦境之中，明知你不在，却依然不停地找寻。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 39
  },
  {
    "id": 1033,
    "uuid": "2af42df8-8535-4592-95be-527208f3292f",
    "hitokoto": "你受伤的时候，我永远都在。",
    "type": "a",
    "from": "多啦A梦",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 13
  },
  {
    "id": 1034,
    "uuid": "8e9dc39e-9474-4e49-87f6-0a332beae9ed",
    "hitokoto": "在未知的未来将要发生的事，一定有它的意义",
    "type": "a",
    "from": "火影忍者",
    "from_who": "岸本齐史",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 20
  },
  {
    "id": 1036,
    "uuid": "6d304440-b09d-4c56-adf4-6cf61a743c3a",
    "hitokoto": "那只萤火虫在很长很长的时间里都是独自一人生活，甚至忘了自己是只萤火虫。",
    "type": "a",
    "from": "小鸠",
    "from_who": "花户小鸠",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 35
  },
  {
    "id": 1037,
    "uuid": "2ade637a-7625-4cf8-9c78-b4ca6dd11e32",
    "hitokoto": "最近的烦恼是小小的离别带来的寂寞，一瞬间的邂逅与分别，这一个一个的刹那，我想好好珍惜起来。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": "绿川幸",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 45
  },
  {
    "id": 1038,
    "uuid": "706d5757-2a33-40bb-8d91-421ebbc8b1a3",
    "hitokoto": "如果基拉被抓住了，那他就是邪恶，如果基拉统治了世界，那他就是正义。",
    "type": "a",
    "from": "死亡笔记",
    "from_who": "夜神月",
    "creator": "70029304",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 33
  },
  {
    "id": 1040,
    "uuid": "906ad80e-1f56-46d3-87cb-edfe514b14e8",
    "hitokoto": "无论最终的结果是什么，只要这是自己选择的道路。",
    "type": "a",
    "from": "龙与虎",
    "from_who": "竹宫悠由子",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 23
  },
  {
    "id": 1041,
    "uuid": "30f75693-3b0a-403d-b3e0-c4325669ed53",
    "hitokoto": "在面对这些强敌之前...一定要先将眼前敌人逐个打败吧。",
    "type": "a",
    "from": "网球王子",
    "from_who": "越前龙马",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1044,
    "uuid": "55b31eed-ece1-496a-966b-113cdeb6a165",
    "hitokoto": "物转星移，花开花落，周而复始，生生不息，但今昔已非昨日，然今日花容依旧。",
    "type": "a",
    "from": "虫师",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 36
  },
  {
    "id": 1046,
    "uuid": "1d3b2d55-d29f-47a8-9bcb-e8350f454a21",
    "hitokoto": "隐藏的是心中的秘密，照耀两人的是star和snow……",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": "青山刚昌",
    "creator": "1277326952",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1047,
    "uuid": "a73b0851-37e5-4420-9aaf-9a38ec2693b5",
    "hitokoto": "从进入厨房的瞬间开始，你们就肩负着烹饪美食的责任。",
    "type": "a",
    "from": "食戟之灵",
    "from_who": "罗兰·夏佩尔",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 25
  },
  {
    "id": 1049,
    "uuid": "8c92f9bd-f87d-4b6f-a09a-b71e32ee9d40",
    "hitokoto": "生活坏到一定程度就会好起来，因为它无法更坏。",
    "type": "a",
    "from": "龙猫",
    "from_who": "宫崎骏",
    "creator": "70029304",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 22
  },
  {
    "id": 1050,
    "uuid": "636daf35-4905-4659-95f1-8150491af411",
    "hitokoto": "当你决定了要向前迈进的那一刻, 你就已经踏出前进的一步了。",
    "type": "a",
    "from": "Canvas2 ～七彩的素描～",
    "from_who": "F\u0026C FC01",
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 29
  },
  {
    "id": 1051,
    "uuid": "60c0c25b-0787-4f8b-9620-c4f800080b39",
    "hitokoto": "我再也不要看见她哭的样子了，就算我从此从她心目中消失。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": "工藤新一",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1052,
    "uuid": "ce0379e6-4aeb-48b2-8a95-6001ef6bccfe",
    "hitokoto": "无限接近于零，却又不等于零的可能性。",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1054,
    "uuid": "6809a894-3da2-471a-bccd-2439801210e8",
    "hitokoto": "在弱者眼里可能是这样，不过，我的确很强。",
    "type": "a",
    "from": "蔷薇少女",
    "from_who": "PEACH-PIT",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 20
  },
  {
    "id": 1058,
    "uuid": "c2152eed-84f1-43df-b286-6e2f59d86f61",
    "hitokoto": "我无法抗拒泡面这种没营养又廉价的口感。",
    "type": "a",
    "from": "银仙",
    "from_who": "市松小雏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 19
  },
  {
    "id": 1061,
    "uuid": "961bda07-d999-4c7e-a7f7-6f8958011a29",
    "hitokoto": "荣耀就在彼方，遥不可及才要挑战，歌颂霸道，展现霸道，为了守护我背影的臣子。",
    "type": "a",
    "from": "RIDER Fate/Zero",
    "from_who": null,
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 37
  },
  {
    "id": 1062,
    "uuid": "b7931673-5e00-4fc8-a18a-6b1fe4e291ed",
    "hitokoto": "活着本身就是一种价值，因为还有明天。",
    "type": "a",
    "from": "高达",
    "from_who": "雷·扎·巴雷尔",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1064,
    "uuid": "e99b8348-3a8f-4e8a-a410-2b6475579113",
    "hitokoto": "大家互相帮助，一起成功，一起幸福什么的，不过是种理想。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 27
  },
  {
    "id": 1065,
    "uuid": "42aa7a10-ef4e-4cda-8949-d68d53d6bcb7",
    "hitokoto": "话说回来，现充还真是麻烦啊。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 14
  },
  {
    "id": 1066,
    "uuid": "e34570e9-f495-430e-b336-e24490edcd90",
    "hitokoto": "重逢的时候没想到我会这样喜欢他，虽然你不是我交往的第一人，可却是我的初恋，虽然你可能并不知道。",
    "type": "a",
    "from": "世界第一初恋",
    "from_who": "中村春菊",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 47
  },
  {
    "id": 1069,
    "uuid": "aede503a-331e-447a-8ac8-3cd7d81dba1e",
    "hitokoto": "有了喜欢的人，就会在意各种小事，感觉很不自由，但是，为了那些小事左思右想，心里竟然会这么快乐。",
    "type": "a",
    "from": "闪烁的青春",
    "from_who": "吉冈双叶",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 47
  },
  {
    "id": 1070,
    "uuid": "397a1dad-bd9f-42ec-92db-a9dd1fbc7cda",
    "hitokoto": "就算世上有着所谓的“好女人”，也不会有着“和我关系好的女人”。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 31
  },
  {
    "id": 1077,
    "uuid": "9d64cc5c-35c9-4c5d-9501-f0394026f6b0",
    "hitokoto": "必须洗净一切往事，否则你永远无法清楚自由地看这个世界",
    "type": "a",
    "from": "死神",
    "from_who": "黑崎一护",
    "creator": "759578199",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 26
  },
  {
    "id": 1086,
    "uuid": "ac913f74-cee2-4ca9-8a02-0077e83fa942",
    "hitokoto": "己所欲者，杀而夺之，亦同天赐",
    "type": "a",
    "from": "游戏人生",
    "from_who": "阿兹莉尔",
    "creator": "458146168",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 14
  },
  {
    "id": 1087,
    "uuid": "814d5ca4-e985-4a2f-b694-d1d5bde827fc",
    "hitokoto": "即使你已经习惯了受伤害，也有人看了会心疼的。",
    "type": "a",
    "from": "我的恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 22
  },
  {
    "id": 1088,
    "uuid": "67acee2d-ee91-45af-8488-a6e956b5c58c",
    "hitokoto": "这个世界上没有完美的人类，所以，人无法自己一个人活著。",
    "type": "a",
    "from": "不可思议游戏",
    "from_who": "渡濑悠宇",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 27
  },
  {
    "id": 1089,
    "uuid": "52c8b923-4daa-497c-8961-b717d15017ed",
    "hitokoto": "我们会，慢慢长大成人，随着季节的不停变换 路边盛开的鲜花也在不断变化。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 35
  },
  {
    "id": 1090,
    "uuid": "baedd0f6-a609-4b7b-8b8b-6019308d85e7",
    "hitokoto": "只要一天活著,难过的事总有一天会让你笑著说出来。",
    "type": "a",
    "from": "天空之城",
    "from_who": "宫崎骏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 24
  },
  {
    "id": 1091,
    "uuid": "00cb3d6c-f56e-49ac-885a-c4ece96763e6",
    "hitokoto": "命运的红线一旦断了，就再也接不上了。",
    "type": "a",
    "from": "犬夜叉",
    "from_who": "高桥留美子",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 18
  },
  {
    "id": 1093,
    "uuid": "7ad5328b-2a4b-483d-a877-3fa502319aee",
    "hitokoto": "一举一动，都是承诺，会被另一个人看在眼里，记在心上的。",
    "type": "a",
    "from": "悬崖上的金鱼姬",
    "from_who": "宫崎骏",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 27
  },
  {
    "id": 1095,
    "uuid": "2333d345-eb38-42fa-9352-78d5857fb265",
    "hitokoto": "如果你一个人把什么都做完了，那我做什么？",
    "type": "a",
    "from": "元气少女缘结神",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 20
  },
  {
    "id": 1097,
    "uuid": "c0f1b16b-9225-4463-9116-e061885538f9",
    "hitokoto": "在自称善意的之时，即存恶意。",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 14
  },
  {
    "id": 1098,
    "uuid": "bbc3fae3-90b5-46c5-be0e-29205ce963be",
    "hitokoto": "正因为生命有限，所以才显得更重要，正因为生命有限，所以才更应该努力不懈。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": "服部平次",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 36
  },
  {
    "id": 1099,
    "uuid": "2d05be1a-87c0-4578-9f36-8f584b89f870",
    "hitokoto": "总觉得跟你在一起，不管多高的地方都可以到达。",
    "type": "a",
    "from": "网球王子",
    "from_who": "不二周助",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 22
  },
  {
    "id": 1100,
    "uuid": "7754b87d-b1f3-4e64-851b-142056567198",
    "hitokoto": "人这种东西，除了为了永不满足的欲望追求新的刺激之外，也是重视稀少价值之物的奇怪生物。",
    "type": "a",
    "from": "gosick",
    "from_who": "维多利加",
    "creator": "1015964489",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 42
  },
  {
    "id": 1103,
    "uuid": "98f6c3c0-4c9c-4669-a39e-5d79de2ebe48",
    "hitokoto": "那些坚定决心的人们，会展现出好脸色。",
    "type": "a",
    "from": "闪电十一人",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 18
  },
  {
    "id": 1104,
    "uuid": "38bedccc-0976-4636-a207-33c5ffe05bba",
    "hitokoto": "世界不完美 所以才显得美丽",
    "type": "a",
    "from": "钢之炼金术士",
    "from_who": "大佐",
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 13
  },
  {
    "id": 1105,
    "uuid": "2ca1ebfe-3d5f-4333-af5d-1d3e41ced8d7",
    "hitokoto": "即使匍匐在地，也要持续前进，这才是你的作风。现在的你只靠一些漂亮话当借口，在高墙前使性子，不过是个小鬼罢了。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 54
  },
  {
    "id": 1108,
    "uuid": "fafc2df2-744b-44af-b0c9-0977f6170246",
    "hitokoto": "明明喜欢的不得了，可是看到对方幸福洋溢的表情，却觉得很难过、很痛苦，胸口发疼。",
    "type": "a",
    "from": "彩云国物语",
    "from_who": "雪乃纱衣",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 39
  },
  {
    "id": 1110,
    "uuid": "5d0fe0ca-cd74-40a0-bc01-38b571770591",
    "hitokoto": "失望了吗？没错，世上或许有些东西别打开比较好，真正把心打开的人多么麻烦啊！",
    "type": "a",
    "from": "绝望先生",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 37
  },
  {
    "id": 1111,
    "uuid": "efb74b09-8992-471e-a6bf-f85048361652",
    "hitokoto": "哭也不会改变什么，这个世界从来不会对任何人温柔。",
    "type": "a",
    "from": "黑执事",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 24
  },
  {
    "id": 1112,
    "uuid": "011171f1-041a-4923-a1af-f6d6b9519e42",
    "hitokoto": "不论是过去还是未来，我都会保护你！",
    "type": "a",
    "from": "旋风管家",
    "from_who": "凌崎飒",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 17
  },
  {
    "id": 1113,
    "uuid": "9ed7e75a-4969-4168-b4fe-09da4fb46957",
    "hitokoto": "自己的过去会被当做笑话或者捏他的形式，被他人随随便便的共有化。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "比企谷八幡",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 31
  },
  {
    "id": 1114,
    "uuid": "8d8e7a52-44a9-49f9-8ffa-698a26404204",
    "hitokoto": "因为等待的越久，重逢时就越幸福啊。",
    "type": "a",
    "from": "名侦探柯南",
    "from_who": "小兰",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 17
  },
  {
    "id": 1116,
    "uuid": "144dac50-5bf3-4937-a7fd-a0e5167c57ab",
    "hitokoto": "我在时光斑驳深处，聆听到花开的声音。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "863885806",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 18
  },
  {
    "id": 1124,
    "uuid": "99363723-fc29-4eaa-a401-d22ad0acfc71",
    "hitokoto": "神会对努力之人微笑，这是骗人的，但我们偶然会被命运之神垂青。",
    "type": "a",
    "from": "吹响吧！上低音号",
    "from_who": null,
    "creator": "Aure",
    "creator_uid": 196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1483804385",
    "length": 30
  },
  {
    "id": 1126,
    "uuid": "cafdc7c8-f43d-4c1f-a15a-809ab60c6d42",
    "hitokoto": "大国战争之后还会繁荣富强，而只有小国涂炭遭殃，让世界感受痛苦吧。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1483436996",
    "length": 32
  },
  {
    "id": 1129,
    "uuid": "8d3cc356-b1cb-496a-b381-d8c19faccb99",
    "hitokoto": "人生最糟糕的事，一个是饿肚子，一个是孤独。",
    "type": "a",
    "from": "夏日大作战",
    "from_who": null,
    "creator": "Alxtit",
    "creator_uid": 195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1484509309",
    "length": 21
  },
  {
    "id": 1133,
    "uuid": "003e4ebe-59a4-49f1-a35e-69b9051ceabf",
    "hitokoto": "你指尖跳动的电光，是我此生不变的信仰",
    "type": "a",
    "from": "某科学的超电磁炮",
    "from_who": null,
    "creator": "Sωeet、心境",
    "creator_uid": 218,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1485526487",
    "length": 18
  },
  {
    "id": 1135,
    "uuid": "c0cb23ee-5b59-4981-87ca-08429663dbcc",
    "hitokoto": "温柔解救不了这个世界",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "灬花丶葬灬",
    "creator_uid": 230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486337784",
    "length": 10
  },
  {
    "id": 1137,
    "uuid": "7bc5ae09-49fd-43a3-a72b-caf1ce7be8c9",
    "hitokoto": "代你见证世界的终结，来世再续梦之伊甸",
    "type": "a",
    "from": "Eden*/b站弹幕",
    "from_who": null,
    "creator": "Sωeet、心境",
    "creator_uid": 218,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1485526418",
    "length": 18
  },
  {
    "id": 1140,
    "uuid": "847fd80e-7f23-4c19-bf1e-5a054f4d7203",
    "hitokoto": "今日已成往昔，明日即将到来，为此理所当然之事，感到无比痛心。",
    "type": "a",
    "from": "寻找失去的未来",
    "from_who": null,
    "creator": "失われた未来を求めて",
    "creator_uid": 235,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486874567",
    "length": 30
  },
  {
    "id": 1141,
    "uuid": "1902a80a-06d8-4c81-8fab-c36292b0c02a",
    "hitokoto": "我活在我的时间里，她活在她的时间里，因此，我们时间交错的瞬间，对我而言比任何事物都宝贵。",
    "type": "a",
    "from": "她与她的猫",
    "from_who": null,
    "creator": "昔日天明",
    "creator_uid": 232,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486657234",
    "length": 44
  },
  {
    "id": 1147,
    "uuid": "eafc2502-72cb-427d-9e21-a657ba718fda",
    "hitokoto": "人类，在决战之时难道会选择自己不擅长的武器来战斗吗？",
    "type": "a",
    "from": "只有神知道的世界",
    "from_who": null,
    "creator": "darudayu",
    "creator_uid": 136,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1488116376",
    "length": 26
  },
  {
    "id": 1149,
    "uuid": "c242c906-084b-4a07-a4a1-3e97c12dd60d",
    "hitokoto": "这只手，暂时不洗了",
    "type": "a",
    "from": "小林家的龙女仆",
    "from_who": null,
    "creator": "Alxtit",
    "creator_uid": 195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1488899441",
    "length": 9
  },
  {
    "id": 1154,
    "uuid": "6c4047da-0f29-45ec-8e0e-a76d782381c6",
    "hitokoto": "重要的人，不能忘记的人，不想忘记的人。 你，是谁？",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "谬蜀黍",
    "creator_uid": 280,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491019648",
    "length": 25
  },
  {
    "id": 1160,
    "uuid": "0539a336-c2de-4409-9c38-231757023522",
    "hitokoto": "正是在对未来没有任何希望的时候，一个人能坚持到什么地步，才真正体现出这个人有多坚强。",
    "type": "a",
    "from": "来自新世界",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408174",
    "length": 42
  },
  {
    "id": 1161,
    "uuid": "545f1271-1753-4af1-9e4b-b03573c3cbcf",
    "hitokoto": "除了这一颗心，都是你的。",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408100",
    "length": 12
  },
  {
    "id": 1162,
    "uuid": "7be7b46c-2c73-4ff4-aeb1-7535d2288763",
    "hitokoto": "正是因为这一点一滴觉得还有希望的自己，才是最无可救药的吧。",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408083",
    "length": 29
  },
  {
    "id": 1163,
    "uuid": "f4e6c5d1-5538-46b4-8d5f-d4214aca90ac",
    "hitokoto": "我们都很执着,而且思念的越深,越是绝望。",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408062",
    "length": 20
  },
  {
    "id": 1164,
    "uuid": "dce6356b-8413-403d-9976-6f4b06a81087",
    "hitokoto": "一个人觉得寂寞，和另一个人相互依偎又有什么错",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408043",
    "length": 22
  },
  {
    "id": 1165,
    "uuid": "9c12116b-f521-4baf-a23f-ed4ef34e3c09",
    "hitokoto": "想象力足以改变一切。",
    "type": "a",
    "from": "来自新世界",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408194",
    "length": 10
  },
  {
    "id": 1166,
    "uuid": "57e9aa67-4929-4830-8498-623b0c89b8df",
    "hitokoto": "越是珍惜呆在这里的时间，今后就越是悲伤吧。但是我认为不能称之为「后悔」。",
    "type": "a",
    "from": "小林家的龙女仆",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408446",
    "length": 36
  },
  {
    "id": 1167,
    "uuid": "ef38ad8f-7e66-45bd-bf1c-cffc6a80157a",
    "hitokoto": "大部分人并不想长大，只是没办法继续当一个小孩子",
    "type": "a",
    "from": "小林家的龙女仆",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491408481",
    "length": 23
  },
  {
    "id": 1168,
    "uuid": "4f4a539e-464d-4e1d-b220-b7680b78b22a",
    "hitokoto": "不得了不得了",
    "type": "a",
    "from": "小林家的龙女仆",
    "from_who": null,
    "creator": "Alxtit",
    "creator_uid": 195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491464699",
    "length": 6
  },
  {
    "id": 1173,
    "uuid": "fdb02641-61db-4439-b997-8176bb219901",
    "hitokoto": "你已经不是我的狗了。",
    "type": "a",
    "from": "龙与虎",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1492136873",
    "length": 10
  },
  {
    "id": 1175,
    "uuid": "f3ef9294-0be7-4009-9144-c8f64ae3002a",
    "hitokoto": "正因为有忘也忘不了的回忆，才会变得坚强，这就是所谓的成长吧！",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "木无本心",
    "creator_uid": 360,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1494239990",
    "length": 30
  },
  {
    "id": 1176,
    "uuid": "c958fe96-61c0-46ff-97b0-760726dd04dd",
    "hitokoto": "其实我对混合咖啡还是很有自信的",
    "type": "a",
    "from": "珈百璃的堕落",
    "from_who": null,
    "creator": "gyming",
    "creator_uid": 330,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1493602670",
    "length": 15
  },
  {
    "id": 1196,
    "uuid": "473a2018-7cb4-4365-bb15-69c25eaf259f",
    "hitokoto": "如果当初握住的不是硬币，而是勇者的手......",
    "type": "a",
    "from": "中二病也要谈恋爱 恋！",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499181144",
    "length": 24
  },
  {
    "id": 1199,
    "uuid": "34accf4f-78f6-4a2a-b0f3-137900db7633",
    "hitokoto": "只要是正义的一方，无论手段多么卑鄙都可以被原谅",
    "type": "a",
    "from": "东京喰种",
    "from_who": null,
    "creator": "Itsusinn",
    "creator_uid": 444,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498827137",
    "length": 23
  },
  {
    "id": 1201,
    "uuid": "c50e81b9-ac96-4806-84f3-4457fd742b16",
    "hitokoto": "你偶尔也该回头看看，那些在你身后的人，说不定已经追到你脚边了！！！",
    "type": "a",
    "from": "妖精的尾巴",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499180903",
    "length": 33
  },
  {
    "id": 1202,
    "uuid": "9ff97b0b-4661-43e3-8bcd-846f998347f1",
    "hitokoto": "因为喜欢你，所以想继续相信下去。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499590379",
    "length": 16
  },
  {
    "id": 1206,
    "uuid": "4527eb60-c90a-4154-8acf-a7bc4e4e2e83",
    "hitokoto": "自杀是没有理由的，只是今天没有飞起来罢了。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499570747",
    "length": 21
  },
  {
    "id": 1207,
    "uuid": "9ba5977a-d5a4-46e2-9e93-1bc3810ae850",
    "hitokoto": "听说，樱花花瓣飘落的速度，是每秒5厘米，思念的距离到底有多远。如果樱花下落时是有声音的，你会不会听到我对你的思念",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "zivi",
    "creator_uid": 450,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499181028",
    "length": 56
  },
  {
    "id": 1208,
    "uuid": "ce77c36d-20e4-48ec-a536-1557e4957fd8",
    "hitokoto": "在下雪时。第一次相会时。雪白的夜与漆黑的伞。只要有你在身边。只要你露出微笑。就是幸福。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499571895",
    "length": 43
  },
  {
    "id": 1210,
    "uuid": "8b9e19a9-e3e0-42db-9770-1e9b889d3bb9",
    "hitokoto": "身体被冻僵了，仅有吐出的气息略带热度。望着彼此即将停止的心脏鼓动。 然后，极为珍惜的记忆随即就会消失而化为眷恋。",
    "type": "a",
    "from": "空之境界",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499571219",
    "length": 56
  },
  {
    "id": 1211,
    "uuid": "41d41e5d-fc2c-4677-8f70-b20d0649564d",
    "hitokoto": "对于虚伪而言，真实的光明或许过于耀眼了",
    "type": "a",
    "from": "蔷薇少女",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499853277",
    "length": 19
  },
  {
    "id": 1219,
    "uuid": "c7c5ac0e-7b52-404d-80b9-5b7f91e779be",
    "hitokoto": "好了 接下来就让你们见识一下程序员的本事",
    "type": "a",
    "from": "骑士与魔法",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501599965",
    "length": 20
  },
  {
    "id": 1220,
    "uuid": "3b6956a3-2aad-4613-bb20-1292f22edb75",
    "hitokoto": "如果结果不如你所愿，就在尘埃落定前奋力一搏。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842170",
    "length": 22
  },
  {
    "id": 1221,
    "uuid": "839f23cc-01bd-4d41-932e-e48711811cbe",
    "hitokoto": "如果因为害怕失败，而不去努力，那就不会有能够成功的人。",
    "type": "a",
    "from": "樱花庄的宠物女孩",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842008",
    "length": 27
  },
  {
    "id": 1222,
    "uuid": "a858e716-49fe-460e-81ce-444444d092e3",
    "hitokoto": "你一直相信的事，也让我相信吧。活着，是件美好的事。",
    "type": "a",
    "from": "Angle Beats",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842068",
    "length": 25
  },
  {
    "id": 1223,
    "uuid": "93389443-3819-4556-a7c9-454b9137f411",
    "hitokoto": "我只希望，我喜欢的人可以健康的活着。",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842142",
    "length": 18
  },
  {
    "id": 1224,
    "uuid": "b2834ef3-ee81-4dd0-bbd5-53119ebfa6d5",
    "hitokoto": "正因为生来什么都没有，因此我们能拥有一切。",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842190",
    "length": 21
  },
  {
    "id": 1225,
    "uuid": "9735072b-531a-47e7-a3a5-1cac23b2a1dd",
    "hitokoto": "未来的事无人知晓，所以它才如同这重逢一般，拥有着无限的可能性。",
    "type": "a",
    "from": "命运石之门",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842367",
    "length": 31
  },
  {
    "id": 1226,
    "uuid": "8825b777-975e-473c-934f-72039bf15353",
    "hitokoto": "只要努力活下去，总有一天会笑着回忆。",
    "type": "a",
    "from": "不可思议游戏",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501842528",
    "length": 18
  },
  {
    "id": 1227,
    "uuid": "c92d843e-6d17-42d8-927e-0f6756532b8b",
    "hitokoto": "想说什么就说，想做什么就做，我们不就是这么一直过来的吗？",
    "type": "a",
    "from": "LoveLive!",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502447520",
    "length": 28
  },
  {
    "id": 1228,
    "uuid": "ca3f18c0-ee8f-4d7b-8076-83d2140e28ec",
    "hitokoto": "也许一个人的快乐会建立在另一个人或者很多人的痛苦之上。但是，自己种下的祸根终有一天会报应在自己的身上的。",
    "type": "a",
    "from": "地狱少女",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502447563",
    "length": 52
  },
  {
    "id": 1229,
    "uuid": "d48564b0-661a-44c1-ab1a-ffbccfede6d5",
    "hitokoto": "何必去在意自己与别人相比是否特别呢？即便只有一个人也好。只要有一个认为自己特别的人，我觉得那就足够了。",
    "type": "a",
    "from": "冰菓",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502447578",
    "length": 51
  },
  {
    "id": 1230,
    "uuid": "ce062027-651c-4fbc-b498-c62267e8014a",
    "hitokoto": "虚伪的眼泪，会伤害别人，虚伪的笑容，会伤害自己。",
    "type": "a",
    "from": "叛逆的鲁鲁修",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502447596",
    "length": 24
  },
  {
    "id": 1231,
    "uuid": "2e722533-abc4-4079-8520-542c2de02781",
    "hitokoto": "空太是笨蛋！",
    "type": "a",
    "from": "樱花庄的宠物女孩",
    "from_who": null,
    "creator": "Mashirozx",
    "creator_uid": 441,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502815879",
    "length": 6
  },
  {
    "id": 1232,
    "uuid": "5b221bec-d07b-45a4-ad51-ff3426a40c30",
    "hitokoto": "不敢反抗压迫的心理将伴你一生",
    "type": "a",
    "from": "狂赌深渊",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502859469",
    "length": 14
  },
  {
    "id": 1235,
    "uuid": "c5abf073-85ea-4fae-9e73-fb8086cb3dd9",
    "hitokoto": "未来的旅程是如此遥远，能见到的光明却是如此稀少。即使如此——我仍然没有完全放弃希望。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "普通的雾雨魔法使",
    "creator_uid": 481,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1502447790",
    "length": 42
  },
  {
    "id": 1238,
    "uuid": "fdd17dad-3aff-431c-a2a8-6c8893b6b3ad",
    "hitokoto": "契约者不会做梦。",
    "type": "a",
    "from": "黑之契约者",
    "from_who": null,
    "creator": "lemonoil",
    "creator_uid": 505,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1503143868",
    "length": 8
  },
  {
    "id": 1240,
    "uuid": "455d2f0b-09aa-4f06-ae73-40605cd984f2",
    "hitokoto": "不可结缘",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Stogov",
    "creator_uid": 522,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1504707802",
    "length": 4
  },
  {
    "id": 1242,
    "uuid": "390f5cea-6acb-4da5-8cb1-76244873ee08",
    "hitokoto": "去做你喜欢做的事吧 这就是所谓的那啥...青春嘛",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505309829",
    "length": 24
  },
  {
    "id": 1244,
    "uuid": "6efeaae7-28ec-4146-aa93-f807c8b9063d",
    "hitokoto": "重要的感情总是非常单纯 自然脱口而出的",
    "type": "a",
    "from": "GAMERS电玩咖！",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505309790",
    "length": 19
  },
  {
    "id": 1249,
    "uuid": "0eb7901e-3dce-414a-a543-31900093b62b",
    "hitokoto": "This is your dream! Anything you can do in your dreams, you can do now!",
    "type": "a",
    "from": "My Little Pony: Friendship is Magic",
    "from_who": null,
    "creator": "VKorpela",
    "creator_uid": 536,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505905736",
    "length": 71
  },
  {
    "id": 1251,
    "uuid": "2bf2efb8-f6ab-4d11-aa8a-e77b986454c9",
    "hitokoto": "What about super-ultra-extreme-awesomazing?",
    "type": "a",
    "from": "My Little Pony: Friendship is Magic",
    "from_who": null,
    "creator": "VKorpela",
    "creator_uid": 536,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505905521",
    "length": 43
  },
  {
    "id": 1252,
    "uuid": "6e7e58a3-6254-4aba-9a41-898e659c56bb",
    "hitokoto": "We've learned that friendship isn't always easy, but there's no doubt it's worth fighting for!",
    "type": "a",
    "from": "My Little Pony: Friendship is Magic",
    "from_who": null,
    "creator": "VKorpela",
    "creator_uid": 536,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1505905587",
    "length": 94
  },
  {
    "id": 1258,
    "uuid": "c46da177-57ca-4f5f-a1a6-f98323e6a4dc",
    "hitokoto": "今宵之月，绝不西沉。只此美梦，不再苏醒。从今往后，生生世世，长相厮守，为你立誓。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1506672639",
    "length": 40
  },
  {
    "id": 1271,
    "uuid": "1dbe184a-7a1e-4d1a-8ca5-de84832ddef0",
    "hitokoto": "打架这玩意，不就是为了守护什么东西吗？",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1507263881",
    "length": 19
  },
  {
    "id": 1275,
    "uuid": "0b38e688-5495-484a-a4d1-b2a8cf7acaab",
    "hitokoto": "届けて— 切なさには 名前をつけようか“Snow halation”",
    "type": "a",
    "from": "Snow Halation",
    "from_who": null,
    "creator": "infinityedge",
    "creator_uid": 606,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1508754873",
    "length": 34
  },
  {
    "id": 1320,
    "uuid": "876cbd0d-e98e-4718-a7b6-e3a93312a65b",
    "hitokoto": "我是想被包养，但不会接受施舍",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889613",
    "length": 14
  },
  {
    "id": 1324,
    "uuid": "08f56ef2-f026-4095-8e72-b4de23274114",
    "hitokoto": "善于破坏气氛的人，不仅能破坏好的气氛，其实也能把坏的气氛破坏掉。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889577",
    "length": 32
  },
  {
    "id": 1326,
    "uuid": "37d409b3-fe26-4024-9b82-d15fa3c13f82",
    "hitokoto": "为什么要称赞他人？那是为了把对方捧到更高的地方更容易绊他的脚，为了把他从高处摔下来。这就叫做称赞杀人法。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889128",
    "length": 52
  },
  {
    "id": 1328,
    "uuid": "2a1573d0-6b7f-44ee-9827-f549d999b027",
    "hitokoto": "女生口中的「好人」首先百分之百是「怎样都好的人」的意思，再好也不过止于「方便好使的人」。也就是说，不管怎样都是没戏了",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "小埋233",
    "creator_uid": 910,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512889170",
    "length": 58
  },
  {
    "id": 1330,
    "uuid": "4b983d4b-de1c-422c-8a85-3e1d1b46f1d0",
    "hitokoto": "夜晚还远远没有结束!",
    "type": "a",
    "from": "春宵苦短，少女前进吧！",
    "from_who": null,
    "creator": "hbybyyang",
    "creator_uid": 954,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513549698",
    "length": 10
  },
  {
    "id": 1333,
    "uuid": "f8c57a69-5d5d-4156-b3ef-a8bb1f383d3d",
    "hitokoto": "只要世间有酒,我就喝不够!",
    "type": "a",
    "from": "春宵苦短，少女前进吧！",
    "from_who": null,
    "creator": "hbybyyang",
    "creator_uid": 954,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513549671",
    "length": 13
  },
  {
    "id": 1335,
    "uuid": "96d3145d-c2ab-4bf8-87db-21c4eb900df9",
    "hitokoto": "如果我们能活着出去，千山万水，你愿意陪我一起看吗？",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "浥轻尘i",
    "creator_uid": 759,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513907508",
    "length": 25
  },
  {
    "id": 1341,
    "uuid": "6600d178-4efe-44b7-963d-30fd0add8c75",
    "hitokoto": "不可结缘,徒增寂寞",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "玉狐",
    "creator_uid": 1000,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514702882",
    "length": 9
  },
  {
    "id": 1347,
    "uuid": "73929516-ddbd-46b4-a024-bfdba0215bf9",
    "hitokoto": "就算世界终结，也无所谓",
    "type": "a",
    "from": "少女终末旅行",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515558198",
    "length": 11
  },
  {
    "id": 1353,
    "uuid": "ce3194d3-3940-4a57-bf94-e698722b9a47",
    "hitokoto": "遇到事情不能坐以待毙！",
    "type": "a",
    "from": "捷德奥特曼",
    "from_who": null,
    "creator": "海神修罗神哈斯石酒",
    "creator_uid": 1027,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515328239",
    "length": 11
  },
  {
    "id": 1356,
    "uuid": "b6d4a2ab-2c3e-4073-8c21-d1d0ed802936",
    "hitokoto": "为了爱，与梦想！",
    "type": "a",
    "from": "眼大人",
    "from_who": null,
    "creator": "EntropyIncreaser",
    "creator_uid": 1153,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1518501038",
    "length": 8
  },
  {
    "id": 1364,
    "uuid": "f0c390a0-6870-40f1-a2a9-e56e8e6a1b1f",
    "hitokoto": "今日的余晖和你最后那天给我的拥抱，同一个温度",
    "type": "a",
    "from": "Myself",
    "from_who": null,
    "creator": "一言",
    "creator_uid": 204,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1517391570",
    "length": 22
  },
  {
    "id": 1365,
    "uuid": "d5525997-75ba-42d6-9f7c-751dc2b58dd5",
    "hitokoto": "想和你重新认识一次 从你叫什么名字说起。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "sakura",
    "creator_uid": 1066,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516376784",
    "length": 20
  },
  {
    "id": 1369,
    "uuid": "240b1a00-cda8-4534-ac09-0ff54580502a",
    "hitokoto": "只要记住你的名字，不管你在世界的哪个地方 ，我一定会，去见你。",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "sakura",
    "creator_uid": 1066,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516376809",
    "length": 31
  },
  {
    "id": 1374,
    "uuid": "8dab57df-c45d-4f82-9e25-ba4d89a27fd2",
    "hitokoto": "和绝望，和睦相处",
    "type": "a",
    "from": "少女终末旅行",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516254763",
    "length": 8
  },
  {
    "id": 1380,
    "uuid": "57a3901f-75c6-412a-959b-52361d53d63d",
    "hitokoto": "愿你有一天，能与你最重要的人重逢",
    "type": "a",
    "from": "可塑性记忆",
    "from_who": null,
    "creator": "Little_Qiu",
    "creator_uid": 1032,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519404787",
    "length": 16
  },
  {
    "id": 1385,
    "uuid": "a00cd7a7-0fec-48c9-967b-b88abb556386",
    "hitokoto": "不相信人咬不到肚脐的，咬破肚脐去死如何？",
    "type": "a",
    "from": "海猫鸣泣之时",
    "from_who": null,
    "creator": "凌小雅",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1318780541000",
    "length": 20
  },
  {
    "id": 1386,
    "uuid": "02ac9cfa-ef9c-4ddb-bdba-c138accb565d",
    "hitokoto": "梦想是否无聊并不是别人来决定的，不管是什么样的梦想，自己拼命努力去追寻才是最重要的。",
    "type": "a",
    "from": "守护甜心",
    "from_who": null,
    "creator": "默默然",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1320425511000",
    "length": 42
  },
  {
    "id": 1388,
    "uuid": "42ba065b-d0f5-43ab-8658-9cdd35653b63",
    "hitokoto": "倘若只是为了驱赶心中的寂寞，找谁都可以的。",
    "type": "a",
    "from": "秒速5厘米",
    "from_who": null,
    "creator": "ggdog",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1365256248000",
    "length": 21
  },
  {
    "id": 1389,
    "uuid": "492f8a6b-2140-4432-ab59-79058c6c4154",
    "hitokoto": "什么都无法舍弃的人，什么都无法改变 。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "空城‘’旧梦",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1369475607000",
    "length": 19
  },
  {
    "id": 1392,
    "uuid": "e18b3831-03a5-4913-9bf4-6a931f9a4545",
    "hitokoto": "比希望更炙热，比绝望更深邃，这就是爱啊。",
    "type": "a",
    "from": "魔法少女小圆-叛逆的物语",
    "from_who": null,
    "creator": "chaucerling",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1396520240000",
    "length": 20
  },
  {
    "id": 1393,
    "uuid": "af3e65d5-b140-47d1-85c6-7b44e1f87813",
    "hitokoto": "我们都在命运之湖上荡舟划桨，波浪起伏着而我们无法逃脱孤航。但是假使我们迷失了方向，波浪将指引我们穿越另一天的曙光。",
    "type": "a",
    "from": "死神",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319122651000",
    "length": 57
  },
  {
    "id": 1394,
    "uuid": "f6d4d652-4966-4680-84ea-c958e578ad4c",
    "hitokoto": "懂得认输是非常重要的，不尝到失败的不甘，也就不会明白跌倒后怎么爬起来，更不可能再向前迈进。",
    "type": "a",
    "from": "笨蛋测验召唤兽",
    "from_who": null,
    "creator": "世风",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319941006000",
    "length": 45
  },
  {
    "id": 1395,
    "uuid": "6f6b0fbf-cd19-45d9-be32-21f21832cfd2",
    "hitokoto": "重要的不是你做了多少事，而是你放了多少心思进去。",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319974786000",
    "length": 24
  },
  {
    "id": 1396,
    "uuid": "b962f13d-2f11-4c5b-a75b-030413702a64",
    "hitokoto": "就算是自私⋯⋯我也希望那些人能够永远都有笑容⋯⋯",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319300372000",
    "length": 24
  },
  {
    "id": 1403,
    "uuid": "1afe82f1-3d67-483b-a7fa-babb9290cca6",
    "hitokoto": "相信十年后的八月，我们还会相遇。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1411796620000",
    "length": 16
  },
  {
    "id": 1405,
    "uuid": "6f6b6edd-1d54-45b9-91fb-e95a89eb2fdd",
    "hitokoto": "男人就应该保持冷静，沸腾的水只会被蒸发掉。",
    "type": "a",
    "from": "假面骑士kabuto",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319248277000",
    "length": 21
  },
  {
    "id": 1407,
    "uuid": "5556102d-e686-4676-ae41-07b6f0c758bd",
    "hitokoto": "不管看到什么样的过去，都请不要迷失自己，不管你变成什么样子，我都是你的同伴。",
    "type": "a",
    "from": "angel beats",
    "from_who": null,
    "creator": "魅影陌客",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1320044209000",
    "length": 38
  },
  {
    "id": 1408,
    "uuid": "e8372b46-a03e-4158-ade0-292500438af8",
    "hitokoto": "想要试着去相互接近，但最后还是无法敞开心扉，结果就是擦肩而过⋯⋯",
    "type": "a",
    "from": "文学少女",
    "from_who": null,
    "creator": "芽衣洛",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1319898383000",
    "length": 32
  },
  {
    "id": 1409,
    "uuid": "8692e17e-3d1e-45e7-bae7-8671bb814c40",
    "hitokoto": "不能逃避，不能逃避，不能逃避，不能逃避⋯⋯",
    "type": "a",
    "from": "EVA",
    "from_who": null,
    "creator": "憾天之泪",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1318779803000",
    "length": 21
  },
  {
    "id": 3602,
    "uuid": "f767d4fd-f0b6-4e7b-9bfa-6e42869fa731",
    "hitokoto": "我终不能改变那个开始，何不忘了那个结局呢。",
    "type": "a",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579315",
    "length": 21
  },
  {
    "id": 3604,
    "uuid": "3ea7c0fc-bb34-4d48-8e01-c1ec2a1b7d06",
    "hitokoto": "因为我想活着，我不能掩藏我心中的本欲，正如我心中爱你美丽,又怎能嘴上装四大皆空。",
    "type": "a",
    "from": "悟空传",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579444",
    "length": 40
  },
  {
    "id": 3613,
    "uuid": "d9e2cbe1-02b9-460d-9f29-0ee4d13eb3c4",
    "hitokoto": "这短短的一生，我们最终都会失去。你不妨大胆一些，爱一个人，攀一座山，追一个梦。",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523579782",
    "length": 39
  },
  {
    "id": 3618,
    "uuid": "9be80936-2d67-4388-955e-440b65e4df25",
    "hitokoto": "出来吧，刻刻帝！",
    "type": "a",
    "from": "时崎狂三",
    "from_who": null,
    "creator": "lausanne",
    "creator_uid": 1398,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523785210",
    "length": 8
  },
  {
    "id": 3619,
    "uuid": "0f2728a7-d965-4672-8237-c0aa79bed5f7",
    "hitokoto": "翠星石最喜欢苍星石的说,所以到死也要在一起的说...",
    "type": "a",
    "from": "Rozen Maiden",
    "from_who": null,
    "creator": "beynix",
    "creator_uid": 1386,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523961472",
    "length": 26
  },
  {
    "id": 3620,
    "uuid": "95a2c300-db98-4ada-afb6-5fb863b1ae58",
    "hitokoto": "都是时辰的错！",
    "type": "a",
    "from": "Fate/Zero",
    "from_who": null,
    "creator": "Yae Sakura",
    "creator_uid": 1424,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1524325851",
    "length": 7
  },
  {
    "id": 3623,
    "uuid": "82048caf-cab1-45ec-930a-8cd589568017",
    "hitokoto": "鸣神の　少しとよみて　さし昙り　雨も降らんか　君を留めん",
    "type": "a",
    "from": "言叶之庭",
    "from_who": null,
    "creator": "lausanne",
    "creator_uid": 1398,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1524876359",
    "length": 28
  },
  {
    "id": 3624,
    "uuid": "89b61cdc-ec5e-42e1-b4fe-15977a04b531",
    "hitokoto": "所谓爱情，是对对自己最重要的人，以慈悲的心保护他的想法。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1524826796",
    "length": 28
  },
  {
    "id": 3625,
    "uuid": "9c5e4cf7-a7aa-4520-bb12-3a53e03cae7d",
    "hitokoto": "旅行唯有出发前最愉快，狗儿唯有叫声最吓人，女人唯有背影最美丽。",
    "type": "a",
    "from": "狼与香辛料",
    "from_who": null,
    "creator": "Null",
    "creator_uid": 1457,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1525249964",
    "length": 31
  },
  {
    "id": 3627,
    "uuid": "cdfa8a70-151d-4f87-b9a6-a2a841e101c8",
    "hitokoto": "让我们开始我们的约会（战争）吧",
    "type": "a",
    "from": "约会大作战",
    "from_who": null,
    "creator": "lausanne",
    "creator_uid": 1398,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523785001",
    "length": 15
  },
  {
    "id": 3636,
    "uuid": "38850a63-99ed-4e4e-b79a-cf90fd917f5f",
    "hitokoto": "连我爸都没打过我",
    "type": "a",
    "from": "高达0079",
    "from_who": null,
    "creator": "pandora",
    "creator_uid": 1540,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527069702",
    "length": 8
  },
  {
    "id": 3637,
    "uuid": "473ccfc9-6a1b-4bad-bdb1-7a956ac8060d",
    "hitokoto": "这是你所不能理解的，人类感情的极致，比希望更热烈，比绝望更深邃——爱！",
    "type": "a",
    "from": "魔法少女小圆新篇 叛逆的物语",
    "from_who": null,
    "creator": "pandora",
    "creator_uid": 1540,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527069895",
    "length": 35
  },
  {
    "id": 3639,
    "uuid": "a04e1fa5-d796-496f-913e-d3b1b4d334b7",
    "hitokoto": "What, so everyone's supposed to sleep every single night now? You realize that nighttime makes up half of all time?",
    "type": "a",
    "from": "Rick",
    "from_who": null,
    "creator": "zP1nG",
    "creator_uid": 1547,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527205085",
    "length": 115
  },
  {
    "id": 3641,
    "uuid": "8790d8f0-cd6c-4d35-902d-a75924c392c2",
    "hitokoto": "人生没有彩排，只有现场直播，所以做最好的自己。",
    "type": "a",
    "from": "Internet",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1527570492",
    "length": 23
  },
  {
    "id": 3655,
    "uuid": "a2636212-0517-410b-869e-40036aa45121",
    "hitokoto": "对自己有自信时，不能对别人说「期待」。所谓的「期待」是放弃时的托词，因为别无选择。若缺少这种无奈感，这个词就太虚伪了。",
    "type": "a",
    "from": "冰菓",
    "from_who": null,
    "creator": "acht",
    "creator_uid": 1598,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528206445",
    "length": 59
  },
  {
    "id": 3659,
    "uuid": "66417b9e-c9ec-4be4-b3d8-24d320faa012",
    "hitokoto": "人难免伤害别人,也难免受伤,不过,人是不会轻易讨厌别人的.",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528673600",
    "length": 29
  },
  {
    "id": 3660,
    "uuid": "c85a18ba-f068-4198-9def-d1a24d4ff1e4",
    "hitokoto": "以智者之名，为愚者代辩。",
    "type": "a",
    "from": "Gosick",
    "from_who": null,
    "creator": "acht",
    "creator_uid": 1598,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529118900",
    "length": 12
  },
  {
    "id": 3661,
    "uuid": "1f5d20aa-9725-43b0-be2f-848edbe45e65",
    "hitokoto": "清算，终将到来。",
    "type": "a",
    "from": "Stellaris",
    "from_who": null,
    "creator": "aziint",
    "creator_uid": 1586,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1528867430",
    "length": 8
  },
  {
    "id": 3663,
    "uuid": "5dfc1010-934c-45b0-bd2a-95feb9f09442",
    "hitokoto": "据说啊 叹气会让幸福溜走的",
    "type": "a",
    "from": "再见了 我们的幼儿园",
    "from_who": null,
    "creator": "xcyz",
    "creator_uid": 1674,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529681514",
    "length": 13
  },
  {
    "id": 3665,
    "uuid": "c56edfa3-61e6-4a0b-b7e0-2f9d08a5e363",
    "hitokoto": "你将不再是道具，而是人如其名的人。",
    "type": "a",
    "from": "紫罗兰永恒的花园",
    "from_who": null,
    "creator": "lore",
    "creator_uid": 1681,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529747498",
    "length": 17
  },
  {
    "id": 3670,
    "uuid": "60032758-690e-4bdf-8c99-2dc3bdf70b11",
    "hitokoto": "人没有回忆是无法活下去的哟",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529320276",
    "length": 13
  },
  {
    "id": 3677,
    "uuid": "48f8afae-120b-4336-bb5c-e8f5ef538244",
    "hitokoto": "只要万事俱备，就能一直保持冷静，无论发生什么事，都不会害怕。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530238125",
    "length": 30
  },
  {
    "id": 3681,
    "uuid": "3ae888ff-b48c-485c-bb31-b6f33f04b56f",
    "hitokoto": "正因为不会发生，人们才称它为”奇迹“",
    "type": "a",
    "from": "KANON",
    "from_who": null,
    "creator": "冰茶",
    "creator_uid": 1730,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530607435",
    "length": 18
  },
  {
    "id": 3693,
    "uuid": "db7022da-d4c4-4a9c-ba10-2efc39884b01",
    "hitokoto": "我想成为一个温柔的人,因为曾被温柔的人那样对待,深深了解那种被温柔相待的感觉。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "一叶",
    "creator_uid": 1756,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531110521",
    "length": 39
  },
  {
    "id": 3697,
    "uuid": "39ca23a3-950b-4f09-936c-49bf5a7f68fc",
    "hitokoto": "我喜欢的人…也能喜欢上自己，我认为这就是奇迹。",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530183116",
    "length": 23
  },
  {
    "id": 3699,
    "uuid": "ba0cf4da-4b24-43ef-ae31-b8632dfe0ddf",
    "hitokoto": "大圣此去欲何? 踏南天，碎凌霄！若一去不回.... 便一去不回！",
    "type": "a",
    "from": "影视",
    "from_who": null,
    "creator": "SugerDS",
    "creator_uid": 1669,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529658275",
    "length": 32
  },
  {
    "id": 3720,
    "uuid": "895a8515-9bb4-4b30-bd3a-75a6971f3d40",
    "hitokoto": "我们一直在离别中，比如和爱的人，和伤害，甚至和时光。",
    "type": "a",
    "from": "萤火虫之墓",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532819547",
    "length": 26
  },
  {
    "id": 3728,
    "uuid": "8a03d5a4-0b9e-4ec0-8587-78176f2d7ab9",
    "hitokoto": "至少恋爱不是种机会，我认为它是一种意志。",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182867",
    "length": 20
  },
  {
    "id": 3729,
    "uuid": "2ab23590-ddc7-4938-8b16-cc84fd981a2f",
    "hitokoto": "幸福感就如沉积在悲哀之河底下 隐隐发光的金砂",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182840",
    "length": 22
  },
  {
    "id": 3730,
    "uuid": "6a4859d2-90dd-470c-b888-8042b77e8957",
    "hitokoto": "有样东西是其他生物绝对没有，只有人类才有 那就是人有秘密。",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182882",
    "length": 29
  },
  {
    "id": 3731,
    "uuid": "1ccc2b74-5451-495d-83fb-76dac23cf0aa",
    "hitokoto": "爱一定存在于世上 一定存在 无从寻觅的是爱的表现 是它的表达方式",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182894",
    "length": 32
  },
  {
    "id": 3732,
    "uuid": "dca821b4-c6a8-4599-8ff5-e69415ffe938",
    "hitokoto": "把同班的可爱女同学娶回家就是我最大的梦想",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182943",
    "length": 20
  },
  {
    "id": 3733,
    "uuid": "8fa19686-0752-4a10-b652-05132ef123d6",
    "hitokoto": "在狂热思绪下喊出的爱情宣言中，存在着爱情的实体",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182962",
    "length": 23
  },
  {
    "id": 3734,
    "uuid": "33268eaf-e6e6-49ad-8651-7fb312e5fbfb",
    "hitokoto": "回首前尘，尽是可耻的过往",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530182995",
    "length": 12
  },
  {
    "id": 3735,
    "uuid": "ea49479a-c342-4678-b29d-3fab39a1ce20",
    "hitokoto": "月色如水，虽不如阳光般耀眼，但我的眼中却只有比那月色更可爱的你。心跳不知不觉中加速，嘴角也绷不住那溢出来的幸福笑意。月色确实醉人，却是因为你才显得更美",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530183160",
    "length": 75
  },
  {
    "id": 3736,
    "uuid": "c6aba05c-ef6a-4f55-931d-3fd3f6fc91bc",
    "hitokoto": "“不管你我相距多远，我都想告诉你 我对你的心意不会变，给即将去到陌生城市的你 ，我永远喜欢你”",
    "type": "a",
    "from": "月色真美",
    "from_who": null,
    "creator": "Jerx2y",
    "creator_uid": 1709,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530183259",
    "length": 47
  },
  {
    "id": 3737,
    "uuid": "f874dcb2-4ca2-457d-9609-a079aac94af4",
    "hitokoto": "我们人是需要吃饭、工作和休息的生物，只要满足了其中一项，其他两项也会逐渐满足，而当这三项都满足后，就会得到强烈的存在感。",
    "type": "a",
    "from": "银魂",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530672522",
    "length": 60
  },
  {
    "id": 3745,
    "uuid": "f966258c-461d-441e-bc8d-71a113c0cf4c",
    "hitokoto": "看来这世界 似乎还想要驯服我 那就如你所愿吧 我会美丽地挣扎到底",
    "type": "a",
    "from": "你的名字",
    "from_who": null,
    "creator": "fbhou",
    "creator_uid": 1778,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532078714",
    "length": 32
  },
  {
    "id": 3747,
    "uuid": "97527f0d-904a-4952-8fc4-8f9b6955db05",
    "hitokoto": "如果，樱花掉落的速度是每秒5厘米，那么两颗心需要多久才能靠近？",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "绯色",
    "creator_uid": 1821,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532490109",
    "length": 31
  },
  {
    "id": 3748,
    "uuid": "c0e9eb76-9bce-46f0-af8e-87787b58e64d",
    "hitokoto": "坐上与学校相反方向的电车，展开没有目标的旅行，去往那从未见过的地方",
    "type": "a",
    "from": "比宇宙更远的地方",
    "from_who": null,
    "creator": "fbhou",
    "creator_uid": 1778,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532078580",
    "length": 33
  },
  {
    "id": 3751,
    "uuid": "78134832-742f-44a8-a0e3-da2bfb463b33",
    "hitokoto": "不是为了战斗而活着，而是为了活着而战斗。",
    "type": "a",
    "from": "《DARLING in the FRANXX》",
    "from_who": null,
    "creator": "恬波之明",
    "creator_uid": 1645,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533654686",
    "length": 20
  },
  {
    "id": 3752,
    "uuid": "a9933c49-dd1c-41f8-8396-42d0cc39351b",
    "hitokoto": "幸福的回忆，美满的回忆不一定会成为救赎，有时候，回忆越是美满便越痛苦，也有时候，会越害怕，无论是对于将要离开的人来说，还是对于被留下的人来说，都不可能会成为一种救赎。",
    "type": "a",
    "from": "可塑性记忆",
    "from_who": null,
    "creator": "xiaou",
    "creator_uid": 1866,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533119658",
    "length": 83
  },
  {
    "id": 3772,
    "uuid": "a9d89a3c-745c-42c2-8cbf-8029aec721d7",
    "hitokoto": "恋爱不是谈出来的，而是陷进去的。",
    "type": "a",
    "from": "GAMER电玩咖！",
    "from_who": null,
    "creator": "719",
    "creator_uid": 1891,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533488697",
    "length": 16
  },
  {
    "id": 3783,
    "uuid": "89348f5d-e968-49fd-9c6a-3c6b040c9caf",
    "hitokoto": "我们的哀伤和年龄是没有关系的。",
    "type": "a",
    "from": "樱桃小丸子",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106760",
    "length": 15
  },
  {
    "id": 3811,
    "uuid": "5de4f74c-39a5-4d2f-9561-9230bc96c5f1",
    "hitokoto": "总在不停寻觅你的踪影，无论十字路口抑或梦境之中，明知你不在，却依然不停地找寻。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "一叶",
    "creator_uid": 1756,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531110730",
    "length": 39
  },
  {
    "id": 3818,
    "uuid": "5c5f9718-461c-428e-9040-25233a1824c7",
    "hitokoto": "我想你们的努力一定会有回报的",
    "type": "a",
    "from": "龙与虎",
    "from_who": null,
    "creator": "jyeric",
    "creator_uid": 1981,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535441271",
    "length": 14
  },
  {
    "id": 3819,
    "uuid": "cdbcc2d0-786a-4000-87a7-503908d7b620",
    "hitokoto": "人生不如意十有八九！",
    "type": "a",
    "from": "龙与虎",
    "from_who": null,
    "creator": "jyeric",
    "creator_uid": 1981,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535442833",
    "length": 10
  },
  {
    "id": 3821,
    "uuid": "ed24489b-c6f6-47ca-aeb0-a31c36b59db6",
    "hitokoto": "此身为剑所天成，身如钢铁，心似琉璃。",
    "type": "a",
    "from": "Fate",
    "from_who": null,
    "creator": "听海听心",
    "creator_uid": 1985,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535439562",
    "length": 18
  },
  {
    "id": 3833,
    "uuid": "824ef2b8-a312-44df-b719-a46811c7bf00",
    "hitokoto": "我的梦想实现了，也留下了美好的回忆，我已经没有任何遗憾了。",
    "type": "a",
    "from": "末日时在做什么?有没有空?可以来拯救吗?",
    "from_who": null,
    "creator": "Lhc_fl",
    "creator_uid": 2007,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535804330",
    "length": 29
  },
  {
    "id": 3839,
    "uuid": "3ec1c46e-c2d0-4c59-8fb5-b297f4f7bc10",
    "hitokoto": "死者的血泪混入滚滚的流沙之中...将会赐予修罗更强的力量...",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231630",
    "length": 31
  },
  {
    "id": 3840,
    "uuid": "fb9626bd-b284-4b92-b992-b3ec88778791",
    "hitokoto": "有型的东西终究会消逝，不过……终于，这份回忆还是永远不朽的…",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231674",
    "length": 30
  },
  {
    "id": 3841,
    "uuid": "22998c8e-e818-4979-9713-17fd7e60b3d9",
    "hitokoto": "人啊...想要保护重要东西的时候，就真的能变得很坚强。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231609",
    "length": 27
  },
  {
    "id": 3842,
    "uuid": "d0f59eae-a204-4457-b723-83618d262ce6",
    "hitokoto": "寂寞阴暗中度过，孤单孕育了怨与悲凉。锋利的伤痛刺入了我们彼此胸膛，这是我们无法躲避的惩罚，是我们不该任人生撩拨忧伤，不该走过之后又往回看。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231586",
    "length": 69
  },
  {
    "id": 3843,
    "uuid": "2315ac75-063e-44c5-bfe7-e257ff49b61e",
    "hitokoto": "哪怕是打断你的手脚，也要把你带回去。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231390",
    "length": 18
  },
  {
    "id": 3844,
    "uuid": "3896f387-0b68-425c-8828-b5c943c808c2",
    "hitokoto": "从你站在桥上看我的 那一刻起你就是我的世界。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "我養你啊_",
    "creator_uid": 2033,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536231352",
    "length": 22
  },
  {
    "id": 3866,
    "uuid": "c0957fd9-cd53-43a3-889b-785911c53d03",
    "hitokoto": "龙儿是我的，谁都不许碰。",
    "type": "a",
    "from": "龙与虎",
    "from_who": null,
    "creator": "jyeric",
    "creator_uid": 1981,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535376600",
    "length": 12
  },
  {
    "id": 3871,
    "uuid": "bf9912c6-c197-462a-bb74-ab618888bcc5",
    "hitokoto": "卧龙低伏，入我阵来。",
    "type": "a",
    "from": "一人之下",
    "from_who": null,
    "creator": "神奇のDzoer",
    "creator_uid": 2029,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536123761",
    "length": 10
  },
  {
    "id": 3885,
    "uuid": "88b41781-bd27-42b8-9f02-1ed85337efe6",
    "hitokoto": "好红，每当想起你，枫叶就会被染红。",
    "type": "a",
    "from": "银仙",
    "from_who": null,
    "creator": "oierlin",
    "creator_uid": 2077,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537360694",
    "length": 17
  },
  {
    "id": 3886,
    "uuid": "470b94ea-abc6-4748-ba59-4b57d0c3ef34",
    "hitokoto": "相信十年后的八月，我们还会相遇。",
    "type": "a",
    "from": "未闻花名",
    "from_who": null,
    "creator": "oierlin",
    "creator_uid": 2077,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537360907",
    "length": 16
  },
  {
    "id": 3887,
    "uuid": "7f60a0e2-089e-471b-810b-d96ee676842a",
    "hitokoto": "应该可以了吧，我已经很努力了，应该可以抵达终点了……",
    "type": "a",
    "from": "AIR",
    "from_who": null,
    "creator": "oierlin",
    "creator_uid": 2077,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537360928",
    "length": 26
  },
  {
    "id": 3935,
    "uuid": "fe35a373-88ec-41a7-84f9-331c0f042ca4",
    "hitokoto": "殺してあげる",
    "type": "a",
    "from": "緋色月下、狂咲ノ絶",
    "from_who": null,
    "creator": "蒟蒻XZY",
    "creator_uid": 877,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538466922",
    "length": 6
  },
  {
    "id": 3940,
    "uuid": "15bb4706-9aa7-4434-b297-5170fe186bd7",
    "hitokoto": "能力越大,责任越大",
    "type": "a",
    "from": "蜘蛛侠",
    "from_who": null,
    "creator": "CrankAR",
    "creator_uid": 2131,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538650030",
    "length": 9
  },
  {
    "id": 3946,
    "uuid": "183f0467-513d-411d-be41-e7a6f3bb041b",
    "hitokoto": "不要随便贬低自己",
    "type": "a",
    "from": "终将成为你",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538750062",
    "length": 8
  },
  {
    "id": 3948,
    "uuid": "1b9dcd23-91a3-4db5-b911-d578c408a5cb",
    "hitokoto": "我不喜欢这世界，我只喜欢你",
    "type": "a",
    "from": "乔一",
    "from_who": null,
    "creator": "新贵",
    "creator_uid": 2297,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541572220",
    "length": 13
  },
  {
    "id": 3949,
    "uuid": "82c311d1-1848-4da7-98cf-ec42e74a0dcc",
    "hitokoto": "神啊 我的人生到底为何而存在呢",
    "type": "a",
    "from": "蜂蜜与四叶草",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541232881",
    "length": 15
  },
  {
    "id": 3956,
    "uuid": "c452a4f9-ada5-4e53-a586-9462e09d884d",
    "hitokoto": "想象力是武器，没有想象力的人会先死。",
    "type": "a",
    "from": "哥布林杀手",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539494232",
    "length": 18
  },
  {
    "id": 3968,
    "uuid": "ddc3bad8-3f01-4cae-b743-8b9971dcbb05",
    "hitokoto": "我们只是历史的过客，目标渺茫，无地自容。我们没有世界大战可以经历，也没有经济大萧条可以恐慌。我们的战争充其量不过是内心之战，我们最大的恐慌就是自己的生活。",
    "type": "a",
    "from": "搏击俱乐部",
    "from_who": null,
    "creator": "Yolly",
    "creator_uid": 2273,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541085065",
    "length": 77
  },
  {
    "id": 3988,
    "uuid": "a535d18b-5b3d-4c2d-ba5e-9197683e4c9a",
    "hitokoto": "有的只是很简单的唯一的思想…只此一个！“胜利然后支配”！仅此而已...这才是我唯一的满足感！…至于过程和方法之类…并不重要！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "DimensionTripper",
    "creator_uid": 2246,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540524137",
    "length": 62
  },
  {
    "id": 3989,
    "uuid": "9251ccdc-976c-47ad-bb18-cf858ca3c1b5",
    "hitokoto": "王有王的才能，厨师有厨师的才能，替身之间是没有强弱之分的",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "DimensionTripper",
    "creator_uid": 2246,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540524024",
    "length": 28
  },
  {
    "id": 4005,
    "uuid": "2bb2750f-af1c-415b-b52c-d06b33c4ef75",
    "hitokoto": "如果我们能活着出去的话，千山万水，你愿意陪我一起看吗？",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109414",
    "length": 27
  },
  {
    "id": 4006,
    "uuid": "99a94395-b872-42d7-9f8d-3bec09b1c61f",
    "hitokoto": "如果可以，愿来生你不要忘记我，我也不要忘记你那熟悉的温柔。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109600",
    "length": 29
  },
  {
    "id": 4007,
    "uuid": "c31ae275-824d-4be6-9a86-3308496af2ba",
    "hitokoto": "我愿意呀，五十年前就愿意了。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109549",
    "length": 14
  },
  {
    "id": 4008,
    "uuid": "3fa22574-6119-4bb3-aa46-9452cd256e98",
    "hitokoto": "而我不知不觉把自己遗忘，只想为你完成那个梦想。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109760",
    "length": 23
  },
  {
    "id": 4009,
    "uuid": "5f422196-9585-47ec-b5e9-517c36d6c880",
    "hitokoto": "让我成为你的双眼，把那世界万千，描绘在你面前。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109989",
    "length": 23
  },
  {
    "id": 4010,
    "uuid": "8548028e-ce04-4bfe-80e3-74309f81783b",
    "hitokoto": "有很多辛苦的事情，从结果上来说并不好。但是一起努力的过程，绝对不是没用的。我是这么想的。所以现在不是停滞不前的时候。",
    "type": "a",
    "from": "如果有个妹妹就好了",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110332",
    "length": 58
  },
  {
    "id": 4011,
    "uuid": "e7302847-9965-4102-8fce-e79b8a95792a",
    "hitokoto": "你们这些天才止步不前的时候，我会走得更远。",
    "type": "a",
    "from": "如果有个妹妹就好了",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110382",
    "length": 21
  },
  {
    "id": 4012,
    "uuid": "1e62ce02-ca7e-4ec9-8c26-48575b6303f8",
    "hitokoto": "有些景色必须前进才能看到，那么只有勇往直前。",
    "type": "a",
    "from": "如果有个妹妹就好了",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110401",
    "length": 22
  },
  {
    "id": 4013,
    "uuid": "1a22ca1b-82db-4ddc-a90f-502f4f9d7fc1",
    "hitokoto": "果然啊，创造一样东西很开心。让别人享受自己创造的东西，是一种幸福呢。",
    "type": "a",
    "from": "如果有个妹妹就好了",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110423",
    "length": 34
  },
  {
    "id": 4014,
    "uuid": "76f9fa17-ecda-4dd1-8e4e-e5fdee2bd7ee",
    "hitokoto": "世界上哪有不会输的英雄啊",
    "type": "a",
    "from": "凸变英雄",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110518",
    "length": 12
  },
  {
    "id": 4015,
    "uuid": "ea0b887f-342a-4152-9358-dd40505b4c20",
    "hitokoto": "我怕失去了你，我的世界就没有了光明",
    "type": "a",
    "from": "凸变英雄",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110594",
    "length": 17
  },
  {
    "id": 4016,
    "uuid": "9b1cc523-cafc-4b51-b87e-614b258250ca",
    "hitokoto": "虽然有时候，不知道要写些什么，有时候，却有很多想说的，来不及记录。回忆一转身，就悄悄溜走了。",
    "type": "a",
    "from": "凸变英雄",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110623",
    "length": 46
  },
  {
    "id": 4017,
    "uuid": "7d1b367e-207c-4413-8900-c9da6592dd30",
    "hitokoto": "哭过喊过便会停止哭泣",
    "type": "a",
    "from": "从零开始的异世界生活",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540111233",
    "length": 10
  },
  {
    "id": 4018,
    "uuid": "6f339ce5-554b-4f08-8acc-d501b3c4902f",
    "hitokoto": "很抱歉，前面是单行道，你就乖乖的夹着尾巴耸拉着脑袋返回原点吧！",
    "type": "a",
    "from": "一方通行",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540111404",
    "length": 31
  },
  {
    "id": 4019,
    "uuid": "4ba79b48-3351-4abf-9e9a-a102a8d070e3",
    "hitokoto": "即便我弱了，也并不代表你强了。",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540111470",
    "length": 15
  },
  {
    "id": 4024,
    "uuid": "4b7f8f0b-69fa-483e-bf35-dd9348f991bd",
    "hitokoto": "小鬼，你为坠入不幸深渊之人而心痛  我不会多言，只不过周遭充斥不幸，而你的小船仅能载一人，若救助其他人，只会让彼此沉没。",
    "type": "a",
    "from": "文豪野犬",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540447429",
    "length": 60
  },
  {
    "id": 4038,
    "uuid": "49fe46af-82c6-48fa-971a-ed2b23ba0de2",
    "hitokoto": "死亡不是终点，被遗忘才是。",
    "type": "a",
    "from": "寻梦环游记",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561460",
    "length": 13
  },
  {
    "id": 4039,
    "uuid": "e1522d84-7e62-4330-b9aa-85f064f2f177",
    "hitokoto": "世界上的人都变成废柴，这个世界就没有废柴了。",
    "type": "a",
    "from": "春物",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561306",
    "length": 22
  },
  {
    "id": 4040,
    "uuid": "52710dfd-1e1f-48e4-8a70-8028ba20eebf",
    "hitokoto": "青春是谎言，是邪恶。",
    "type": "a",
    "from": "春物",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561331",
    "length": 10
  },
  {
    "id": 4041,
    "uuid": "886a4e78-c240-4d80-a133-054e1db1fa45",
    "hitokoto": "纵使日薄西山。",
    "type": "a",
    "from": "末日时在做什么",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561377",
    "length": 7
  },
  {
    "id": 4042,
    "uuid": "8934666c-c486-4f1f-a194-f5e5dfee208e",
    "hitokoto": "孤高的游荡灵魂不需要羁绊之地",
    "type": "a",
    "from": "春物",
    "from_who": null,
    "creator": "流畅i",
    "creator_uid": 2358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542561276",
    "length": 14
  },
  {
    "id": 4048,
    "uuid": "2aa90f91-cd4e-4635-b7f0-6696e7cbd10a",
    "hitokoto": "我的金子，只给千寻。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542438405",
    "length": 10
  },
  {
    "id": 4049,
    "uuid": "c25ba6ee-8903-445d-b949-e7f1f224dc8f",
    "hitokoto": "步伐虽小，密而不停",
    "type": "a",
    "from": "实验品家庭",
    "from_who": null,
    "creator": "RGHSSS",
    "creator_uid": 2349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542435504",
    "length": 9
  },
  {
    "id": 4052,
    "uuid": "e733e036-b713-4c55-adfc-6e330c703d16",
    "hitokoto": "只会比大小真是没品",
    "type": "a",
    "from": "某科学的超电磁炮S",
    "from_who": null,
    "creator": "111",
    "creator_uid": 2336,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542283594",
    "length": 9
  },
  {
    "id": 4057,
    "uuid": "450629ad-6081-46bf-8d25-c47837c59411",
    "hitokoto": "问灵十三载，等一不归人。",
    "type": "a",
    "from": "魔道祖师",
    "from_who": null,
    "creator": "༄凉ོ࿆风࿆有࿆信ོ࿆࿐",
    "creator_uid": 1948,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542029698",
    "length": 12
  },
  {
    "id": 4059,
    "uuid": "35cdee89-ce24-49fd-a5a7-f4cfe0d5e979",
    "hitokoto": "如果我是雨的话，也能像连接那永远都不将交汇的天空和大地一样，去连接某个人的心吗。",
    "type": "a",
    "from": "BLEACH",
    "from_who": null,
    "creator": "diazynez",
    "creator_uid": 2418,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543638778",
    "length": 40
  },
  {
    "id": 4079,
    "uuid": "ff79312e-4ac3-487d-a0be-5e23423ed267",
    "hitokoto": "你还是...笑起来...最棒了",
    "type": "a",
    "from": "最终幻想XIV",
    "from_who": null,
    "creator": "一人之善",
    "creator_uid": 2162,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539056437",
    "length": 15
  },
  {
    "id": 4088,
    "uuid": "c49c2be5-61f6-45f5-ad68-820a33b5dd1b",
    "hitokoto": "'Cause rainbow won't light up the sky unless you let it rain.",
    "type": "a",
    "from": "My Little Pony: Friendship is Magic",
    "from_who": null,
    "creator": "flowphyl",
    "creator_uid": 2150,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538802325",
    "length": 61
  },
  {
    "id": 4101,
    "uuid": "0f616c2f-b2b0-4f17-a85c-f551904d038e",
    "hitokoto": "千山万水，因你不过毫厘",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109694",
    "length": 11
  },
  {
    "id": 4102,
    "uuid": "292f6e01-1e81-401f-9a2c-f2a36cb8ab07",
    "hitokoto": "古往传奇多少别离，我 只是不经意 遇到了你",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109836",
    "length": 21
  },
  {
    "id": 4103,
    "uuid": "028dece9-3e8f-42e2-b1ee-8835034413a8",
    "hitokoto": "或许，你认为你的心已经给了他。但是，我会证明……我有一颗爱你的心！",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110022",
    "length": 33
  },
  {
    "id": 4104,
    "uuid": "67943275-8932-4847-88d7-0503db8d6fa8",
    "hitokoto": "你相信时间会抚平一切，可时过境迁，你已不复醒",
    "type": "a",
    "from": "动画",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110217",
    "length": 22
  },
  {
    "id": 4105,
    "uuid": "9114bbb5-838a-4786-b058-91d77aa4d787",
    "hitokoto": "不拼尽全力去试一下，又怎么会知道啊",
    "type": "a",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110679",
    "length": 17
  },
  {
    "id": 4106,
    "uuid": "c70b8b1b-b2d0-43a7-923d-3d6fe0ed2103",
    "hitokoto": "我今天就要带她走，我看谁敢拦我！",
    "type": "a",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110721",
    "length": 16
  },
  {
    "id": 4107,
    "uuid": "91e120c0-2025-4092-aaec-c0cfe58b983b",
    "hitokoto": "你们人类让我明白了一个道理，那就是这个世界是不讲道理的",
    "type": "a",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110736",
    "length": 27
  },
  {
    "id": 4108,
    "uuid": "c03dfa97-484b-476e-a6de-e86cae020b1d",
    "hitokoto": "人各有命，上天注定。有人天生为王，有人落草为寇。脚下的路如果不是你自己的选择，那么旅程的终点在哪儿也没人知道，你会走到哪儿，会碰到谁，都不一定。",
    "type": "a",
    "from": "镇魂街",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540110780",
    "length": 72
  },
  {
    "id": 4109,
    "uuid": "192ee378-12b8-4acf-b68f-76cdc5b0497c",
    "hitokoto": "世界是无情的，并不存在与生俱来的英雄。 所以只能由刚好在旁边的人粉墨登场， 演一出英雄的戏码。",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540111436",
    "length": 47
  },
  {
    "id": 4112,
    "uuid": "ee3ed14b-67a2-4a58-9fd7-d4c1346b0a47",
    "hitokoto": "樱花满地集于我心，楪舞纷飞祈愿相随",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "泣血之恋",
    "creator_uid": 2143,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540474351",
    "length": 17
  },
  {
    "id": 4113,
    "uuid": "1bdd8fef-53cb-4a69-b30a-08e581c45e25",
    "hitokoto": "人的能力是有极限的。我从短暂的人生当中学到一件事……越是玩弄计谋,就越会发现人类的能力是有极限的……除非超越人类。",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "DimensionTripper",
    "creator_uid": 2246,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540524193",
    "length": 57
  },
  {
    "id": 4124,
    "uuid": "48b9aa7d-3b1a-42d8-9154-64daaf32497f",
    "hitokoto": "那似乎是比翼鸟。这种鸟天生单翼，须靠雌雄二鸟相互依偎才能翱翔天际，是种有缺陷的生物。但是，不知为何，我却感受到了这种生活方式的美妙。",
    "type": "a",
    "from": "Darling in the FRANXX",
    "from_who": null,
    "creator": "MegaOwIer",
    "creator_uid": 2331,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542203017",
    "length": 66
  },
  {
    "id": 4125,
    "uuid": "6d16c432-7230-4dc4-9d7b-e3f50bd88800",
    "hitokoto": "追寻只是因为无法抓获，想要触碰，只是因为知道自己触碰不到。",
    "type": "a",
    "from": "FLCL Progressive",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542436556",
    "length": 29
  },
  {
    "id": 4129,
    "uuid": "81d83baf-a7f7-459f-bb20-0c9fd1cf97fc",
    "hitokoto": "世界上所有的不利情况都是因为当事者的能力不足造成的",
    "type": "a",
    "from": "东京喰种",
    "from_who": null,
    "creator": "二十一",
    "creator_uid": 2361,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542691955",
    "length": 25
  },
  {
    "id": 4132,
    "uuid": "18c404fc-1610-4b12-a774-8c66d258f4b4",
    "hitokoto": "一个人有表里两面，你能看到的，仅仅是其中一面而已。",
    "type": "a",
    "from": "零的执行人",
    "from_who": null,
    "creator": "Food-F",
    "creator_uid": 2333,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542712258",
    "length": 25
  },
  {
    "id": 4159,
    "uuid": "b680b672-831c-44d8-9ad1-30828189b26c",
    "hitokoto": "不知彼此来世相逢。是否还能记得我是谁？",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540109926",
    "length": 19
  },
  {
    "id": 4167,
    "uuid": "c88e5d5d-ebba-4bc3-bcda-b43e89dd9fcf",
    "hitokoto": "与其因为不信任而后悔，不如因为相信而后悔。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545533543",
    "length": 21
  },
  {
    "id": 4168,
    "uuid": "5d6c23d6-ac38-4265-a3b3-0203afb9fb37",
    "hitokoto": "人生没有那么多的捷径，你不知道路的尽头是什么，但你必须向前走。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545533612",
    "length": 31
  },
  {
    "id": 4169,
    "uuid": "a2fb3d09-fe84-49f0-b0bf-9de9e44ec478",
    "hitokoto": "一个人决定寂寞，和另一个人相互依偎又有什么错",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "RGHSSS",
    "creator_uid": 2349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545835092",
    "length": 22
  },
  {
    "id": 4170,
    "uuid": "f66b2018-3fb5-4cbe-9aeb-fa50853e8d04",
    "hitokoto": "我可从来不认为恐惧可以成为舍弃他人的借口，人不能因为恐惧，就连身为人类的品性都丢掉。",
    "type": "a",
    "from": "铁甲城的卡巴内瑞",
    "from_who": null,
    "creator": "RGHSSS",
    "creator_uid": 2349,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545835294",
    "length": 42
  },
  {
    "id": 4176,
    "uuid": "0400f3cb-49b6-481b-969f-fdfda316e32e",
    "hitokoto": "你知道吗？从人眼的高度能看到的地平线，是离自身的距离大约是4公里。",
    "type": "a",
    "from": "青春猪头少年不会梦到兔女郎学姐",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545533360",
    "length": 33
  },
  {
    "id": 4181,
    "uuid": "208f0417-09e6-46d5-85f1-0e3a61bc8221",
    "hitokoto": "梦想是一个天真的词，实现梦想是一个残酷的词",
    "type": "a",
    "from": "哆啦A梦",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547732577",
    "length": 21
  },
  {
    "id": 4192,
    "uuid": "d66f8046-b0d0-4334-8d32-32f937bbc4d6",
    "hitokoto": "既然今天是昨天，那么睡到明天就好。",
    "type": "a",
    "from": "青春猪头少年不会梦到兔女郎学姐",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545533295",
    "length": 17
  },
  {
    "id": 4193,
    "uuid": "7cf387d5-15bf-4334-9681-c6e4f953e211",
    "hitokoto": "做不到的事没必要勉强去做，不也挺好吗？",
    "type": "a",
    "from": "青春猪头少年不会梦到兔女郎学姐",
    "from_who": null,
    "creator": "Amadeus",
    "creator_uid": 2230,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545533443",
    "length": 19
  },
  {
    "id": 4215,
    "uuid": "714750b4-25cc-4fe8-bcc7-ec250b0ac9f8",
    "hitokoto": "给我高高的飞起来啊！",
    "type": "a",
    "from": "星游记",
    "from_who": null,
    "creator": "萃枫",
    "creator_uid": 2569,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546010367",
    "length": 10
  },
  {
    "id": 4216,
    "uuid": "86a1b1b6-7259-4d25-b845-f0f6816ccbfa",
    "hitokoto": "要是眼睁睁的看着重要的同伴死去，就算是死，我也不能瞑目。",
    "type": "a",
    "from": "家庭教师",
    "from_who": null,
    "creator": "萃枫",
    "creator_uid": 2569,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546010486",
    "length": 28
  },
  {
    "id": 4217,
    "uuid": "02ae61ca-7034-4a7d-a584-060c2bdddf25",
    "hitokoto": "你的败因只有一个，就是与我为敌。 ­",
    "type": "a",
    "from": "家庭教师",
    "from_who": null,
    "creator": "萃枫",
    "creator_uid": 2569,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546010516",
    "length": 18
  },
  {
    "id": 4218,
    "uuid": "211b3987-0073-4028-84ac-009866d945bd",
    "hitokoto": "如果真是这样， 就由我来把彭格列毁灭！",
    "type": "a",
    "from": "家庭教师",
    "from_who": null,
    "creator": "萃枫",
    "creator_uid": 2569,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546010644",
    "length": 19
  },
  {
    "id": 4219,
    "uuid": "69a0b4d1-9479-475f-bc76-fec57d94c9b3",
    "hitokoto": "十代目的意志就是我们的意志！",
    "type": "a",
    "from": "家庭教师",
    "from_who": null,
    "creator": "萃枫",
    "creator_uid": 2569,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546010812",
    "length": 14
  },
  {
    "id": 4223,
    "uuid": "3fe8f2ab-d3f9-4864-b858-4d0d8bf413d3",
    "hitokoto": "但我拒绝！我岸边露伴最喜欢的事情之一，就是向那些自以为是的家伙说，NO！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "Ranu",
    "creator_uid": 2591,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546476698",
    "length": 36
  },
  {
    "id": 4224,
    "uuid": "9cd64aae-5349-45de-84db-3401043dbac7",
    "hitokoto": "人类的赞歌就是勇气的赞歌！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "Ranu",
    "creator_uid": 2591,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546476739",
    "length": 13
  },
  {
    "id": 4225,
    "uuid": "a0247532-077a-4208-81f1-96d38e911c8e",
    "hitokoto": "大家都是伪善者，世间充斥着不真实。",
    "type": "a",
    "from": "无头骑士异闻录",
    "from_who": null,
    "creator": "Ranu",
    "creator_uid": 2591,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546476809",
    "length": 17
  },
  {
    "id": 4228,
    "uuid": "f614d9f2-ccf3-4e32-81c7-4712137afce0",
    "hitokoto": "不服从命令的人是人渣，抛弃同伴的人连人渣都不如。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "althezsh",
    "creator_uid": 185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547048264",
    "length": 24
  },
  {
    "id": 4244,
    "uuid": "9aecd2be-a806-473b-b53a-3b3fcd6879ff",
    "hitokoto": "砸瓦鲁多！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547789243",
    "length": 5
  },
  {
    "id": 4252,
    "uuid": "70e28b9f-c71f-4880-aa46-10a3dff05c6a",
    "hitokoto": "背后即是祖国，我们无路可退。",
    "type": "a",
    "from": "那年那兔那些事",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547798034",
    "length": 14
  },
  {
    "id": 4262,
    "uuid": "42a14cf2-4cd7-4e03-982c-3c03bb7d59a7",
    "hitokoto": "不能输，笑吧！",
    "type": "a",
    "from": "约定的梦幻岛",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548556704",
    "length": 7
  },
  {
    "id": 4268,
    "uuid": "aa27de77-0b5d-493c-a0c1-d4aa8c63822c",
    "hitokoto": "不管是怎样的回忆，都是我们活过的人生。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "ChenZ01",
    "creator_uid": 2711,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549191579",
    "length": 19
  },
  {
    "id": 4269,
    "uuid": "feafb91f-84c3-4c4c-b883-62a909d84bbb",
    "hitokoto": "孤独的我们才有人类的样子。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "ChenZ01",
    "creator_uid": 2711,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549191622",
    "length": 13
  },
  {
    "id": 4270,
    "uuid": "66d917b6-cccc-4afa-8495-25b610756e0b",
    "hitokoto": "声起立华乐独奏，曲末音无心结弦。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "ChenZ01",
    "creator_uid": 2711,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549192909",
    "length": 16
  },
  {
    "id": 4271,
    "uuid": "4903bcc1-2911-45a6-beaf-0e202a812335",
    "hitokoto": "不愿意的时候，逃跑也没有关系！",
    "type": "a",
    "from": "灵能百分百",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549357675",
    "length": 15
  },
  {
    "id": 4277,
    "uuid": "a8825f90-0df7-473d-9847-6bc025884dbd",
    "hitokoto": "邪王真眼是最强的",
    "type": "a",
    "from": "中二病也要谈恋爱",
    "from_who": null,
    "creator": "じゃおうしんがん",
    "creator_uid": 2756,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550138076",
    "length": 8
  },
  {
    "id": 4278,
    "uuid": "b6157697-8a10-4d44-babb-8c11fba5ff7f",
    "hitokoto": "大部分人并不想长大 只是没办法继续当一个小孩子。",
    "type": "a",
    "from": "小林家的龙女仆",
    "from_who": null,
    "creator": "ppO",
    "creator_uid": 2686,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549864293",
    "length": 24
  },
  {
    "id": 4280,
    "uuid": "582464e8-7a57-4740-86bf-0fea8d9f31a3",
    "hitokoto": "从开始的第一天起，就回不去了。",
    "type": "a",
    "from": "流浪地球",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549883720",
    "length": 15
  },
  {
    "id": 4299,
    "uuid": "48c68bfa-7dfd-4cc3-86d2-040ed4403b90",
    "hitokoto": "欧拉欧拉欧拉欧拉！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "じゃおうしんがん",
    "creator_uid": 2756,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550138412",
    "length": 9
  },
  {
    "id": 4311,
    "uuid": "94370806-758d-4158-a982-2eed93832c32",
    "hitokoto": "一举一动，都是承诺，会被另一个人看在眼里，记在心上的。",
    "type": "a",
    "from": "悬崖上的金鱼姬",
    "from_who": null,
    "creator": "阁主博客",
    "creator_uid": 2831,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551540529",
    "length": 27
  },
  {
    "id": 4315,
    "uuid": "fd325ed4-f304-4c72-83b0-151794cd8031",
    "hitokoto": "人各有命，上天注定。有人天生为王，有人落草为寇。脚下的路，如果不是自己的选择，那旅程的终点在哪儿，也没人知道，你会走到哪儿，会碰到谁，都不一定。",
    "type": "a",
    "from": "镇魂街",
    "from_who": null,
    "creator": "龙飞",
    "creator_uid": 3200,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557302446",
    "length": 72
  },
  {
    "id": 4316,
    "uuid": "82a944fd-8098-4b12-9177-6fd285e4efa8",
    "hitokoto": "成一事者，是失之不渝的愚者；毁一事者，是停滞不前的贤者。",
    "type": "a",
    "from": "不正经的魔法讲师",
    "from_who": null,
    "creator": "龙飞",
    "creator_uid": 3200,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557302125",
    "length": 28
  },
  {
    "id": 4320,
    "uuid": "eae42b38-d735-4152-957b-4a791bdb6a8f",
    "hitokoto": "到底是，为什么呢？",
    "type": "a",
    "from": "金木研",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557221711",
    "length": 9
  },
  {
    "id": 4321,
    "uuid": "e35bce3d-190b-4ee1-a1cc-175758fee9f1",
    "hitokoto": "我爱你，与你何干？",
    "type": "a",
    "from": "歌德",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557151260",
    "length": 9
  },
  {
    "id": 4328,
    "uuid": "1ca1ea97-79e2-4fff-b4a0-63d269460380",
    "hitokoto": "即使我弱了，也并不代表你强了",
    "type": "a",
    "from": "魔法禁书目录 第二季",
    "from_who": null,
    "creator": "jyeric",
    "creator_uid": 1981,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556628066",
    "length": 14
  },
  {
    "id": 4332,
    "uuid": "e8025d13-e419-4e63-b4da-17dddc84884e",
    "hitokoto": "正因为有了音乐，才有了相遇的瞬间，有了相会的感动，有了相逢的人们，有了邂逅的思念。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756959",
    "length": 41
  },
  {
    "id": 4333,
    "uuid": "04c4c5ba-6815-4f6a-9033-38c2a9c72de2",
    "hitokoto": "你驻足于春色中，于那独一无二的春色之中。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756935",
    "length": 20
  },
  {
    "id": 4334,
    "uuid": "46210228-4442-4a09-836b-bfb6e0b58a3f",
    "hitokoto": "每当心情郁闷的时候，用手托腮就好，手臂会因为帮上忙而开心的。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756886",
    "length": 30
  },
  {
    "id": 4335,
    "uuid": "d8dfe679-5dec-4911-9134-cf31134e1773",
    "hitokoto": "你的所言所行，全都闪烁着光芒，太过刺目，于是我闭上双眼，但内心还是无法停止对你的憧憬。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756787",
    "length": 43
  },
  {
    "id": 4336,
    "uuid": "ba15899a-8914-4729-ae46-2aee4a7e667e",
    "hitokoto": "或许前路永夜，即便如此我也要前进，因为星光即使微弱也会为我照亮前途。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756751",
    "length": 34
  },
  {
    "id": 4337,
    "uuid": "6be7df57-af06-48b5-9e73-f645002449ff",
    "hitokoto": "九月是蒲公英漫飞的季节，我喜欢这个季节，只可惜今天是九月的最后一天了",
    "type": "a",
    "from": "我是江小白",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555738231",
    "length": 34
  },
  {
    "id": 4338,
    "uuid": "ceda710f-4d5e-46c4-b889-b1db46c97a48",
    "hitokoto": "不辜负年华，做自己想做的事，唱自己想唱的歌",
    "type": "a",
    "from": "我是江小白",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555732783",
    "length": 21
  },
  {
    "id": 4339,
    "uuid": "019b4fe9-9259-47a1-a13b-22c2753e5938",
    "hitokoto": "世间有很多事情，人们无法从它寂静的表象，猜测到暗涌，就像一个人和另一个人的相遇",
    "type": "a",
    "from": "我是江小白",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555732518",
    "length": 39
  },
  {
    "id": 4341,
    "uuid": "0d676f75-2f1b-4be9-bd57-0d35741fb171",
    "hitokoto": "用我那牵强的微笑，活出无人能比的骄傲。",
    "type": "a",
    "from": "黑执事",
    "from_who": null,
    "creator": "綾音",
    "creator_uid": 1570,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551712132",
    "length": 19
  },
  {
    "id": 4342,
    "uuid": "f28bee04-9d48-410b-a5d8-99aa36e7fc44",
    "hitokoto": "人类的赞歌就是勇气的赞歌",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "敢当",
    "creator_uid": 2846,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551765429",
    "length": 12
  },
  {
    "id": 4358,
    "uuid": "3c002d6f-4412-4500-86f1-1ee37ffbe16a",
    "hitokoto": "我没有任何理由为了那些人让自己的人生付之一炬！",
    "type": "a",
    "from": "三月的狮子",
    "from_who": null,
    "creator": "ouuan",
    "creator_uid": 2676,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556883649",
    "length": 23
  },
  {
    "id": 4359,
    "uuid": "b79fd770-abd5-4915-a459-acadbaf67d38",
    "hitokoto": "但是，我没有后悔，不能后悔，因为，我所做的事情一定没有错！",
    "type": "a",
    "from": "三月的狮子",
    "from_who": null,
    "creator": "ouuan",
    "creator_uid": 2676,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556883408",
    "length": 29
  },
  {
    "id": 4361,
    "uuid": "ea547ef2-b7d1-4de5-8ecf-1a2ff1f5347e",
    "hitokoto": "相信奇迹的人，本身就和奇迹一样了不起。",
    "type": "a",
    "from": "星游记",
    "from_who": null,
    "creator": "oierlin",
    "creator_uid": 2077,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556872801",
    "length": 19
  },
  {
    "id": 4366,
    "uuid": "4aae9954-2695-493b-abaf-8b36778c2ecc",
    "hitokoto": "即使天无雨，我亦留此地。",
    "type": "a",
    "from": "言叶之庭",
    "from_who": null,
    "creator": "Oreo",
    "creator_uid": 2873,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552144611",
    "length": 12
  },
  {
    "id": 4370,
    "uuid": "46d8c75d-8878-4ec5-abd2-7b360d8b8f1b",
    "hitokoto": "有些梦想虽然遥不可及，但不是不可能实现。只要我足够的强。",
    "type": "a",
    "from": "秦时明月",
    "from_who": null,
    "creator": "小学生",
    "creator_uid": 1754,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555593111",
    "length": 28
  },
  {
    "id": 4376,
    "uuid": "8871f3ea-52e1-490d-b049-bc7e40cf9766",
    "hitokoto": "有一天，你到了人类的世界，不要去爱上一个人，因为，爱上一个人，会让你真正变成孤单一人。",
    "type": "a",
    "from": "朝花夕誓",
    "from_who": null,
    "creator": "飞龙project",
    "creator_uid": 2944,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553579687",
    "length": 43
  },
  {
    "id": 4377,
    "uuid": "5b090192-a6b7-43a4-9181-55576d7b369c",
    "hitokoto": "经为流逝的日月。纬为人们的生业。",
    "type": "a",
    "from": "朝花夕誓",
    "from_who": null,
    "creator": "飞龙project",
    "creator_uid": 2944,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553579708",
    "length": 16
  },
  {
    "id": 4378,
    "uuid": "ac1723d5-55f3-4e28-ba63-6b718b6bc621",
    "hitokoto": "悲痛的事，温柔以对；难过的事，坚强以对。",
    "type": "a",
    "from": "朝花夕誓",
    "from_who": null,
    "creator": "飞龙project",
    "creator_uid": 2944,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553579733",
    "length": 20
  },
  {
    "id": 4379,
    "uuid": "182c5b95-b832-4d8f-be11-c7fca6df9b29",
    "hitokoto": "叫做妈妈的人，是不会哭的。",
    "type": "a",
    "from": "朝花夕誓",
    "from_who": null,
    "creator": "飞龙project",
    "creator_uid": 2944,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553579776",
    "length": 13
  },
  {
    "id": 4380,
    "uuid": "752f5d74-bfb8-4ada-9468-6c2cc49b80c7",
    "hitokoto": "每一个兔子都有一个大国梦",
    "type": "a",
    "from": "那年那兔那些事",
    "from_who": null,
    "creator": "STman",
    "creator_uid": 2972,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557157069",
    "length": 12
  },
  {
    "id": 4384,
    "uuid": "421ae985-e401-410d-bf10-5d68293d8791",
    "hitokoto": "乘上与平时相反的列车，为了去见从未见过的风景。",
    "type": "a",
    "from": "比宇宙更远的地方",
    "from_who": null,
    "creator": "柔刃",
    "creator_uid": 3053,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555218075",
    "length": 23
  },
  {
    "id": 4387,
    "uuid": "295d8716-74cb-4e6e-857c-7932e84d1f32",
    "hitokoto": "我不做人了！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "海人",
    "creator_uid": 2120,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551589806",
    "length": 6
  },
  {
    "id": 4395,
    "uuid": "67a2205f-a48b-449f-938b-524764f984e5",
    "hitokoto": "我是否住进了某人的心房呢？",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562903036",
    "length": 13
  },
  {
    "id": 4401,
    "uuid": "1cea4b1e-8d70-4f98-a726-6ce9c92dbf3a",
    "hitokoto": "那么难受，那么痛苦，可是 世界这么美丽...让我如何能够忘记！",
    "type": "a",
    "from": "朝花夕誓",
    "from_who": null,
    "creator": "飞龙project",
    "creator_uid": 2944,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553579805",
    "length": 31
  },
  {
    "id": 4402,
    "uuid": "b2b21600-4875-4545-b10c-762130de394c",
    "hitokoto": "雁过拔毛，兽走留皮。涂山，我罩的，懂？",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "QQQfy",
    "creator_uid": 2949,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553595491",
    "length": 19
  },
  {
    "id": 4403,
    "uuid": "a8adc700-386f-435c-8af2-63ef168f4a81",
    "hitokoto": "那天，我见过的最强剑客，提起了天下最强的宝剑······却早已没了剑心。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "QQQfy",
    "creator_uid": 2949,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553595585",
    "length": 36
  },
  {
    "id": 4404,
    "uuid": "34f2aebd-ec91-4e10-9339-d417b4faee51",
    "hitokoto": "知识是很美的，它们可以让你不出家门就了解这世上的许多事。",
    "type": "a",
    "from": "妖精的尾巴",
    "from_who": null,
    "creator": "QQQfy",
    "creator_uid": 2949,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553598182",
    "length": 28
  },
  {
    "id": 4405,
    "uuid": "7439052b-9f73-4515-aade-4a6df79d5e5b",
    "hitokoto": "尽情的依靠我吧，因为总有一天我也会依靠你的。",
    "type": "a",
    "from": "妖精的尾巴",
    "from_who": null,
    "creator": "QQQfy",
    "creator_uid": 2949,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553598306",
    "length": 22
  },
  {
    "id": 4420,
    "uuid": "840da7f7-05e4-40c3-bacf-9cda14745a51",
    "hitokoto": "电助！凉子，看到了吗！",
    "type": "a",
    "from": "电脑线圈",
    "from_who": null,
    "creator": "年糕小豆汤",
    "creator_uid": 3039,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555055681",
    "length": 11
  },
  {
    "id": 4424,
    "uuid": "aead346f-06a7-4d65-970f-495736fbc275",
    "hitokoto": "I met the girl under full-bloomed cherry blossoms, and my fate has begun to change.",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555756865",
    "length": 83
  },
  {
    "id": 4425,
    "uuid": "9da8c327-0ac9-4b74-bbab-25dfbc07bd05",
    "hitokoto": "不相信自己的人，连努力的价值都没有。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "chhokmah",
    "creator_uid": 3087,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555746726",
    "length": 18
  },
  {
    "id": 4427,
    "uuid": "5ca4257c-5fad-421f-bd9c-0e341278d695",
    "hitokoto": "我一点也不走运。",
    "type": "a",
    "from": "Fairy gone",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555769425",
    "length": 8
  },
  {
    "id": 4429,
    "uuid": "a2b46cfd-fe8a-4a21-8e76-c61972ad20f0",
    "hitokoto": "我从未让你们骄傲，你们却待我如宝。",
    "type": "a",
    "from": "Az殇芯的chx",
    "from_who": null,
    "creator": "Az殇芯",
    "creator_uid": 3173,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556888082",
    "length": 17
  },
  {
    "id": 4430,
    "uuid": "b21b434f-a276-4d8e-b517-81c067920741",
    "hitokoto": "错的不是我，而是这个世界！",
    "type": "a",
    "from": "东京喰种",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557151217",
    "length": 13
  },
  {
    "id": 4433,
    "uuid": "f0148130-ba1c-4b09-adfb-b9af233f963c",
    "hitokoto": "你驻足于春色中，于那独一无二的春色之中。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557716090",
    "length": 20
  },
  {
    "id": 4434,
    "uuid": "02d3b525-71d5-479a-8783-98182d763727",
    "hitokoto": "和她相遇的瞬间，我的人生就改变了。所见所闻所感，目之所及全都开始变得多姿多彩起来。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557716129",
    "length": 41
  },
  {
    "id": 4439,
    "uuid": "a83cbcaf-1ef9-4df0-a877-7019789a99bb",
    "hitokoto": "やり遂げたよ、最後まで。",
    "type": "a",
    "from": "ラブライブ",
    "from_who": null,
    "creator": "HentaiKai",
    "creator_uid": 3164,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1558449307",
    "length": 12
  },
  {
    "id": 4447,
    "uuid": "7f2afd0b-97df-4101-b112-50d63552b5b4",
    "hitokoto": "要把所有的夜归还给星河，把所有的春光归还给疏疏篱落，把所有的慵慵沉迷与不前，归还给过去的我。",
    "type": "a",
    "from": "德卡先生的信箱",
    "from_who": null,
    "creator": "MILLOPE",
    "creator_uid": 3119,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559051624",
    "length": 46
  },
  {
    "id": 4456,
    "uuid": "cbadf245-efab-4d2b-871d-8c17931453f4",
    "hitokoto": "总有一天，我要撕碎这片虚伪的星空。",
    "type": "a",
    "from": "黑之契约者",
    "from_who": null,
    "creator": "lrj124",
    "creator_uid": 3625,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565252131",
    "length": 17
  },
  {
    "id": 4461,
    "uuid": "aa2fae5b-3126-46e6-a390-f9260a0c61f6",
    "hitokoto": "那么，开始实验吧！",
    "type": "a",
    "from": "假面骑士Build",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566909340",
    "length": 9
  },
  {
    "id": 4467,
    "uuid": "a4648934-3d78-4b74-948d-12d7e836708a",
    "hitokoto": "我看到这个世界的恶意，我们正在接受考验。",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567429159",
    "length": 20
  },
  {
    "id": 4468,
    "uuid": "564319da-7f6b-484f-9aaf-e337dfe84937",
    "hitokoto": "喜欢上一个人就是变得束手无策。",
    "type": "a",
    "from": "悠久之翼2",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567158437",
    "length": 15
  },
  {
    "id": 4469,
    "uuid": "943cbb5c-4d49-4344-9a13-eaf1540d87d7",
    "hitokoto": "所谓人，无论是谁到了最后，都会形单影只。",
    "type": "a",
    "from": "悠久之翼2",
    "from_who": null,
    "creator": "unknowncloud",
    "creator_uid": 2196,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567157145",
    "length": 20
  },
  {
    "id": 4470,
    "uuid": "9ea2461a-8dd7-4e7a-9569-024cd71c07b9",
    "hitokoto": "长大了，才能体会什么是责任！",
    "type": "a",
    "from": "家庭",
    "from_who": null,
    "creator": "太白",
    "creator_uid": 3801,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567097176",
    "length": 14
  },
  {
    "id": 4471,
    "uuid": "f7aa11c2-d97b-4d51-98b8-0cdb89ed7f30",
    "hitokoto": "你是否会等待着我?我还想变的更加完美...",
    "type": "a",
    "from": "LoveLive!Sunshine!",
    "from_who": null,
    "creator": "No268435",
    "creator_uid": 3798,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567081662",
    "length": 21
  },
  {
    "id": 4485,
    "uuid": "67272dcb-4315-4a59-9419-3554e5a018f4",
    "hitokoto": "我只是想要得到「我没有逃避」的记忆吧。",
    "type": "a",
    "from": "三月的狮子",
    "from_who": null,
    "creator": "ouuan",
    "creator_uid": 2676,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560495574",
    "length": 19
  },
  {
    "id": 4494,
    "uuid": "7abab272-53a1-4861-a53a-e11113b5f9f0",
    "hitokoto": "人生海海，敢死不叫勇气，活着才需要勇气。",
    "type": "a",
    "from": "麦家-人生海海",
    "from_who": null,
    "creator": "水蜜桃",
    "creator_uid": 3385,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560913209",
    "length": 20
  },
  {
    "id": 4496,
    "uuid": "e6da1337-27f4-41a7-bbc7-642a6e73214e",
    "hitokoto": "我无知又愚蠢，世界残酷又疯狂。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1561040917",
    "length": 15
  },
  {
    "id": 4498,
    "uuid": "5759fc06-8ce0-4ca7-b306-1e3b750b56d9",
    "hitokoto": "我的面包！",
    "type": "a",
    "from": "Clannad",
    "from_who": null,
    "creator": "Steven_Meng",
    "creator_uid": 3449,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562110853",
    "length": 5
  },
  {
    "id": 4501,
    "uuid": "0d8b512a-c864-43f9-9576-9d662cd69e00",
    "hitokoto": "是我，是我先，明明都是我先来的，接吻也好，拥抱也好，还是喜欢上那家伙也好。",
    "type": "a",
    "from": "白色相簿2",
    "from_who": null,
    "creator": "birchtree",
    "creator_uid": 3455,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111249",
    "length": 37
  },
  {
    "id": 4502,
    "uuid": "79e8e908-936a-4130-9c7b-a8a15cac9d89",
    "hitokoto": "一旦醉心于狩猎，不到最后关头不会发现自己才是猎物。",
    "type": "a",
    "from": "来自新世界",
    "from_who": null,
    "creator": "birchtree",
    "creator_uid": 3455,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111388",
    "length": 25
  },
  {
    "id": 4503,
    "uuid": "ae6ca6a5-ce13-4650-aa22-7ca2b3201591",
    "hitokoto": "人类这种生物，不管有过多少不得不伴着泪水吞咽的教训，只要过了咽喉，所有教训便又会被彻底遗忘。",
    "type": "a",
    "from": "来自新世界",
    "from_who": null,
    "creator": "birchtree",
    "creator_uid": 3455,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111412",
    "length": 46
  },
  {
    "id": 4510,
    "uuid": "d97ad8be-683a-4c32-8374-df1a9f4553c1",
    "hitokoto": "即使我变弱了，也不代表你变强了。",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": null,
    "creator": "STman",
    "creator_uid": 2972,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562485818",
    "length": 16
  },
  {
    "id": 4517,
    "uuid": "bda4639e-3d83-4997-96db-0625d6b82a57",
    "hitokoto": "喜欢和不讨厌之间可是有着数亿光年的距离的。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562901900",
    "length": 21
  },
  {
    "id": 4518,
    "uuid": "fe63bea9-1978-4857-8ba3-c5e985b16d4b",
    "hitokoto": "痛苦着痛苦着，满脑子只能想我的事。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562902591",
    "length": 17
  },
  {
    "id": 4519,
    "uuid": "8a2d0604-849e-419b-83d2-4b0a5ecb0226",
    "hitokoto": "我拼命地挣扎，我对活下去的执著，都是因为你，是你让我，对和你一起度过的那段时光无比留恋。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562902777",
    "length": 44
  },
  {
    "id": 4520,
    "uuid": "55d1d815-630e-4633-a356-87cb5b6ec47e",
    "hitokoto": "站起来！站起来啊！你是我的腿吧！站起来啊！",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562902837",
    "length": 21
  },
  {
    "id": 4521,
    "uuid": "b4e23a28-23a7-4174-854f-ef7f6a431320",
    "hitokoto": "我不甘心，明明你为我做了那么多，我却什么都不能为你做。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562902904",
    "length": 27
  },
  {
    "id": 4522,
    "uuid": "067595e1-cfd1-4247-9355-a791785daec5",
    "hitokoto": "等着我，有马，不对，别回头，向前进，你要一直向前，我一定会追上来的。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562902954",
    "length": 34
  },
  {
    "id": 4523,
    "uuid": "6d00dad6-30a5-45af-92a6-dd2ed8e74bbe",
    "hitokoto": "就此分别吧！请继续向前，迎接樱花漫溢的四月，但请不要忘记我，友人A……",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "AThousandMoon",
    "creator_uid": 3063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562903155",
    "length": 35
  },
  {
    "id": 4528,
    "uuid": "e03c035c-21e1-4d91-82b3-68c7fc5815c3",
    "hitokoto": "那里还有——医生的房间啊！",
    "type": "a",
    "from": "Fate / Grand Order",
    "from_who": null,
    "creator": "Venus",
    "creator_uid": 3500,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562981156",
    "length": 13
  },
  {
    "id": 4537,
    "uuid": "267aece9-2b2a-4fb3-a627-f3f507ae0bca",
    "hitokoto": "因为我...我希望不做任何的努力，让对方喜欢上最真实的我。",
    "type": "a",
    "from": "女高中生的无所事事",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563036548",
    "length": 29
  },
  {
    "id": 4549,
    "uuid": "1c9ad34d-3584-46f1-8556-1d5c04b370bc",
    "hitokoto": "没有一封信是不必被送达的。",
    "type": "a",
    "from": "紫罗兰永恒花园",
    "from_who": null,
    "creator": "bql",
    "creator_uid": 3531,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563691469",
    "length": 13
  },
  {
    "id": 4550,
    "uuid": "6be01b20-f3ec-4c27-843e-52241966a9ad",
    "hitokoto": "我觉得，不改变也很好。",
    "type": "a",
    "from": "来自风平浪静的明天",
    "from_who": null,
    "creator": "bql",
    "creator_uid": 3531,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563695987",
    "length": 11
  },
  {
    "id": 4563,
    "uuid": "bb95def3-f218-4985-86a7-63436c54c962",
    "hitokoto": "痴情的妖怪啊,请再等一世吧。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": null,
    "creator": "checksen",
    "creator_uid": 3333,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564273746",
    "length": 14
  },
  {
    "id": 4569,
    "uuid": "3828e0f4-606c-4a22-b00b-79d1a3ed6077",
    "hitokoto": "你从我的手中展翅高飞，我深受打击。在这世上的某处，再次寻找崭新的你的影子，那就是我们之间的美好结局。",
    "type": "a",
    "from": "骚动时节的少女们啊",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1564927517",
    "length": 50
  },
  {
    "id": 4579,
    "uuid": "5ce10aad-9403-4841-bca8-ec0537b0e22d",
    "hitokoto": "一旦你尝试过天空的味道，你就会永远向上仰望",
    "type": "a",
    "from": "列奥那多·达芬奇",
    "from_who": null,
    "creator": "臻の泉",
    "creator_uid": 3676,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566354984",
    "length": 21
  },
  {
    "id": 4581,
    "uuid": "07ff542a-66ac-45c6-82f5-fb825be3624f",
    "hitokoto": "人间不温柔",
    "type": "a",
    "from": "李诞",
    "from_who": null,
    "creator": "南枝",
    "creator_uid": 3708,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566465687",
    "length": 5
  },
  {
    "id": 4584,
    "uuid": "c0d7c2b3-623a-41bc-81b0-ab7060ef34aa",
    "hitokoto": "知道和感觉到是两码事。",
    "type": "a",
    "from": "《看见》",
    "from_who": null,
    "creator": "toiii",
    "creator_uid": 3723,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566554173",
    "length": 11
  },
  {
    "id": 4585,
    "uuid": "af50bfec-8675-4bef-b9a7-fd2c93d68249",
    "hitokoto": "只要学不死，就往死里学。",
    "type": "a",
    "from": "网络热语",
    "from_who": null,
    "creator": "liebing",
    "creator_uid": 3727,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566554670",
    "length": 12
  },
  {
    "id": 4593,
    "uuid": "1b25cd71-38de-43cb-b82c-88f8d541ddf9",
    "hitokoto": "我是奥尔加·伊滋卡，几颗子弹不要紧的！",
    "type": "a",
    "from": "机动战士高达：铁血的孤儿",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566909395",
    "length": 19
  },
  {
    "id": 4594,
    "uuid": "60151e65-74ec-48d7-a6fc-cfe7eb798244",
    "hitokoto": "死亡的尽头，没有神",
    "type": "a",
    "from": "机动战士高达00:先驱者的觉醒",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566909746",
    "length": 9
  },
  {
    "id": 4597,
    "uuid": "79ca80c7-ac93-4640-b10c-761ee7e6816e",
    "hitokoto": "只要能和大家一起唱歌，大概就算毕业以后我们分开了，只要听见这首歌就能回想起现在。",
    "type": "a",
    "from": "TARI TARI",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567051969",
    "length": 40
  },
  {
    "id": 4598,
    "uuid": "f2039d3e-8bca-4212-b7ed-3324fa324e6f",
    "hitokoto": "我没能说出口，不管是那句「我走了」，还是那句「对不起」，或者那句「谢谢」...",
    "type": "a",
    "from": "TARI TARI",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567052306",
    "length": 39
  },
  {
    "id": 4600,
    "uuid": "a0079ff0-aa4f-4efb-b5bd-0fbadd810372",
    "hitokoto": "现世为梦，夜梦为真。",
    "type": "a",
    "from": "《xxxholic》",
    "from_who": null,
    "creator": "于归",
    "creator_uid": 3797,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567080688",
    "length": 10
  },
  {
    "id": 4604,
    "uuid": "972103a8-1d80-484f-8ec2-d457a9af859c",
    "hitokoto": "今天不想做，所以才要做",
    "type": "a",
    "from": "春上村树",
    "from_who": null,
    "creator": "嘟嘟噜",
    "creator_uid": 247,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567387561",
    "length": 11
  },
  {
    "id": 4605,
    "uuid": "e12cd6e5-04b1-4f13-bbc7-85c3a4884e55",
    "hitokoto": "嗯，明白。我们是天人的Gundam Meister",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567429261",
    "length": 25
  },
  {
    "id": 4614,
    "uuid": "3d36fea1-38cb-4b43-8758-1d3e65b9decf",
    "hitokoto": "不动身的话就永远无法追寻，哪怕是休息也不会就此停下。",
    "type": "a",
    "from": "Aqours",
    "from_who": null,
    "creator": "Chika Takami",
    "creator_uid": 3838,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567592758",
    "length": 26
  },
  {
    "id": 4615,
    "uuid": "8b3b25d3-4a25-43ea-9d3c-c8f96e2fb348",
    "hitokoto": "朝着下一道光芒横渡大海吧！",
    "type": "a",
    "from": "Aqours",
    "from_who": null,
    "creator": "Chika Takami",
    "creator_uid": 3838,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567592796",
    "length": 13
  },
  {
    "id": 4616,
    "uuid": "14e9e254-b836-4e96-ba68-fb018b994f01",
    "hitokoto": "这个世界啊，很美丽的，很广大的，很辽阔的！",
    "type": "a",
    "from": "Darling in the FRANXX",
    "from_who": null,
    "creator": "Chika Takami",
    "creator_uid": 3838,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567592815",
    "length": 21
  },
  {
    "id": 4617,
    "uuid": "91d0a252-0b7c-446d-af86-3bfa764fa844",
    "hitokoto": "我对Darling啊，最喜欢了。我们从今以后，都要在一起哦。",
    "type": "a",
    "from": "Darling in the FRANXX",
    "from_who": null,
    "creator": "Chika Takami",
    "creator_uid": 3838,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567592845",
    "length": 30
  },
  {
    "id": 4618,
    "uuid": "d8c9914c-7f3f-4c1b-8d67-ec33fc2d9c28",
    "hitokoto": "为了传达不到的思念而苦恼，只会感到痛不欲生。",
    "type": "a",
    "from": "WHITE FIRST LOVE",
    "from_who": null,
    "creator": "Chika Takami",
    "creator_uid": 3838,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567592872",
    "length": 22
  },
  {
    "id": 4629,
    "uuid": "7562f0b3-2acf-460f-8d00-fe014ead8609",
    "hitokoto": "千军万马滚滚来，不知何人留情怀！",
    "type": "a",
    "from": "Other",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970631",
    "length": 16
  },
  {
    "id": 4634,
    "uuid": "b1bba2e6-cf47-4a76-ac77-a0f8bdf6a7ad",
    "hitokoto": "用决斗......给大家......带来笑容......",
    "type": "a",
    "from": "游戏王\u003cA-RCV\u003e",
    "from_who": null,
    "creator": "不知火的橙子",
    "creator_uid": 3880,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568016445",
    "length": 28
  },
  {
    "id": 4637,
    "uuid": "b55e296a-03c5-4ffc-a88b-c9126ba59e83",
    "hitokoto": "别人的看法都是狗屁，你是谁只有你自己说了才算，这是爹教我的道理。",
    "type": "a",
    "from": "哪吒之魔童降世",
    "from_who": null,
    "creator": "木头人",
    "creator_uid": 3938,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568861108",
    "length": 32
  },
  {
    "id": 4642,
    "uuid": "88195f98-8466-4b37-bcfa-53cc48db17c0",
    "hitokoto": "或许前路永夜，即便如此我也要前进，因为星光即使微弱也会为我照亮前路。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": "宫园薰",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1579527722",
    "length": 34
  },
  {
    "id": 4657,
    "uuid": "f14cf46b-1d8a-4cd6-bcbb-df72c7e9bb13",
    "hitokoto": "这个世上没有无用的齿轮，也只有齿轮本身能决定自己的用途。",
    "type": "a",
    "from": "嫌疑人x的献身",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312335",
    "length": 28
  },
  {
    "id": 4668,
    "uuid": "08f4ecf3-bc63-44e8-87d5-b48eae8262f0",
    "hitokoto": "光就是羁绊之力，它会再度被某人继承，散发出耀眼的光。",
    "type": "a",
    "from": "奈克瑟斯奥特曼",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569328870",
    "length": 26
  },
  {
    "id": 4669,
    "uuid": "d603053b-950f-4abb-ac97-5dd5fe2bd92b",
    "hitokoto": "人们渴望像鸟儿一样自由自在地飞翔，可他们并没有想过，鸟儿也并不自由，它们之所以飞翔，是为了生存。",
    "type": "a",
    "from": "奈克瑟斯奥特曼",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569328940",
    "length": 48
  },
  {
    "id": 4670,
    "uuid": "f5260d71-36b6-47c2-bbd2-bb8b06b7b90b",
    "hitokoto": "记忆是不会消失的，只是一时想不起来了而已。",
    "type": "a",
    "from": "千与千寻",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569328996",
    "length": 21
  },
  {
    "id": 4671,
    "uuid": "508bd372-d72e-4af8-ab4d-7bb77adec6a9",
    "hitokoto": "我不借助别人的力量就没办法跟仰慕的人聊天吗？",
    "type": "a",
    "from": "女高中生的虚度日常",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569409493",
    "length": 22
  },
  {
    "id": 4672,
    "uuid": "529f3096-700c-4644-bba2-f622105a3105",
    "hitokoto": "强韧，无敌，最强！玉碎，粉碎，大喝彩！",
    "type": "a",
    "from": "海马濑人",
    "from_who": null,
    "creator": "灰流丽永不被指",
    "creator_uid": 3985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569464051",
    "length": 19
  },
  {
    "id": 4676,
    "uuid": "bb86a9f5-48f0-44f1-9fd1-528624397c4b",
    "hitokoto": "人的好意是沉重的。",
    "type": "a",
    "from": "黑神",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569775045",
    "length": 9
  },
  {
    "id": 4684,
    "uuid": "727253a7-6776-47ec-9d51-529328d8cb27",
    "hitokoto": "我们所度过的每个平凡的日常，也许就是连续发生的奇迹。",
    "type": "a",
    "from": "日常",
    "from_who": null,
    "creator": "jzl",
    "creator_uid": 4022,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1570259692",
    "length": 26
  },
  {
    "id": 4692,
    "uuid": "2e61e2e9-e5ad-48ab-9fa5-e301c59b6a22",
    "hitokoto": "我最喜欢三月的风，四月的雨，不落的太阳和最好的你",
    "type": "a",
    "from": "闺密",
    "from_who": null,
    "creator": "憨糊糊的闺密",
    "creator_uid": 4023,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570264355",
    "length": 24
  },
  {
    "id": 4697,
    "uuid": "344d1d8a-9c80-4a83-b0a3-1e5ef3cd2224",
    "hitokoto": "在末日中，人们总想寻找希望，但要真有希望的话，那还叫希望吗？",
    "type": "a",
    "from": "灵笼",
    "from_who": null,
    "creator": "xinyun",
    "creator_uid": 4039,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570584028",
    "length": 30
  },
  {
    "id": 4705,
    "uuid": "2f506d9f-419d-480d-bb46-2bd0dcf60fd7",
    "hitokoto": "可爱即是正义。",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "STman",
    "creator_uid": 2972,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570834278",
    "length": 7
  },
  {
    "id": 4706,
    "uuid": "ff66755a-07ba-4b77-98a7-e2ba08e2bbad",
    "hitokoto": "在末日中，人们总想寻找希望，但要真有希望的话，那还叫末日吗？",
    "type": "a",
    "from": "灵笼",
    "from_who": null,
    "creator": "xinyun",
    "creator_uid": 4039,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570873391",
    "length": 30
  },
  {
    "id": 4713,
    "uuid": "01f926a9-7263-493d-aa47-a3184ba397ec",
    "hitokoto": "只要抗争下去就能带来奇迹，这是恐怖分子的教诲，你给我记清楚了。",
    "type": "a",
    "from": "未来日记",
    "from_who": null,
    "creator": "STman",
    "creator_uid": 2972,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571397683",
    "length": 31
  },
  {
    "id": 4715,
    "uuid": "1b45f95b-c9e3-4cac-a98e-fec5d3e93e73",
    "hitokoto": "相信奇迹的人本身就和奇迹一样了不起啊",
    "type": "a",
    "from": "星游记",
    "from_who": null,
    "creator": "kurumit3",
    "creator_uid": 4102,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571497615",
    "length": 18
  },
  {
    "id": 4720,
    "uuid": "f8562b9d-d828-4c9a-b03a-040aa6aa5974",
    "hitokoto": "人类的赞歌就是勇气的赞歌。",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": null,
    "creator": "jhaseh",
    "creator_uid": 4818,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580886421",
    "length": 13
  },
  {
    "id": 4722,
    "uuid": "8625722b-0baa-406e-9dcc-f64950c180cc",
    "hitokoto": "你们腌太监也不会动人脑子啊！",
    "type": "a",
    "from": "铁心搏奕",
    "from_who": null,
    "creator": "矮雨",
    "creator_uid": 4798,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580808586",
    "length": 14
  },
  {
    "id": 4724,
    "uuid": "b3df18a9-4d7e-4a5b-a703-113999f0cf3b",
    "hitokoto": "这是你所不能理解的，人类感情的极致，比希望更热烈，比绝望更深邃——爱！",
    "type": "a",
    "from": "魔法少女小圆新篇",
    "from_who": null,
    "creator": "陈未来",
    "creator_uid": 1803,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580792217",
    "length": 35
  },
  {
    "id": 4726,
    "uuid": "78c82540-35cb-498b-be1b-06e0f8379e97",
    "hitokoto": "我不要你觉得，我要我觉得。",
    "type": "a",
    "from": "中餐厅",
    "from_who": "黄晓明",
    "creator": "187J3X1",
    "creator_uid": 4787,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580643555",
    "length": 13
  },
  {
    "id": 4757,
    "uuid": "2fa011f2-1180-4805-acaa-e061cda9d972",
    "hitokoto": "神啊，求求你。已经足够了。已经没事了。我们都会熬过去的。",
    "type": "a",
    "from": "天气之子",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370831",
    "length": 28
  },
  {
    "id": 4758,
    "uuid": "cec3565f-bf9d-4de2-ad3e-f18e0d871053",
    "hitokoto": "自古以来，天空上就是另一个世界。",
    "type": "a",
    "from": "天气之子",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370831",
    "length": 16
  },
  {
    "id": 4759,
    "uuid": "bd4f6b3f-0df2-479a-aea0-f1121e2fe452",
    "hitokoto": "在东京的天空上，我们决定性的改变了世界的模样。",
    "type": "a",
    "from": "天气之子",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370830",
    "length": 23
  },
  {
    "id": 4775,
    "uuid": "a9a2f484-2142-4fe3-a4aa-97d72303233e",
    "hitokoto": "向天空拼命伸出的双手，发射那么巨大的东西，只是为了寻找超出想象的彼岸所存在的东西。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370823",
    "length": 41
  },
  {
    "id": 4792,
    "uuid": "9c8b8ac9-d5d2-4d70-80a4-cdc240694913",
    "hitokoto": "你是否会等待着我？我会变得更加完美！",
    "type": "a",
    "from": "Aqours",
    "from_who": null,
    "creator": "BillZhou233",
    "creator_uid": 4131,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571894083",
    "length": 18
  },
  {
    "id": 4793,
    "uuid": "e3e6b00a-6a65-4094-8633-95cbb4f0939d",
    "hitokoto": "さあ，Games始めましょうか",
    "type": "a",
    "from": "游戏人生",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572011809",
    "length": 15
  },
  {
    "id": 4794,
    "uuid": "6d624f1b-bc13-4606-943b-5394c6f3d4c3",
    "hitokoto": "被一个自己不感兴趣的人示好，你不觉得没有比这更恶心的事吗",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572011865",
    "length": 28
  },
  {
    "id": 4795,
    "uuid": "2139ea78-287f-4fe8-903f-ac698abf4e67",
    "hitokoto": "世界上所有的不利状况都是因为当事者的能力不足",
    "type": "a",
    "from": "东京喰种",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572011831",
    "length": 22
  },
  {
    "id": 4796,
    "uuid": "57923250-0be9-4e03-93ce-56965b37a867",
    "hitokoto": "在虚构现实里寻求现实感的人才有问题",
    "type": "a",
    "from": "凉宫春日的忧郁",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572011895",
    "length": 17
  },
  {
    "id": 4800,
    "uuid": "a45eee18-69b7-4330-9764-27d5ef06429f",
    "hitokoto": "Ex - ploooosion !",
    "type": "a",
    "from": "为美好的世界献上祝福",
    "from_who": null,
    "creator": "Mys_C_K",
    "creator_uid": 4132,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571892944",
    "length": 17
  },
  {
    "id": 4802,
    "uuid": "479c259d-038c-46ae-859e-972fd05a4f8e",
    "hitokoto": "是我，是我先，明明都是我先来的……接吻也好，拥抱也好，还是喜欢上那家伙也好",
    "type": "a",
    "from": "白色相簿2",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572012080",
    "length": 37
  },
  {
    "id": 4803,
    "uuid": "f6dd3554-0c47-443a-ad7a-3bec112b22fd",
    "hitokoto": "没有一个世界会比活在这个世界痛苦",
    "type": "a",
    "from": "黑岩射手",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572012133",
    "length": 16
  },
  {
    "id": 4804,
    "uuid": "c03bdcf1-67cd-48c8-82a3-bb87025f4521",
    "hitokoto": "如果把那一端的敌人全部杀掉的话，我们就能自由了吗？",
    "type": "a",
    "from": "进击的巨人",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572012690",
    "length": 25
  },
  {
    "id": 4816,
    "uuid": "2f1e9cd4-b741-4d32-a0b0-76872980801d",
    "hitokoto": "今后我们来度过满是愉快之事的人生吧",
    "type": "a",
    "from": "Charlotte",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572061202",
    "length": 17
  },
  {
    "id": 4833,
    "uuid": "518f0047-f538-43ae-b25a-7f07122794bd",
    "hitokoto": "如果一切都是镜花水月，那就让这万物走向终结。如果一切皆是命中注定，那就让这世界消失殆尽。",
    "type": "a",
    "from": "失落的歌谣",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252896",
    "length": 44
  },
  {
    "id": 4838,
    "uuid": "3f9f240f-d5bf-4f92-81ff-f03d01166c9c",
    "hitokoto": "能够用自己喜欢的工作维持生活是件很幸福的事情",
    "type": "a",
    "from": "白箱",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572607947",
    "length": 22
  },
  {
    "id": 4840,
    "uuid": "73271c53-783a-4398-8c22-f321594c5c90",
    "hitokoto": "有的鱼是永远关不住的，因为他们属于天空。",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572772719",
    "length": 20
  },
  {
    "id": 4841,
    "uuid": "4bfeb20c-8424-47c7-988c-f0a53dec5cfe",
    "hitokoto": "我会化作人间的风雨陪在你的身边",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572772766",
    "length": 15
  },
  {
    "id": 4846,
    "uuid": "648d5c00-df8a-4bcd-b356-6b9f85f2814d",
    "hitokoto": "你以为你接受的是谁的爱，是一个天神的爱！他背叛所有神灵去爱你，为你忍受一切痛苦。",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572959829",
    "length": 40
  },
  {
    "id": 4849,
    "uuid": "994893ac-4bab-4d67-bf15-125b3a1e6c6c",
    "hitokoto": "深藏不露是一种卓越的才能",
    "type": "a",
    "from": "欢迎来到实力至上主义的教室",
    "from_who": null,
    "creator": "滑稽者",
    "creator_uid": 4240,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573267566",
    "length": 12
  },
  {
    "id": 4859,
    "uuid": "7a92d8e9-557f-44ea-b93d-3b2b0dff17ff",
    "hitokoto": "这样叹气的话，幸福会像四处逃散的小蜘蛛一样溜走的。",
    "type": "a",
    "from": "辉夜大小姐想让我告白",
    "from_who": null,
    "creator": "Ac1",
    "creator_uid": 4239,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573293881",
    "length": 25
  },
  {
    "id": 4860,
    "uuid": "5e398eef-f5cf-4ff6-a000-c24913de86dd",
    "hitokoto": "世上所以不公平之事是由于当事人能力不足所致。",
    "type": "a",
    "from": "金木研",
    "from_who": null,
    "creator": "夕之树",
    "creator_uid": 4248,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573331301",
    "length": 22
  },
  {
    "id": 4871,
    "uuid": "1e28212e-d129-4e6a-bd9d-5981d34454c8",
    "hitokoto": "雨滴降落的速度是每秒十米，我该用怎么样的速度，才能将你挽留？",
    "type": "a",
    "from": "言叶之庭",
    "from_who": null,
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581149583",
    "length": 30
  },
  {
    "id": 4874,
    "uuid": "e8c3f54f-210d-4d3b-a116-425371db7a30",
    "hitokoto": "樱花落下的速度是每秒五厘米， 我该用怎么样的速度，才能与你相遇。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": null,
    "creator": "湮灭_消滅する",
    "creator_uid": 4839,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581148909",
    "length": 32
  },
  {
    "id": 4884,
    "uuid": "cafb79d2-9958-4376-86e9-72073b33caa2",
    "hitokoto": "如果当时我们说了再见，后来是不是就可以再见",
    "type": "a",
    "from": "昨日青空",
    "from_who": null,
    "creator": "Skltri",
    "creator_uid": 4316,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574169183",
    "length": 21
  },
  {
    "id": 4888,
    "uuid": "2c836ed3-d73a-4111-ad65-882d93569fd1",
    "hitokoto": "音无结弦之日 跃动天使之心 立于浮华之世 奏响天籁之音",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "DreamerT",
    "creator_uid": 4257,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573486411",
    "length": 27
  },
  {
    "id": 4893,
    "uuid": "791de996-bbc9-4ec1-8196-d79279b9c21a",
    "hitokoto": "温柔正确的人总是难以生存，因为这世界既不温柔，也不正确。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "Love丶Aimer",
    "creator_uid": 4338,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574513471",
    "length": 28
  },
  {
    "id": 4919,
    "uuid": "b884657a-cb36-4aa7-aebb-4d32943c9e14",
    "hitokoto": "我一直注视着你，似近，似远。但你永远，看不见我……",
    "type": "a",
    "from": "来自风平浪静的明天",
    "from_who": "来自风平浪静的明天",
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572012204",
    "length": 25
  },
  {
    "id": 4920,
    "uuid": "c9dacb00-d403-486d-ac53-ec20894d07dc",
    "hitokoto": "与其被人扯碎校服，撕破心灵，倒不如直接剁碎自己的躯体，来得痛快。",
    "type": "a",
    "from": "黑岩射手",
    "from_who": null,
    "creator": "魑星辰",
    "creator_uid": 4074,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572012150",
    "length": 32
  },
  {
    "id": 4925,
    "uuid": "bfe012d9-34dd-4e3b-8124-8b77ae8a1c17",
    "hitokoto": "目标是以科学的力量凌驾于超能力之上，为了伯伦希尔的荣耀。",
    "type": "a",
    "from": "小绿和小蓝",
    "from_who": null,
    "creator": "今A",
    "creator_uid": 1611,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574562603",
    "length": 28
  },
  {
    "id": 4929,
    "uuid": "acb8c6b0-3805-4af9-8516-11c7eed0c63f",
    "hitokoto": "这东西是越嚼越有味哦~",
    "type": "a",
    "from": "BanG Dream! 2nd Season",
    "from_who": null,
    "creator": "potatopotat0",
    "creator_uid": 4352,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574657008",
    "length": 11
  },
  {
    "id": 4934,
    "uuid": "c3a5b00b-5f8a-48ac-a9a4-0667425e5ab6",
    "hitokoto": "即使再也没有晴天也没有关系.",
    "type": "a",
    "from": "天气之子",
    "from_who": null,
    "creator": "AmanoHina",
    "creator_uid": 4348,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574614675",
    "length": 14
  },
  {
    "id": 4940,
    "uuid": "e0e78632-fc92-4e3e-87c1-906817ba8a25",
    "hitokoto": "我一直以为最糟糕的情况是你离开我，其实最令我难过的，是你不快乐。",
    "type": "a",
    "from": "精灵旅社",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575474218",
    "length": 32
  },
  {
    "id": 4941,
    "uuid": "1b5bea52-0c88-4821-8812-c0f330375b49",
    "hitokoto": "キラキラ☆ドキドキ",
    "type": "a",
    "from": "戸山香澄",
    "from_who": null,
    "creator": "potatopotat0",
    "creator_uid": 4352,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574829959",
    "length": 9
  },
  {
    "id": 4971,
    "uuid": "bdf16ac1-6579-4ea2-ad5a-51c8e852505c",
    "hitokoto": "我下定决心要当海贼王，就算因此而战死，那也无所谓。",
    "type": "a",
    "from": "海贼王",
    "from_who": null,
    "creator": "wait.",
    "creator_uid": 3905,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581662974",
    "length": 25
  },
  {
    "id": 4975,
    "uuid": "55a89314-9c84-4eb2-bd20-0567ead9b391",
    "hitokoto": "规则是用来被打破的。",
    "type": "a",
    "from": "机械公敌",
    "from_who": null,
    "creator": "404NOTFOUND",
    "creator_uid": 4166,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581597455",
    "length": 10
  },
  {
    "id": 4977,
    "uuid": "aecd798a-94d4-424a-b0c5-3f609d359ae8",
    "hitokoto": "木叶飞舞之处，火亦生生不息",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "kirito",
    "creator_uid": 4899,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581592935",
    "length": 13
  },
  {
    "id": 4978,
    "uuid": "b1fae8ac-bca1-46c9-8326-a4d7cfc550f2",
    "hitokoto": "当我拔出第二把剑时，就是为了我所爱之人",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "kirito",
    "creator_uid": 4899,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581592857",
    "length": 19
  },
  {
    "id": 4979,
    "uuid": "add2a1cd-2bc7-4b91-bb50-4c7954028d7c",
    "hitokoto": "你指尖跃动的电光，是我此生不变的信仰，唯我超电磁炮永世长存。",
    "type": "a",
    "from": "某科学的超电磁炮",
    "from_who": null,
    "creator": "kirito",
    "creator_uid": 4899,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581592814",
    "length": 30
  },
  {
    "id": 4980,
    "uuid": "b66be92c-a1ca-48bc-9625-16c34f1fc5dd",
    "hitokoto": "遇事不决，量子力学。",
    "type": "a",
    "from": "青春期猪头少年不会梦到兔女郎学姐",
    "from_who": null,
    "creator": "kirito",
    "creator_uid": 4899,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581592776",
    "length": 10
  },
  {
    "id": 4989,
    "uuid": "4db60183-1720-451e-b07e-4fb2940ba51a",
    "hitokoto": "我们终会相遇相知，在那悠远的苍穹。",
    "type": "a",
    "from": "缘之空",
    "from_who": null,
    "creator": "悠远的苍穹",
    "creator_uid": 4871,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581496038",
    "length": 17
  },
  {
    "id": 4991,
    "uuid": "81bda8b0-152e-48a1-b172-b52c025ce4f5",
    "hitokoto": "Star Burst Stream!",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "桐人",
    "creator": "187J3X1",
    "creator_uid": 4787,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581486809",
    "length": 18
  },
  {
    "id": 5019,
    "uuid": "40ff4169-0c01-4d27-8506-6460c8553a16",
    "hitokoto": "虽然想做一团火，却成了一块透视苦难的冰",
    "type": "a",
    "from": "卡夫卡研究",
    "from_who": "马克思·布洛德",
    "creator": "CY-Track",
    "creator_uid": 4740,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580349773",
    "length": 19
  },
  {
    "id": 5022,
    "uuid": "600e1132-22fa-4dbb-8f23-fabcc0a9b300",
    "hitokoto": "生命可以随心所欲，但不能随波逐流",
    "type": "a",
    "from": "猫的报恩",
    "from_who": "宫崎骏",
    "creator": "CY-Track",
    "creator_uid": 4740,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580262933",
    "length": 16
  },
  {
    "id": 5029,
    "uuid": "80772e5a-0463-4371-bc04-1466e65d264a",
    "hitokoto": "我们所度过的每个平凡的日常，也许就是连续发生的奇迹",
    "type": "a",
    "from": "日常",
    "from_who": null,
    "creator": "245802003",
    "creator_uid": 4489,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576509407",
    "length": 25
  },
  {
    "id": 5031,
    "uuid": "b10c93c2-281d-4000-919d-fd344c355691",
    "hitokoto": "加油",
    "type": "a",
    "from": "自编",
    "from_who": null,
    "creator": "chibin",
    "creator_uid": 4532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1577117480",
    "length": 2
  },
  {
    "id": 5038,
    "uuid": "ca0ac2a1-6274-4144-b543-df98b4e9ccab",
    "hitokoto": "夕阳真是耀眼无比啊。",
    "type": "a",
    "from": "女高中生的虚度日常",
    "from_who": null,
    "creator": "天空绝不认输",
    "creator_uid": 4597,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578149905",
    "length": 10
  },
  {
    "id": 5042,
    "uuid": "fd05d7ee-44fb-4d6c-a6d7-d8ecbcae9f6d",
    "hitokoto": "今天我就要带她走，我看谁敢拦我",
    "type": "a",
    "from": "刺客伍六七",
    "from_who": null,
    "creator": "梦逍遥",
    "creator_uid": 4596,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578127402",
    "length": 15
  },
  {
    "id": 5044,
    "uuid": "29994d7b-cb60-4909-98d0-f350f2dcbdb1",
    "hitokoto": "这里有你,他现在只有我了。",
    "type": "a",
    "from": "罗小黑战记",
    "from_who": null,
    "creator": "梦逍遥",
    "creator_uid": 4596,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578407214",
    "length": 13
  },
  {
    "id": 5045,
    "uuid": "f4f1d472-91b3-4022-ab8f-33caee902196",
    "hitokoto": "星空之所以美丽，就是因为在无限的宇宙中，不管黑暗如何蔓延，都有星星的光芒去把它照亮。世界也是这样，有绝望的地方，就会有希望产生。",
    "type": "a",
    "from": "星游记",
    "from_who": null,
    "creator": "上官天涵",
    "creator_uid": 4614,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578454592",
    "length": 64
  },
  {
    "id": 5049,
    "uuid": "7aeaa28a-1a2e-4e63-8ab0-62cae1e6cd27",
    "hitokoto": "我来做最不想做的事情了。",
    "type": "a",
    "from": "22/7",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578836113",
    "length": 12
  },
  {
    "id": 5054,
    "uuid": "bb1e5bbd-a133-428c-b908-dd5a5053d1ee",
    "hitokoto": "你只见树，未见森林",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "信徒",
    "creator_uid": 4679,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579419894",
    "length": 9
  },
  {
    "id": 5055,
    "uuid": "00c26c9d-702a-4b5b-85bd-36804bfb6a86",
    "hitokoto": "你就赌我会死吧，因为你逢赌必输。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "信徒",
    "creator_uid": 4679,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1579420266",
    "length": 16
  },
  {
    "id": 5064,
    "uuid": "df4de3e9-b5f7-4309-986b-af5e2ae385e7",
    "hitokoto": "奶奶说过，男人有两件事不能做——绝不能让女孩子流泪和浪费食物。",
    "type": "a",
    "from": "假面骑士Kabuto",
    "from_who": "天道总司",
    "creator": "城南桥下",
    "creator_uid": 4738,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1580192663",
    "length": 31
  },
  {
    "id": 5069,
    "uuid": "696b6cdc-815c-4c9b-bfc7-fd516e33b710",
    "hitokoto": "正因为这样，我才决定任何时候都要尽全力享受人生，这样的话，无论什么时候死去，都是最幸福的一生了吧",
    "type": "a",
    "from": "恋爱随意链接",
    "from_who": "青木义文",
    "creator": "Hermione_Granger",
    "creator_uid": 4956,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581949139",
    "length": 48
  },
  {
    "id": 5072,
    "uuid": "f4d30b3a-509f-4adf-85e3-1d2bcc3c61ed",
    "hitokoto": "正因为有了所有的过去，才成就了现在的我。否定自己所走过的路途，就意味着否定现在的自己。",
    "type": "a",
    "from": "恋爱随意链接",
    "from_who": "永濑伊织",
    "creator": "Hermione_Granger",
    "creator_uid": 4956,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581949960",
    "length": 43
  },
  {
    "id": 5087,
    "uuid": "97bcd6a5-3161-4f33-a66e-5ad39c71d704",
    "hitokoto": "每个人每一天的价值都是完全相等的，无论做什么，都不会改变我今天活着的价值。",
    "type": "a",
    "from": "我想吃掉你的胰脏",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582469007",
    "length": 37
  },
  {
    "id": 5088,
    "uuid": "1501bd47-6a34-48f9-9317-459a70847885",
    "hitokoto": "我这个人呀，能过着这样平凡普通的日子就很开心了。",
    "type": "a",
    "from": "我想吃掉你的胰脏",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582469024",
    "length": 24
  },
  {
    "id": 5094,
    "uuid": "8320ea32-f360-4cb4-988f-0419d429f339",
    "hitokoto": "每个人能走到现在，都是自己选择的结果。",
    "type": "a",
    "from": "我想吃掉你的胰脏",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582469040",
    "length": 19
  },
  {
    "id": 5095,
    "uuid": "02ba5ece-97f7-48c3-b2cf-3010cd82ce8c",
    "hitokoto": "都说樱花飘落时让人伤感，而我看到樱花盛开也觉得伤感，因为我会计算，我还能再看几次樱花盛开呢。",
    "type": "a",
    "from": "我想吃掉你的胰脏",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582469088",
    "length": 46
  },
  {
    "id": 5096,
    "uuid": "d06bee8c-c0de-487f-80e4-9d84cadaeb74",
    "hitokoto": "只要人活在这世上就一定是有意义的，怎么活是自己选的。",
    "type": "a",
    "from": "我想吃掉你的胰脏",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582469103",
    "length": 26
  },
  {
    "id": 5097,
    "uuid": "f21fb8b6-05d7-4db7-b93a-ce4fcc7c2501",
    "hitokoto": "人生，一半是现实，一半是梦想。一念花开，一念花落。",
    "type": "a",
    "from": "火影忍者",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582570293",
    "length": 25
  },
  {
    "id": 5099,
    "uuid": "9d108470-6117-416c-8c23-8bbd3a45becb",
    "hitokoto": "我希望，我能完全信任你，我还从来没有能这样信任过谁。我也希望，你将给我最大的支持。",
    "type": "a",
    "from": "安妮日记",
    "from_who": "安妮·弗朗克",
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582649890",
    "length": 41
  },
  {
    "id": 5100,
    "uuid": "763fb7d9-9c89-4306-ba34-8da766726050",
    "hitokoto": "愿你有一天，能和你最重要的人重逢。",
    "type": "a",
    "from": "可塑性记忆",
    "from_who": "艾拉",
    "creator": "言叶之庭",
    "creator_uid": 5072,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582646213",
    "length": 17
  },
  {
    "id": 5110,
    "uuid": "06552491-9d49-4dff-8ff3-1f93ec419bf9",
    "hitokoto": "告诉我，神会流血吗？——神不会，但你会。",
    "type": "a",
    "from": "烦人的村民",
    "from_who": "Herobrine",
    "creator": "ZERO_PLAYER",
    "creator_uid": 5075,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582675361",
    "length": 20
  },
  {
    "id": 5128,
    "uuid": "29e787ac-6c91-4e00-985b-3736ceb0459b",
    "hitokoto": "さあ、始めようか。(那么，游戏开始吧。)",
    "type": "a",
    "from": "No Game No Life",
    "from_who": null,
    "creator": "005",
    "creator_uid": 4640,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578845250",
    "length": 20
  },
  {
    "id": 5131,
    "uuid": "aceae220-bae3-47a5-a7f0-a1e295756a9d",
    "hitokoto": "我讨厌温柔的女孩子，温柔的女孩子其实对所有人都温柔，而我却会误以为只对自己温柔，然后沾沾自喜得意忘形，最后弄得不欢而散，双方都受到伤害，所以我才讨厌温柔的女孩子。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "Love丶Aimer",
    "creator_uid": 4338,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1574513500",
    "length": 81
  },
  {
    "id": 5136,
    "uuid": "a97e172d-3033-4309-8368-e87d4f3d6420",
    "hitokoto": "无知而又纯洁的岁月。是任何人都曾拥有的。世界上没有一成不变的事务。所以只要以其他方式找到自己的快乐就行了。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "L小祈",
    "creator_uid": 4391,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575198205",
    "length": 53
  },
  {
    "id": 5141,
    "uuid": "030ff839-b054-49bc-91ea-7187f0eba9bd",
    "hitokoto": "粉色蓝宝石的宝石语是「献给弱者的正义」。",
    "type": "a",
    "from": "宝石商人理查德的谜鉴定",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578659605",
    "length": 20
  },
  {
    "id": 5154,
    "uuid": "611c41d4-18bc-472d-b378-47cd06c39ef9",
    "hitokoto": "喂，前面可是地狱啊！おい、この先は地狱だぜ！",
    "type": "a",
    "from": "Fate/stay night",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575601114",
    "length": 22
  },
  {
    "id": 5155,
    "uuid": "c4b2aabe-6afd-42cf-a042-0aa3f47c2dcb",
    "hitokoto": "Steel is my body, and fire is my blood.",
    "type": "a",
    "from": "Fate/stay night",
    "from_who": null,
    "creator": "海心月",
    "creator_uid": 4416,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575598994",
    "length": 39
  },
  {
    "id": 5173,
    "uuid": "19ae4ac5-62b7-4469-9aa6-32637ee6568a",
    "hitokoto": "游龙当归海，海不迎我自来也。",
    "type": "a",
    "from": "火影鸣人",
    "from_who": "自来也",
    "creator": "你会梦游，我会磨牙",
    "creator_uid": 5085,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582976316",
    "length": 14
  },
  {
    "id": 5176,
    "uuid": "ad2c2cd4-57af-44dd-a74f-429cdf684e45",
    "hitokoto": "孩子，我愿意为你而前行。",
    "type": "a",
    "from": "灵笼",
    "from_who": "埃隆教官",
    "creator": "scvoet",
    "creator_uid": 1713,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583132510",
    "length": 12
  },
  {
    "id": 5179,
    "uuid": "80804728-45f8-482d-832d-ea31e1a37a0d",
    "hitokoto": "世界上一切不利状况，都是因为当事人的能力不足。",
    "type": "a",
    "from": "东京食尸鬼",
    "from_who": null,
    "creator": "欧气震八荒",
    "creator_uid": 5166,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583046900",
    "length": 23
  },
  {
    "id": 5188,
    "uuid": "6d7ba898-47e2-41ff-b00a-2ca87b0942d8",
    "hitokoto": "隐约雷鸣，阴霾天空，即使天无雨，我亦留此地。",
    "type": "a",
    "from": "言叶之庭",
    "from_who": "新海诚",
    "creator": "KangKang",
    "creator_uid": 5192,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583157223",
    "length": 22
  },
  {
    "id": 5210,
    "uuid": "cdf09c46-0c9c-401b-aa66-434c3839fae7",
    "hitokoto": "没有未来的未来不是我想要的未来。",
    "type": "a",
    "from": "境界的彼方",
    "from_who": null,
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583412200",
    "length": 16
  },
  {
    "id": 5211,
    "uuid": "abd4f053-2d13-4894-a3b5-de3b71fc89b2",
    "hitokoto": "只要怀着理想而行动，就算结果不尽如人意也没有关系。但是如果失去了理想，那就真的一无所有了，连自己珍视的人都保护不了。",
    "type": "a",
    "from": "境界的彼方",
    "from_who": null,
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583412210",
    "length": 58
  },
  {
    "id": 5212,
    "uuid": "b27ce4ca-b2a0-4edb-85d6-33a9a595eb06",
    "hitokoto": "我喜欢你，比这个世界上其他任何人都喜欢你，我永远都会喜欢你的。只有我的这份心情是不会输给任何人的，即使我的这个身体毁灭了、从世界上消失了，来世我肯定还是会喜欢上你的。",
    "type": "a",
    "from": "境界的彼方",
    "from_who": null,
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583412305",
    "length": 83
  },
  {
    "id": 5213,
    "uuid": "a9559151-0282-4462-b505-0d6f23cbb499",
    "hitokoto": "愿有朝一日与你见面还能释放温暖拥你入怀。",
    "type": "a",
    "from": "境界的彼方",
    "from_who": null,
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583412323",
    "length": 20
  },
  {
    "id": 5223,
    "uuid": "fe6d9425-54fc-4ba1-8261-d4a77b615ffb",
    "hitokoto": "已经没什么好害怕了。",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": null,
    "creator": "jyeric",
    "creator_uid": 1981,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583634335",
    "length": 10
  },
  {
    "id": 5228,
    "uuid": "5cbc2b18-3011-44f4-9f9d-0d4ace413795",
    "hitokoto": "声起立华乐独奏，曲末音无心结弦。",
    "type": "a",
    "from": "Angel Beats!",
    "from_who": null,
    "creator": "宋章昕",
    "creator_uid": 4682,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583728014",
    "length": 16
  },
  {
    "id": 5235,
    "uuid": "306673c4-a7fd-499e-9caa-352ca4dc5e17",
    "hitokoto": "总在不停寻觅你的踪影，无论十字路口抑或梦境之中，明知你不在，却依然不停地找寻。",
    "type": "a",
    "from": "秒速5厘米",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583786562",
    "length": 39
  },
  {
    "id": 5238,
    "uuid": "2aa6ead2-1665-49bc-b986-7fa215ae54ca",
    "hitokoto": "只要引导着二人的两把命运之剑还在身边，我们就绝不会失败。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": "优吉欧",
    "creator": "Forest",
    "creator_uid": 5312,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583822578",
    "length": 28
  },
  {
    "id": 5243,
    "uuid": "4b830c5a-da97-4460-a315-e64126b5170c",
    "hitokoto": "这虽然这是游戏，但可不是闹着玩的。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "Forest",
    "creator_uid": 5312,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583822182",
    "length": 17
  },
  {
    "id": 5245,
    "uuid": "db6b311d-d7ec-43fc-b2f1-45d028f16950",
    "hitokoto": "花开得太好，所以摇摇欲坠；这一切的事情，老得这样快；世间一直熙攘着。",
    "type": "a",
    "from": "素年锦时",
    "from_who": null,
    "creator": "a632079",
    "creator_uid": 1044,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583786432",
    "length": 34
  },
  {
    "id": 5246,
    "uuid": "ca5fc510-775a-477e-b1b4-cadcbf65b526",
    "hitokoto": "人要意识到自己过得悲哀，需要很长时间；要意识到其实不必如此，则需要更久。",
    "type": "a",
    "from": "马男波杰克",
    "from_who": null,
    "creator": "冰微尘@",
    "creator_uid": 5251,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1583800405",
    "length": 36
  },
  {
    "id": 5268,
    "uuid": "d77b1a85-9132-476c-99be-ba7a9a4e53a0",
    "hitokoto": "从这里（太空）根本看不到什么国境线，只有地球。",
    "type": "a",
    "from": "星空清理者",
    "from_who": null,
    "creator": "冰砯",
    "creator_uid": 5376,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584024757",
    "length": 23
  },
  {
    "id": 5270,
    "uuid": "c7bea944-1c3b-498b-a87c-2ab14d885c93",
    "hitokoto": "你那无聊的幻想，就由我来打破！",
    "type": "a",
    "from": "魔法禁书目录",
    "from_who": "上条当麻",
    "creator": "名字？存在しない",
    "creator_uid": 5382,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584057698",
    "length": 15
  },
  {
    "id": 5271,
    "uuid": "8a92eed2-aa49-4457-90dd-20ee6c354f14",
    "hitokoto": "正义不是行使武力的理由，而是正相反——为了将动武的理由正当化，人们才会高喊正义。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "枯野瑛",
    "creator": "Sweetlemon",
    "creator_uid": 5389,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584084805",
    "length": 40
  },
  {
    "id": 5273,
    "uuid": "506a5165-dac8-4df5-a09d-3efa55bd79f8",
    "hitokoto": "君子无争，含光无形，坐忘无心。",
    "type": "a",
    "from": "秦时明月",
    "from_who": "楚南公",
    "creator": "‮",
    "creator_uid": 5401,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584103067",
    "length": 15
  },
  {
    "id": 5291,
    "uuid": "9c257839-8d2e-4a82-a424-b364bd569541",
    "hitokoto": "我在这里只学会一件事，那就是不到最后绝不轻言放弃。如果回到了现实世界，我一定会再度和桐人你相遇，然后重新喜欢上你。",
    "type": "a",
    "from": "刀剑神域",
    "from_who": null,
    "creator": "Forest",
    "creator_uid": 5312,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583821919",
    "length": 57
  },
  {
    "id": 5314,
    "uuid": "020d1f7a-2982-42e6-a477-a61e6ebe3451",
    "hitokoto": "最近我很喜欢明天见这句话，因为只要许下约定，就能期待明天的到来。",
    "type": "a",
    "from": "结城友奈是勇者",
    "from_who": "结城友奈",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585063313",
    "length": 32
  },
  {
    "id": 5317,
    "uuid": "35ad705c-a85a-45c0-b017-a6280238d718",
    "hitokoto": "就算没有意义，偶尔也会有好事发生。",
    "type": "a",
    "from": "终末少女旅行",
    "from_who": "尤莉",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585105300",
    "length": 17
  },
  {
    "id": 5321,
    "uuid": "01eb00e7-09cb-4004-bf3c-028688a55246",
    "hitokoto": "你将不再是道具，而是成为人如其名的人。",
    "type": "a",
    "from": "紫罗兰的永恒花园",
    "from_who": null,
    "creator": "龙一",
    "creator_uid": 5632,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585195442",
    "length": 19
  },
  {
    "id": 5323,
    "uuid": "cc2b77b1-9ea2-46c2-8b96-1dee6e8ebe96",
    "hitokoto": "大家热爱的事物，擅长的事物都不同，都拥有自己的世界，一个人一个世界，这些互相连接的话，就会展开许多的可能性，广大、未知，就像是宇宙一样。",
    "type": "a",
    "from": "恋爱小行星",
    "from_who": "木之幡米拉",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585356147",
    "length": 68
  },
  {
    "id": 5336,
    "uuid": "7d1ba68f-4b33-439d-88b4-d327a116708d",
    "hitokoto": "无论人生过得怎么样，都不要失去自己活着的意义，努力的去追逐心中的梦想，留下自己曾经在这个世界活过的痕迹，不要等到一切都失去了才追悔莫及。",
    "type": "a",
    "from": "天使的心跳",
    "from_who": "立华奏",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584956607",
    "length": 68
  },
  {
    "id": 5337,
    "uuid": "5e7305c2-0196-43ef-9eef-b6612a471dd8",
    "hitokoto": "人生没有那么多预算，不要等到到死后世界叹息，珍惜眼前所有。相信每天都是新的开始，都充满希望.",
    "type": "a",
    "from": "天使的心跳",
    "from_who": "立华奏",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584956662",
    "length": 46
  },
  {
    "id": 5338,
    "uuid": "33cda866-1cdf-40a7-96d3-b600ed6fb10f",
    "hitokoto": "真真需要记住的不是立华奏，而是天使身体里跳动的那颗永不结弦之心。",
    "type": "a",
    "from": "天使的心跳",
    "from_who": "立华奏",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584956714",
    "length": 32
  },
  {
    "id": 5340,
    "uuid": "8ce1eb71-7088-4d95-84e5-03c3fb08b00e",
    "hitokoto": "人总有一天会孤独一人，然后活在自己的回忆中。为了能笑着于孤独相依为命，我决定战斗下去，决定不会再以泪洗面。",
    "type": "a",
    "from": "天使的心跳",
    "from_who": "立华奏",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584957036",
    "length": 53
  },
  {
    "id": 5345,
    "uuid": "e61f064b-c594-404e-bda2-201c286fa0e0",
    "hitokoto": "与绝望~和睦相处。",
    "type": "a",
    "from": "少女终末旅行",
    "from_who": "尤莉\u0026千户",
    "creator": "萌萌哒SPC",
    "creator_uid": 5646,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585276913",
    "length": 9
  },
  {
    "id": 5359,
    "uuid": "f5016220-4cc3-43f1-af6a-294e1946445d",
    "hitokoto": "人类的赞歌是勇气的赞歌，人类的伟大是勇气的伟大！",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": "威廉·A·齐贝林",
    "creator": "橘子_ORANGE",
    "creator_uid": 5229,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585296142",
    "length": 24
  },
  {
    "id": 5361,
    "uuid": "93f449e7-d153-47dc-8aee-24eb24aa5590",
    "hitokoto": "孤独的人不会伤害别人，只会不断地伤害自己罢了。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "大老师",
    "creator": "papi",
    "creator_uid": 7,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585532719",
    "length": 23
  },
  {
    "id": 5366,
    "uuid": "364355b6-6717-455a-bd6d-450f845cb442",
    "hitokoto": "枷锁，自然规律，时光的流逝，名为身体的容器，名为心灵的自我。",
    "type": "a",
    "from": "四月一日灵异事件薄",
    "from_who": null,
    "creator": "bia",
    "creator_uid": 5687,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585475799",
    "length": 30
  },
  {
    "id": 5372,
    "uuid": "ec4304b4-2439-4cfb-9ced-7f9b944ff55c",
    "hitokoto": "没事没事，不同朋友擅长的事情也不同。",
    "type": "a",
    "from": "兽娘动物园",
    "from_who": "たつき",
    "creator": "cswhrdf7",
    "creator_uid": 5677,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585416830",
    "length": 18
  },
  {
    "id": 5380,
    "uuid": "cdaea91f-d8f0-49d7-98ed-f01d85299317",
    "hitokoto": "如果有人对我说抱有希望是错误的花，我会无数次回答“不是这样的”，无论什么时候都一定会这样撑下去。",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": "鹿目圆",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585104564",
    "length": 48
  },
  {
    "id": 5381,
    "uuid": "8bad470c-ac61-47a9-9a5e-d55c9c1f18eb",
    "hitokoto": "这么温暖的世界里有我，要感谢神明了。",
    "type": "a",
    "from": "Comic Girls",
    "from_who": "萌田熏子",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585104963",
    "length": 18
  },
  {
    "id": 5382,
    "uuid": "08498ddc-9557-4f1a-ad23-465725a12a73",
    "hitokoto": "Don't forget. Always,somewhere,someone is fighting for you. As long as you remember her,you are not alone.",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": "晓美焰",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585105552",
    "length": 106
  },
  {
    "id": 5383,
    "uuid": "04e2c261-1b2a-48e7-86ac-f56d8d146c11",
    "hitokoto": "这就是人类感情的极致，比希望更炽热，比绝望更深邃的，爱哟！",
    "type": "a",
    "from": "魔法少女小圆",
    "from_who": "晓美焰",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585105678",
    "length": 29
  },
  {
    "id": 5384,
    "uuid": "5ba3ee0b-3359-4b93-9d4c-a51d54c3acf5",
    "hitokoto": "露珠落去花留着，花萎露珠未消去。奈何露已随风去，花间寻觅不见珠。",
    "type": "a",
    "from": "学园孤岛",
    "from_who": "直树美纪",
    "creator": "yuuna",
    "creator_uid": 5606,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585105844",
    "length": 32
  },
  {
    "id": 5409,
    "uuid": "dd4e12eb-d452-4cd8-a9dd-3b75f36a8a95",
    "hitokoto": "波，高低起伏的东西；波，产生后开始扩散；波，自己无法抵抗的东西。",
    "type": "a",
    "from": "四月一日灵异事件薄",
    "from_who": null,
    "creator": "bia",
    "creator_uid": 5687,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585475466",
    "length": 32
  },
  {
    "id": 5424,
    "uuid": "a550123b-de54-418f-ab2a-deca208721cc",
    "hitokoto": "在這手心之中的，就是“心”啊。",
    "type": "a",
    "from": "死神",
    "from_who": "乌尔奇奥拉",
    "creator": "郭遥",
    "creator_uid": 5654,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585882659",
    "length": 15
  },
  {
    "id": 5428,
    "uuid": "f9277dda-ae3d-49e7-a24b-917f41031f8a",
    "hitokoto": "木叶飞舞之处，火亦生生不息。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "猿飞日斩",
    "creator": "Occam",
    "creator_uid": 5716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585649338",
    "length": 14
  },
  {
    "id": 5432,
    "uuid": "e1d5309d-2aab-4426-976e-227c53bba30b",
    "hitokoto": "你以为我是谁？这是我埋下的因，我要亲手解决这一切。",
    "type": "a",
    "from": "某科学的超电磁炮",
    "from_who": "御坂美琴",
    "creator": "xmlequn",
    "creator_uid": 5752,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585813798",
    "length": 25
  },
  {
    "id": 5961,
    "uuid": "a08d4092-84ea-462b-9803-a49f23ba480a",
    "hitokoto": "只要呼唤你的名字，我们的牵绊就永远不会消逝。",
    "type": "a",
    "from": "紫罗兰永恒花园外传：永远与自动手记人偶",
    "from_who": "艾米",
    "creator": "梦逍遥",
    "creator_uid": 4596,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586787898",
    "length": 22
  },
  {
    "id": 5966,
    "uuid": "b5dcbb9e-fba6-4111-abc4-d1dfd92320a3",
    "hitokoto": "我也许能再一次找到活着的目的，也许能再一次找到活着的意义，为了那些人，奉献出我的人生的话……",
    "type": "a",
    "from": "Angelbeats",
    "from_who": "音无结弦",
    "creator": "流浪汉",
    "creator_uid": 5935,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587106262",
    "length": 46
  },
  {
    "id": 5972,
    "uuid": "11b243f8-37fb-4796-9c75-085a5174506b",
    "hitokoto": "别低下头  排球是一门积极向上的运动！",
    "type": "a",
    "from": "排球少年",
    "from_who": null,
    "creator": "Erwin",
    "creator_uid": 5953,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587448247",
    "length": 19
  },
  {
    "id": 6016,
    "uuid": "08507e5b-68ff-4f65-ac87-ed0ae0a0fa42",
    "hitokoto": "理解何为孤单，努力想得到爱的你，内心的悲伤是否稍微宣泄了呢？",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": null,
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588646502",
    "length": 30
  },
  {
    "id": 6023,
    "uuid": "c5ea67d4-8ef8-4b2f-805e-7bea41b23dc3",
    "hitokoto": "自己不经意的一句话，触动了别人的心。",
    "type": "a",
    "from": "恋如雨止",
    "from_who": "近藤正己",
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1589297820",
    "length": 18
  },
  {
    "id": 6034,
    "uuid": "4d7445f7-224a-499e-930c-7d6277da3f84",
    "hitokoto": "游荡的孤高灵魂不需要羁绊之处。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": "渡航",
    "creator": "pinming",
    "creator_uid": 5924,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587047913",
    "length": 15
  },
  {
    "id": 6039,
    "uuid": "8e6759c4-1c9a-43b6-bcb4-16c0be83885f",
    "hitokoto": "如果说现在的日子过得很穷困，那我就去喜欢上穷困。",
    "type": "a",
    "from": "隐瞒之事",
    "from_who": "后藤姬",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587128926",
    "length": 24
  },
  {
    "id": 6045,
    "uuid": "000f5beb-1cb9-4637-b740-86b990ec0465",
    "hitokoto": "人和人之间就像这风筝一样，拉的太紧就飞不远，放的太松又掉下来，而当它飞的很高很高你还拽着不放，它就有可能会断掉，再也回不来了。",
    "type": "a",
    "from": "灵契",
    "from_who": "瓶子",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587536928",
    "length": 63
  },
  {
    "id": 6046,
    "uuid": "4d507004-a4ab-4cc1-83a2-34914c824b33",
    "hitokoto": "一日为灵，终生为影，灵气共生，魂命无分，阴阳调和，万物皆宁。",
    "type": "a",
    "from": "灵契",
    "from_who": "瓶子",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587537112",
    "length": 30
  },
  {
    "id": 6047,
    "uuid": "7348d7cb-5709-455d-8e46-0d4f5d2258a6",
    "hitokoto": "端木熙，别忘了，你是我的祭司，谁也别来跟我争，他神龙章轩不可以，神也不行。",
    "type": "a",
    "from": "灵契",
    "from_who": "瓶子",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587537190",
    "length": 37
  },
  {
    "id": 6048,
    "uuid": "f94aaf7c-9d21-4390-877f-40b6c80576eb",
    "hitokoto": "从今往后，你不能斩的人我来斩，你不能伤的人我来杀，既然你要保护这个世界，那我便保护你，这就是我的信念！",
    "type": "a",
    "from": "灵契",
    "from_who": "瓶子",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587537263",
    "length": 51
  },
  {
    "id": 6049,
    "uuid": "3004c714-2329-4edc-a08e-533a8b5ca319",
    "hitokoto": "千载流年一如梦，月落山河一世倾。",
    "type": "a",
    "from": "灵契",
    "from_who": "瓶子",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587537318",
    "length": 16
  },
  {
    "id": 6053,
    "uuid": "eec496b7-59c6-48c8-9ea4-0a3ed6b2e3e8",
    "hitokoto": "不可结缘，徒留寂寞……",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": "夏目友人帐",
    "creator": "Jamesjili",
    "creator_uid": 6007,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587618180",
    "length": 11
  },
  {
    "id": 6088,
    "uuid": "c6087865-57d8-42c8-8549-d32a9509e2b5",
    "hitokoto": "一代锤子一代皇，代代锤子教做人！",
    "type": "a",
    "from": "斗罗大陆",
    "from_who": "102集弹幕",
    "creator": "Rainbow after rain",
    "creator_uid": 6069,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588494321",
    "length": 16
  },
  {
    "id": 6106,
    "uuid": "d226f5d1-bd4e-416b-96ec-c1f95fa7d747",
    "hitokoto": "花早晚会凋谢，记忆最终也会消散。",
    "type": "a",
    "from": "镇魂街",
    "from_who": null,
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588659101",
    "length": 16
  },
  {
    "id": 6107,
    "uuid": "96c42da2-737e-4044-b08e-e05a69d59e7f",
    "hitokoto": "所谓首领，只不过是被势力绑架上制高点的走狗而已。而且，都是身不由己的走狗。",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": "东方月初",
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588659240",
    "length": 37
  },
  {
    "id": 6108,
    "uuid": "080ad240-2965-45f1-9e2d-a5eff77da242",
    "hitokoto": "无论是人类还是妖怪，只要内心希望他人接触，那么就是相同的存在；会因独处而感到寂寞，也会害怕踏出第一步。",
    "type": "a",
    "from": "夏目友人帐",
    "from_who": "夏目",
    "creator": "PercyDan",
    "creator_uid": 6125,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1588659273",
    "length": 51
  },
  {
    "id": 6125,
    "uuid": "944c4990-df5f-40aa-85f1-eec29783d236",
    "hitokoto": "未来始终掌握在自己手中，从中滑落的，我们称之为过去。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": null,
    "creator": "Liak",
    "creator_uid": 6141,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588760783",
    "length": 26
  },
  {
    "id": 6130,
    "uuid": "f1b85dc8-9aef-41f0-8754-3a211d80af39",
    "hitokoto": "我不努力，就见不到你了啊。",
    "type": "a",
    "from": "昨日之歌",
    "from_who": "野中晴",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1591538136",
    "length": 13
  },
  {
    "id": 6131,
    "uuid": "07d369d6-c8d5-4d82-8f52-d55c56214575",
    "hitokoto": "无可取代的东西要到失去后才知道珍惜呢。",
    "type": "a",
    "from": "干物妹小埋",
    "from_who": null,
    "creator": "爱喝快乐水的小埋",
    "creator_uid": 6431,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591697988",
    "length": 19
  },
  {
    "id": 6137,
    "uuid": "c1e3bf41-76d1-4d09-9638-b4038630b01f",
    "hitokoto": "没有什么背叛，只不过是忠诚过期了而已。",
    "type": "a",
    "from": "凹凸世界",
    "from_who": "帕洛斯",
    "creator": "AMU",
    "creator_uid": 6407,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591446636",
    "length": 19
  },
  {
    "id": 6172,
    "uuid": "fc9af7f6-feba-49d5-ba2b-da4db4de6742",
    "hitokoto": "Ko no Dio da!",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": "迪奥",
    "creator": "Fight_xing",
    "creator_uid": 6244,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589893939",
    "length": 13
  },
  {
    "id": 6173,
    "uuid": "6b7191d9-e960-480e-8438-35bdf4be7d79",
    "hitokoto": "我们不是大人，而是同学吧。",
    "type": "a",
    "from": "恋如雨止",
    "from_who": "九条千寻",
    "creator": "酷儿",
    "creator_uid": 6,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589905646",
    "length": 13
  },
  {
    "id": 6180,
    "uuid": "8727b6ed-ea5f-4cbb-b69a-5fe6619f8557",
    "hitokoto": "今天的我，凌驾于阿修罗之上！",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": "格拉汉姆",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590321135",
    "length": 14
  },
  {
    "id": 6181,
    "uuid": "d2edc339-026e-4eb0-8eea-5e0f451c50e3",
    "hitokoto": "Exia，驱逐目标！",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": "刹那F清英",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590321173",
    "length": 10
  },
  {
    "id": 6207,
    "uuid": "20743d60-3235-4680-894c-91380f872e81",
    "hitokoto": "花无凋零之时，爱无传达之期，爱情亘古不变，紫罗兰永世长存。",
    "type": "a",
    "from": "紫罗兰永恒花园",
    "from_who": "曉佳奈",
    "creator": "V",
    "creator_uid": 6333,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590833495",
    "length": 29
  },
  {
    "id": 6209,
    "uuid": "081df546-9dbd-48e7-ad30-df8ae6881a59",
    "hitokoto": "相比昨日明日，今天更适合开始。",
    "type": "a",
    "from": "Comic Girls",
    "from_who": "杉坂天汰",
    "creator": "香风智成",
    "creator_uid": 6324,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590759314",
    "length": 15
  },
  {
    "id": 6235,
    "uuid": "b61c43d6-e531-4f96-98a1-995ebc2c3702",
    "hitokoto": "呐~~凯利，你想成为怎样的大人。",
    "type": "a",
    "from": "Fate/Zero",
    "from_who": "夏丽",
    "creator": "pythonworld",
    "creator_uid": 6391,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591368561",
    "length": 16
  },
  {
    "id": 6236,
    "uuid": "10ad7508-1ee5-4bc8-b87d-b88191da4fad",
    "hitokoto": "当敌人变成战友多半是为了生存，而战友变成敌人多半是为了金钱。",
    "type": "a",
    "from": "端脑",
    "from_who": "GM",
    "creator": "shellingford",
    "creator_uid": 250,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591336430",
    "length": 30
  },
  {
    "id": 6245,
    "uuid": "9d90c5cc-9814-45b5-a23b-1bc9010e21fc",
    "hitokoto": "正因为听不见和看不到，所以风子才会做这样的事情。",
    "type": "a",
    "from": "Clannad",
    "from_who": "风子",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913656",
    "length": 24
  },
  {
    "id": 6246,
    "uuid": "58301746-3a2b-4976-ae5a-4c8551f19f0d",
    "hitokoto": "我们开始一起攀登，这长长的，长长的坡道。",
    "type": "a",
    "from": "Clannad",
    "from_who": "渚",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913678",
    "length": 20
  },
  {
    "id": 6247,
    "uuid": "330d373d-f7cc-4985-859a-5afa5fd3cd58",
    "hitokoto": "无知而又纯洁的岁月是任何人都曾拥有的，世界上没有一成不变的事物，所以只要以其他方式找到自己的快乐就行了。",
    "type": "a",
    "from": "Clannad",
    "from_who": "冈崎朋也",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913720",
    "length": 52
  },
  {
    "id": 6248,
    "uuid": "336ab0ee-e827-4b59-9835-0df1da683ce7",
    "hitokoto": "前天是小兔子，昨天是小鹿，今天是你。",
    "type": "a",
    "from": "Clannad",
    "from_who": "一之濑琴美",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913774",
    "length": 18
  },
  {
    "id": 6249,
    "uuid": "5cc5e5d1-171a-402a-8c12-515bceccf7e6",
    "hitokoto": "能哭的地方只有厕所和爸爸的怀里。",
    "type": "a",
    "from": "Clannad",
    "from_who": "汐",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913790",
    "length": 16
  },
  {
    "id": 6250,
    "uuid": "866a47c8-4005-4508-b8d4-0371fc2e8483",
    "hitokoto": "美好的事情，现在才开始呐。",
    "type": "a",
    "from": "Clannad",
    "from_who": "伊吹风子",
    "creator": "Jkkoi",
    "creator_uid": 6332,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590913820",
    "length": 13
  },
  {
    "id": 6276,
    "uuid": "5db1816a-a2e9-4dd0-a51d-bd9f49bc5233",
    "hitokoto": "什么叫忍者？学会忍耐的人就叫忍者。",
    "type": "a",
    "from": "哔哩哔哩",
    "from_who": null,
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591971197",
    "length": 17
  },
  {
    "id": 6289,
    "uuid": "145992fc-9dca-4a12-b5a4-8d0c56f1d1ce",
    "hitokoto": "既然没有终点，那在何处又何妨呢。",
    "type": "a",
    "from": "异度侵入",
    "from_who": null,
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592460956",
    "length": 16
  },
  {
    "id": 6290,
    "uuid": "4e70b812-ee17-4664-a71a-c68410bfe803",
    "hitokoto": "人生在世只有一次，不必勉强选择自己不喜欢的路，随性而生或随性而死都没关系，不过，无论选择哪条路，都不要忘记保护自己所珍惜的人。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "猿飞日斩",
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592528467",
    "length": 63
  },
  {
    "id": 6291,
    "uuid": "82a5ba4a-74d8-46eb-8d60-1282054362fc",
    "hitokoto": "只要是人都是依靠自己的知识与认知并且被之束缚生活着的，那就叫做现实。但是知识与认知是模糊不清的东西，现实也许只是镜花水月，人都是活在自己的执念中的。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "宇智波鼬",
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592528503",
    "length": 74
  },
  {
    "id": 6293,
    "uuid": "d4db0a71-8472-4c3d-860d-ee5ec59e9580",
    "hitokoto": "当你们试图去寻找死的意义……能找到的……只有痛苦…和不知道归向何方的憎恨……",
    "type": "a",
    "from": "火影忍者",
    "from_who": "佩恩",
    "creator": "北笙",
    "creator_uid": 6495,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592528561",
    "length": 38
  },
  {
    "id": 6309,
    "uuid": "ee530a9b-5fda-4946-842b-27fa2b20e547",
    "hitokoto": "我连宇宙尽头在哪里都不知道，怎么会知道这个。",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": "马里奥·兹凯罗",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592727189",
    "length": 22
  },
  {
    "id": 6323,
    "uuid": "4f545d8b-bbd5-4f4a-9f87-d57266c1c171",
    "hitokoto": "无论世界如何改变，我们都将永不分离。",
    "type": "a",
    "from": "GOSICK",
    "from_who": "维多利加",
    "creator": "FangbrbrFangbrbr",
    "creator_uid": 6540,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593004512",
    "length": 18
  },
  {
    "id": 6324,
    "uuid": "baa69bf5-fdc6-4254-a6fd-4b6e710ea624",
    "hitokoto": "火焰啊，燃烧吧，燃烧吧！照亮……那孩子的未来。",
    "type": "a",
    "from": "GOSICK",
    "from_who": "维多利亚",
    "creator": "FangbrbrFangbrbr",
    "creator_uid": 6540,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593004683",
    "length": 23
  },
  {
    "id": 6338,
    "uuid": "ca530d4d-a93d-480a-a38a-62e785f0f9a7",
    "hitokoto": "牙白得斯内！",
    "type": "a",
    "from": "公主连结Re:Dive",
    "from_who": null,
    "creator": "二狸",
    "creator_uid": 6592,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593435231",
    "length": 6
  },
  {
    "id": 6347,
    "uuid": "b0fcce01-1dce-4b0c-8874-56f6fc407e77",
    "hitokoto": "不能逃避，不能逃避，不能逃避。",
    "type": "a",
    "from": "EVA",
    "from_who": "碇真嗣",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543414",
    "length": 15
  },
  {
    "id": 6348,
    "uuid": "4d099ee4-302e-4835-a9eb-3b54733cfb63",
    "hitokoto": "我是为了与你相见才诞生于世的。",
    "type": "a",
    "from": "EVA",
    "from_who": "渚薰",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543455",
    "length": 15
  },
  {
    "id": 6349,
    "uuid": "afc506eb-c7f1-4bbf-bd20-92ae3d67dd3e",
    "hitokoto": "我将送你最美的鲜花。",
    "type": "a",
    "from": "怪物Monster",
    "from_who": "约翰·李贝特",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543500",
    "length": 10
  },
  {
    "id": 6350,
    "uuid": "b10f5c16-8f15-4f80-ba68-9912a2f7c8e1",
    "hitokoto": "我的出生就是为了用鲜花将你淹没。",
    "type": "a",
    "from": "怪物Monster",
    "from_who": "约翰.李贝特",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593543606",
    "length": 16
  },
  {
    "id": 6359,
    "uuid": "a011413b-f507-42b6-833f-ba26334bf7d0",
    "hitokoto": "心急火燎地想要长大，明明还是个小鬼。",
    "type": "a",
    "from": "CLANNAD ～AFTER STORY～",
    "from_who": "古河秋生",
    "creator": "たんじろう！",
    "creator_uid": 6628,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593879156",
    "length": 18
  },
  {
    "id": 6360,
    "uuid": "4d1a0aa3-03f2-4206-b3c5-f12242b0e0e4",
    "hitokoto": "在时间的流逝里，没有什么是一成不变的。",
    "type": "a",
    "from": "CLANNAD ～AFTER STORY～",
    "from_who": "古河渚",
    "creator": "たんじろう！",
    "creator_uid": 6628,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593879174",
    "length": 19
  },
  {
    "id": 6361,
    "uuid": "1699109e-6f30-4efd-b20b-96c5e6dd49f1",
    "hitokoto": "爸爸，我能不再忍了吗？早苗说了，世界上能够放声大哭的地方，只有卫生间，和爸爸的怀里。",
    "type": "a",
    "from": "CLANNAD ～AFTER STORY～ EP18",
    "from_who": "冈崎汐",
    "creator": "たんじろう！",
    "creator_uid": 6628,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593879237",
    "length": 42
  },
  {
    "id": 6362,
    "uuid": "d8e7f08a-0633-4c95-ad38-384042fd50ac",
    "hitokoto": "冈崎，永远都别迷失自己最珍爱的事物啊。",
    "type": "a",
    "from": "CLANNAD ～AFTER STORY～",
    "from_who": "芳野佑介",
    "creator": "たんじろう！",
    "creator_uid": 6628,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593879295",
    "length": 19
  },
  {
    "id": 6390,
    "uuid": "83e2b2d2-d1b2-46b3-872d-385cf285871b",
    "hitokoto": "有些东西不管你怎么努力也无法挽回，也有无论怎么挣扎都逃脱不了的绝望。",
    "type": "a",
    "from": "黑执事",
    "from_who": "夏尔·凡多姆海威",
    "creator": "麻吉酷博异",
    "creator_uid": 6796,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595666418",
    "length": 34
  },
  {
    "id": 6397,
    "uuid": "6cc735a4-3c84-49ef-b1f7-93a873e13499",
    "hitokoto": "你在那么美丽的地方，纯属奇迹般的偶然。",
    "type": "a",
    "from": "理科生坠入情网故尝试证明",
    "from_who": "雪村心叶",
    "creator": "zzhhq",
    "creator_uid": 6788,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595572123",
    "length": 19
  },
  {
    "id": 6411,
    "uuid": "ba56c9fe-ee5d-4dfc-85e8-5dfe2908adc4",
    "hitokoto": "做好人需要比恶人更狡猾，他们的名字终将成为传说，而真实沉没于历史的波涛中。",
    "type": "a",
    "from": "万国志",
    "from_who": "万国志",
    "creator": "厌猫",
    "creator_uid": 5103,
    "reviewer": 1,
    "commit_from": "app",
    "created_at": "1595664074",
    "length": 37
  },
  {
    "id": 6413,
    "uuid": "9fe746bb-99e5-435e-90ab-023909ffda47",
    "hitokoto": "一旦失去的东西，就再也拿不回来了。",
    "type": "a",
    "from": "黑执事",
    "from_who": "夏尔·凡多姆海威",
    "creator": "麻吉酷博异",
    "creator_uid": 6796,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1595666602",
    "length": 17
  },
  {
    "id": 6415,
    "uuid": "5a36601f-27a5-4355-b93a-03747680a382",
    "hitokoto": "难道我输了吗？",
    "type": "a",
    "from": "火影忍者",
    "from_who": "宇智波·带土",
    "creator": "ITACHI",
    "creator_uid": 6876,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596514209",
    "length": 7
  },
  {
    "id": 6428,
    "uuid": "d3c84c04-7658-43b7-a5f8-a14cb9f546f8",
    "hitokoto": "遇到事情不能坐以待毙。",
    "type": "a",
    "from": "捷德奥特曼",
    "from_who": null,
    "creator": "雨啸青锋",
    "creator_uid": 5808,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596722538",
    "length": 11
  },
  {
    "id": 6442,
    "uuid": "18b16cbe-89ed-46ab-ad1e-a55b43567150",
    "hitokoto": "我必须要变强，但是孤独居然这么痛苦。",
    "type": "a",
    "from": "黑色五叶草",
    "from_who": "高顿",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596600302",
    "length": 18
  },
  {
    "id": 6455,
    "uuid": "54e2be4e-68a2-4a1a-8d16-5bb01314cd47",
    "hitokoto": "我的回合，抽卡！",
    "type": "a",
    "from": "游戏王",
    "from_who": "高桥和希",
    "creator": "liggest",
    "creator_uid": 6946,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597307637",
    "length": 8
  },
  {
    "id": 6463,
    "uuid": "8394e8b6-08c5-4f22-9ad5-023bc05a4db2",
    "hitokoto": "再相见，会是怎样的世界？",
    "type": "a",
    "from": "升起的烟花，从下面看？还是从侧面看?",
    "from_who": "及川菜津奈",
    "creator": "cswhrdf7",
    "creator_uid": 5677,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1597627709",
    "length": 12
  },
  {
    "id": 6467,
    "uuid": "0346fef1-3197-4075-b2a7-4575a9c4fc7d",
    "hitokoto": "憧憬是距离理解最遥远的一种感情。",
    "type": "a",
    "from": "死神",
    "from_who": "蓝染惣右介",
    "creator": "李无生",
    "creator_uid": 7454,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602692960",
    "length": 16
  },
  {
    "id": 6485,
    "uuid": "abdfac1b-0c1e-4587-bf06-9fe61fb6ddb1",
    "hitokoto": "两个囚犯从监狱的窗户往外看，一个看到了泥地，一个看到了星星。",
    "type": "a",
    "from": "JOJO的奇妙冒险",
    "from_who": "荒木飞吕彦",
    "creator": "白玉楼的白麻薯",
    "creator_uid": 5325,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597733718",
    "length": 30
  },
  {
    "id": 6496,
    "uuid": "fceff054-5fb1-4b9b-9e1a-dbe9bec372e8",
    "hitokoto": "我可是要成为海贼王的男人！",
    "type": "a",
    "from": "海贼王",
    "from_who": "路飞",
    "creator": "qffk",
    "creator_uid": 6995,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597813308",
    "length": 13
  },
  {
    "id": 6506,
    "uuid": "724981b0-4f47-4d16-b4c9-701a75459342",
    "hitokoto": "人找不到某种东西沉迷就活不下来。人都是某种东西的奴隶。",
    "type": "a",
    "from": "进击的巨人",
    "from_who": "肯尼·阿克曼",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598013540",
    "length": 27
  },
  {
    "id": 6508,
    "uuid": "8fe87bed-6587-4468-a676-145a34afe3a3",
    "hitokoto": "也许我的灵魂彷徨了几万年，不过就是为了与你相遇。",
    "type": "a",
    "from": "JOJO的奇妙冒险·战斗潮流",
    "from_who": "瓦姆乌",
    "creator": "白玉楼的白麻薯",
    "creator_uid": 5325,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597733471",
    "length": 24
  },
  {
    "id": 6587,
    "uuid": "4ffc1c0b-4a08-4f3d-9deb-b1ab867eb5f4",
    "hitokoto": "英雄意味着强大，英雄意味着孤独，最后一幕一定是英雄渐行渐远，我的英雄也是那样的存在。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": "相座武士",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598692553",
    "length": 42
  },
  {
    "id": 6594,
    "uuid": "c3aadbaf-f1f1-4047-a651-9d8f0001c0d0",
    "hitokoto": "世界怎样与我无关，以我自己的意识！",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": "格拉汉姆艾卡",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603201196",
    "length": 17
  },
  {
    "id": 6596,
    "uuid": "cc904842-4be6-4c99-b85d-cc763d197d08",
    "hitokoto": "宛如花朵在风中摇摆起舞，宛如雨露滋润大地，这世界的万物相互依存共同延续。",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": "片尾曲Trust You",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603200718",
    "length": 36
  },
  {
    "id": 6597,
    "uuid": "35bea592-e08d-4b55-8454-8472a632f212",
    "hitokoto": "不论目睹怎样的现实 也不要迷失那个说「即便如此」的自我 这就是你的骨气。",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": "玛莉妲·库鲁斯",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603200929",
    "length": 36
  },
  {
    "id": 6598,
    "uuid": "9433fd7d-2364-44af-a24d-3dc594ded894",
    "hitokoto": "たとえどんな现実を突きつられようと それでもと・言い続ける 自分を见失うな。",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603201023",
    "length": 38
  },
  {
    "id": 6599,
    "uuid": "8175f20f-8a91-4ae8-94fe-446d63147f11",
    "hitokoto": "おれは 人の悲しさを 悲しい感じる心があるんなって事を 忘れなくない それを受け止められる人间になりたいです。",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603200953",
    "length": 55
  },
  {
    "id": 6607,
    "uuid": "e85539d0-cb75-4bb2-9bca-85719d19423e",
    "hitokoto": "为了维护自己,渐渐地失去,就算无法做好,屡屡受伤 ,也不要心生怨恨。",
    "type": "a",
    "from": "樱与抱月",
    "from_who": null,
    "creator": "yuuki_asuna",
    "creator_uid": 7461,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603441688",
    "length": 34
  },
  {
    "id": 6608,
    "uuid": "0938bb31-8726-4994-a23e-ad6673ed0c5f",
    "hitokoto": "我明白，洛克昂。我是只能选择战斗的破坏者，所以要战斗，为击败催生战争的人，粉碎这扭曲。",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603201151",
    "length": 43
  },
  {
    "id": 6609,
    "uuid": "827e9969-f008-4e0b-b772-2d122819281c",
    "hitokoto": "无法入眠的凌晨两点，烦躁就像在敲门。",
    "type": "a",
    "from": "RUNNING TO HORIZON",
    "from_who": "こむろてつや",
    "creator": "Yuina",
    "creator_uid": 6844,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603534006",
    "length": 18
  },
  {
    "id": 6619,
    "uuid": "f57abfe3-87ea-4fbe-8ac6-fa71f12f8e46",
    "hitokoto": "梦是现实的延续，现实是梦的终结。",
    "type": "a",
    "from": "Eva",
    "from_who": "绫波丽",
    "creator": "i",
    "creator_uid": 6605,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1604176910",
    "length": 16
  },
  {
    "id": 6666,
    "uuid": "219d44c8-4abb-4338-907d-c6ff3c65683a",
    "hitokoto": "战斗是残酷的，无法做出多余的考虑！",
    "type": "a",
    "from": "机动战士高达",
    "from_who": "夏亚阿兹布纳尔",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604587737",
    "length": 17
  },
  {
    "id": 6667,
    "uuid": "c36032f7-dd07-4f82-a038-be10f18bbef0",
    "hitokoto": "人类的伟大就是勇气的伟大！人类的赞歌就是勇气的赞歌！",
    "type": "a",
    "from": "jojo的奇妙冒险",
    "from_who": "齐贝林男爵",
    "creator": "草生出来了",
    "creator_uid": 7674,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604751842",
    "length": 26
  },
  {
    "id": 6687,
    "uuid": "402f976b-076c-4d86-95b9-1ea1020e58d3",
    "hitokoto": "前天我遇见了小兔，昨天遇见了小鹿，今天则遇见了你。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": "一之濑琴美",
    "creator": "Nozomi",
    "creator_uid": 7738,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605262054",
    "length": 25
  },
  {
    "id": 6742,
    "uuid": "546e5262-886c-466f-8727-4bdafb57ef26",
    "hitokoto": "只要你们不停下来，那前面就一定有我。所以啊，不要停下来……",
    "type": "a",
    "from": "机动战士高达 铁血的奥尔芬斯",
    "from_who": "奥尔加",
    "creator": "70CentsApple",
    "creator_uid": 7798,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605931719",
    "length": 29
  },
  {
    "id": 6752,
    "uuid": "ebd29812-be5f-4e28-97c6-7dbc400a0713",
    "hitokoto": "不管是快乐，还是欣喜，全都……全都不可能永远延续，即使是这样，你也会喜欢这里吗？",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "pro_hjc",
    "creator_uid": 7821,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606313018",
    "length": 40
  },
  {
    "id": 6753,
    "uuid": "d3e7cf75-003d-41f2-a43c-bdee687d1e70",
    "hitokoto": "如期待奇迹发生，那唯有不停伸手去抓紧，去把握才行",
    "type": "a",
    "from": "秒速5厘米",
    "from_who": null,
    "creator": "麻婆豆腐",
    "creator_uid": 8368,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1612804578",
    "length": 24
  },
  {
    "id": 6754,
    "uuid": "0d65aaed-fc56-47fc-a3dc-3044622efaa2",
    "hitokoto": "即便分开，羁绊仍然是存在的，这就是所谓的家人。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "pro_hjc",
    "creator_uid": 7821,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606313052",
    "length": 23
  },
  {
    "id": 6755,
    "uuid": "865ac7f8-deca-4178-8925-103bc029fc6a",
    "hitokoto": "世界上没有一成不变的事物，所以只要以其他方式找到自己的快乐就行了。",
    "type": "a",
    "from": "CLANNAD",
    "from_who": null,
    "creator": "pro_hjc",
    "creator_uid": 7821,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606313111",
    "length": 33
  },
  {
    "id": 6757,
    "uuid": "55adae02-8a97-4f73-bdba-0df350299e43",
    "hitokoto": "青春总是焦虑的，连一勺砂糖溶于杯中的时间都等不及。后悔带来的苦涩，是对过去的见证，终将逐一化为杯中咖啡的味道。",
    "type": "a",
    "from": "玉子爱情故事",
    "from_who": null,
    "creator": "pro_hjc",
    "creator_uid": 7821,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606313541",
    "length": 55
  },
  {
    "id": 6758,
    "uuid": "8cfad566-5db5-4ddf-a1ae-7bb1046b63f3",
    "hitokoto": "今まで生きてきで，今が一番幸せかもしれない。",
    "type": "a",
    "from": "言叶之庭",
    "from_who": "新海诚",
    "creator": "feiwuqianqi",
    "creator_uid": 7862,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606377299",
    "length": 22
  },
  {
    "id": 6772,
    "uuid": "f4d27a3b-23ba-4268-8a5f-6b11f7342566",
    "hitokoto": "嗯。我的梦想也成真了，美好的回忆也留下了，我想我不会再有什么遗憾了。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "珂朵莉·诺塔·瑟尼欧里斯",
    "creator": "SomeyaMako",
    "creator_uid": 7867,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606404060",
    "length": 34
  },
  {
    "id": 6787,
    "uuid": "c43786e4-8d7e-4e54-82cb-d5b54c27da5b",
    "hitokoto": "他有一双好眼睛，就是他将我从黑暗的迷途中带了回来。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "日向宁次",
    "creator": "system",
    "creator_uid": 7869,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606442453",
    "length": 25
  },
  {
    "id": 6811,
    "uuid": "85d087e1-7cf3-43c2-bf15-9a5b4481ec31",
    "hitokoto": "愿你有一天能与你最重要的人重逢。",
    "type": "a",
    "from": "可塑性记忆",
    "from_who": null,
    "creator": "udfgr",
    "creator_uid": 8687,
    "reviewer": 9016,
    "commit_from": "web",
    "created_at": "1615180662",
    "length": 16
  },
  {
    "id": 6824,
    "uuid": "a2515da3-edb0-4ee2-a74a-410d4b0e5024",
    "hitokoto": "干燥的空气，尘埃的味道，我在其中……踏上旅途。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": "宫园薰",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606974839",
    "length": 23
  },
  {
    "id": 6907,
    "uuid": "65310c10-8595-429b-a9a6-5156a5232177",
    "hitokoto": "我向星星许了个愿。我并不是真的相信它，但是反正也是免费的，而且也没有证据证明它不灵。",
    "type": "a",
    "from": "加菲猫的幸福生活",
    "from_who": "加菲猫",
    "creator": "scvoet",
    "creator_uid": 1713,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608223879",
    "length": 42
  },
  {
    "id": 6912,
    "uuid": "a700a1e3-48d7-4e67-a37d-2b99efcb0dd4",
    "hitokoto": "这也算是一条路啊，或许这样会更加幸福一些。",
    "type": "a",
    "from": "半妖的夜叉姬",
    "from_who": null,
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429459",
    "length": 21
  },
  {
    "id": 6917,
    "uuid": "dcefd8c6-65fd-411b-9a80-f5bdece85686",
    "hitokoto": "我们即使发了一千次短信，心与心之间大概也只能靠近1厘米。",
    "type": "a",
    "from": "秒速五厘米",
    "from_who": "远野贵树",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608625182",
    "length": 28
  },
  {
    "id": 6919,
    "uuid": "e1aee6ca-b109-451c-b656-bde374259ca6",
    "hitokoto": "因为拒绝了世间所有的美好，才会比任何人都要温柔。",
    "type": "a",
    "from": "空は高く風は歌う - 「Fate/Zero」ED2",
    "from_who": null,
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608687470",
    "length": 24
  },
  {
    "id": 6943,
    "uuid": "f546eb22-bd74-49fd-8c3b-ff03eb680111",
    "hitokoto": "I'm bad, and that's good. I will never be good, and that's not bad. There's no one I'd rather be than me.",
    "type": "a",
    "from": "无敌破坏王",
    "from_who": "拉尔夫",
    "creator": "Clementine2019",
    "creator_uid": 8137,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610877136",
    "length": 105
  },
  {
    "id": 6947,
    "uuid": "e609053e-5183-4277-ac12-33ad4e28dcbb",
    "hitokoto": "狙击目标！",
    "type": "a",
    "from": "机动战士高达00",
    "from_who": "洛克昂",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611229672",
    "length": 5
  },
  {
    "id": 6948,
    "uuid": "33b9d04d-e116-443e-b688-8243ac4eb350",
    "hitokoto": "齿轮也有齿轮的志气！",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": "联邦军队长",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611229927",
    "length": 10
  },
  {
    "id": 6949,
    "uuid": "1dfbf921-8957-45d8-9dbd-5b0ceeae91c6",
    "hitokoto": "爸爸，妈妈，对不起，我，要去了！",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": "巴纳吉林克斯",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611230230",
    "length": 16
  },
  {
    "id": 6953,
    "uuid": "9239cf92-20b4-4f56-9cc3-dc92482ce86f",
    "hitokoto": "从认识你，到和你性命相连，我从未后悔过。",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": "椿",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432093",
    "length": 20
  },
  {
    "id": 6954,
    "uuid": "2c1a335a-ea4e-4135-b8d1-583913aa014b",
    "hitokoto": "相信朋友是不需要理由的。",
    "type": "a",
    "from": "从零开始的异世界生活 第二季",
    "from_who": "奥托",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432391",
    "length": 12
  },
  {
    "id": 6956,
    "uuid": "dcbda30a-a349-4e0d-82a6-39f859a18585",
    "hitokoto": "你将不再是工具，而是人如其名的人。",
    "type": "a",
    "from": "紫罗兰永恒花园",
    "from_who": "少佐",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432531",
    "length": 17
  },
  {
    "id": 6958,
    "uuid": "51323b3f-c005-44b4-b3b8-91abc65f4727",
    "hitokoto": "Explotion！",
    "type": "a",
    "from": "为美好的世界献上祝福",
    "from_who": "慧慧",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432676",
    "length": 10
  },
  {
    "id": 6959,
    "uuid": "e15c4c25-8835-4fbf-b6f9-9e36e4585b6d",
    "hitokoto": "现在的我，一定是世界上最幸福的女孩子。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "珂朵莉",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432772",
    "length": 19
  },
  {
    "id": 6960,
    "uuid": "f3fc621a-2cc6-476d-aa19-06b92b43cdc4",
    "hitokoto": "寂寞的时候，就呼唤我的名字吧。",
    "type": "a",
    "from": "紫罗兰永恒花园外传",
    "from_who": "艾米",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611432968",
    "length": 15
  },
  {
    "id": 6961,
    "uuid": "b79951c0-ff10-4702-a91d-0a819551df7a",
    "hitokoto": "总之就是非常可爱！",
    "type": "a",
    "from": "总之就是非常可爱",
    "from_who": "由崎星空",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611433002",
    "length": 9
  },
  {
    "id": 6962,
    "uuid": "68d976db-20b3-477f-a162-ebdb1c8c6278",
    "hitokoto": "万水千山，你愿意和我一起看吗？",
    "type": "a",
    "from": "狐妖小红娘",
    "from_who": "王权富贵",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611433147",
    "length": 15
  },
  {
    "id": 6963,
    "uuid": "37ec8519-8113-48a0-9ca5-1c44234913eb",
    "hitokoto": "这个地方的人们，就是我战斗的理由。",
    "type": "a",
    "from": "战翼的希格德莉法",
    "from_who": "卡劳迪亚",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611433207",
    "length": 17
  },
  {
    "id": 6964,
    "uuid": "b7d8cef8-5811-48a6-af31-303a0051ed3b",
    "hitokoto": "上天给我们生命，一定是为了让我们创造奇迹的。",
    "type": "a",
    "from": "大鱼海棠",
    "from_who": "椿",
    "creator": "莉娅碳的骑士",
    "creator_uid": 8310,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611433368",
    "length": 22
  },
  {
    "id": 6965,
    "uuid": "b6e4f6ad-3d55-4814-a653-4b26e99306c5",
    "hitokoto": "你的双眼能够看到多远的未来。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "宇智波鼬",
    "creator": "BlueHeart0621",
    "creator_uid": 8312,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611458809",
    "length": 14
  },
  {
    "id": 6969,
    "uuid": "3fdc4333-d8a3-43c9-8c79-2742364a9a79",
    "hitokoto": "王与坐骑的区别—在于本能！",
    "type": "a",
    "from": "死神",
    "from_who": "白一护",
    "creator": "SinGer",
    "creator_uid": 8345,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611683791",
    "length": 13
  },
  {
    "id": 7003,
    "uuid": "b3e81035-460d-4bc3-a01a-e59d9b4826c5",
    "hitokoto": "自认为为他人好而做的事情，并不一定正确。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "伊雷娜",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612285806",
    "length": 20
  },
  {
    "id": 7004,
    "uuid": "6a72105e-e648-4d33-80b2-dd7a490f3533",
    "hitokoto": "请别在意。我是旅人，得继续旅行才行。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "伊雷娜",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612285820",
    "length": 18
  },
  {
    "id": 7005,
    "uuid": "40f560b2-0a02-441a-900c-d878bbb2e48f",
    "hitokoto": "要是有事情不称心，就起身反抗吧。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "芙兰",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612285910",
    "length": 16
  },
  {
    "id": 7006,
    "uuid": "fd7471bc-3ef3-45c3-ab28-5a28edeb880f",
    "hitokoto": "不要就是不要，要学会大声说出口，这样才能保护你自己。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "芙兰",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612285977",
    "length": 26
  },
  {
    "id": 7007,
    "uuid": "b246a1ff-c81c-4a22-9a0b-a76bdadd707c",
    "hitokoto": "当真心想要做成一件事的时候，人总是孤独的，必须孤身一人，相互依赖上就完了。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "伊雷娜",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612286028",
    "length": 37
  },
  {
    "id": 7008,
    "uuid": "f7df7b3e-0d7e-4cfa-9792-7c03b538407f",
    "hitokoto": "温柔与美丽，偶尔也是残忍的。",
    "type": "a",
    "from": "魔女之旅",
    "from_who": "伊雷娜",
    "creator": "Hytf233",
    "creator_uid": 7017,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612286081",
    "length": 14
  },
  {
    "id": 7020,
    "uuid": "84c67ac1-af47-4511-afda-137d722f52a5",
    "hitokoto": "“为什么要选择这条路”这种问题，是决不能问出口的，只有在暴风雨里问自己。",
    "type": "a",
    "from": "三月的狮子",
    "from_who": null,
    "creator": "286799714",
    "creator_uid": 8426,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612495014",
    "length": 36
  },
  {
    "id": 7023,
    "uuid": "96e184f7-a91c-4837-be8f-809e74742002",
    "hitokoto": "小的时候，总认为世界是单纯的。",
    "type": "a",
    "from": "游戏人生 zero",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613612136",
    "length": 15
  },
  {
    "id": 7024,
    "uuid": "b262892e-ff0d-4bbc-a7fd-c4574bd941e3",
    "hitokoto": "这个世界对温柔的你可一点也不温柔呀。",
    "type": "a",
    "from": "军火女王",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613612166",
    "length": 18
  },
  {
    "id": 7032,
    "uuid": "9495988e-6991-490c-81fa-10da588a9b81",
    "hitokoto": "蔷薇不管被冠以什么名字，却依旧可以芳香扑鼻。",
    "type": "a",
    "from": "我的青春恋爱物语果然有问题",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613612105",
    "length": 22
  },
  {
    "id": 7033,
    "uuid": "9ee63685-03bf-463f-9e68-2e10806f69fe",
    "hitokoto": "伤害别人的人，要有被别人伤害的觉悟。",
    "type": "a",
    "from": "罪恶王冠",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613612197",
    "length": 18
  },
  {
    "id": 7040,
    "uuid": "218806c1-0075-4e72-b95c-e882af388b78",
    "hitokoto": "人可以为他人舍弃自身的生命，但并不代表你我的伟大。伟大的、美丽的是已经逝去的他们，我们只是卑微地、愚昧地、苟延残喘地，在这地狱中挣扎，匍匐着拼命求生，仅此而已。",
    "type": "a",
    "from": "UN-GO",
    "from_who": "结成新十郎",
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613612041",
    "length": 80
  },
  {
    "id": 7066,
    "uuid": "f55979c3-dab9-424e-bbea-119c22ab21cb",
    "hitokoto": "有时写信才能表达，平时难以说出口的心声。",
    "type": "a",
    "from": "紫罗兰的永恒花园",
    "from_who": "薇尔莉特·伊芙嘉登",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613909274",
    "length": 20
  },
  {
    "id": 7067,
    "uuid": "23372d39-b040-4989-87e6-67a6e9d1e241",
    "hitokoto": "我和空太是恋人以上，友人未满的关系。",
    "type": "a",
    "from": "樱花庄的宠物女孩",
    "from_who": "椎名真白",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613909892",
    "length": 18
  },
  {
    "id": 7068,
    "uuid": "0dfd7b95-206f-42a2-8ebf-9205a0344893",
    "hitokoto": "愿你和重要的人，在来日重逢。",
    "type": "a",
    "from": "可塑性记忆",
    "from_who": "艾拉",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613909996",
    "length": 14
  },
  {
    "id": 7071,
    "uuid": "1c65a9d5-1642-46e8-805f-e0a1f8929f20",
    "hitokoto": "When the dawn is close inside, we never say good-bye and never see again.",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "Ever be my love",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613910231",
    "length": 73
  },
  {
    "id": 7078,
    "uuid": "3a288587-4768-4d1c-9526-a4f9822f6c6b",
    "hitokoto": "我会欺骗你，欺骗世界，欺骗自己。",
    "type": "a",
    "from": "Princess Principle",
    "from_who": "安洁",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614086524",
    "length": 16
  },
  {
    "id": 7079,
    "uuid": "1c8708f0-a46f-4ff9-9068-bde9f01e0fb9",
    "hitokoto": "好想尝试一下把整颗心都掏出来献给爱人的感觉，我能体验吗？那种恋爱。",
    "type": "a",
    "from": "青春纪行",
    "from_who": "多田万里",
    "creator": "梦逍遥",
    "creator_uid": 4596,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614095631",
    "length": 33
  },
  {
    "id": 7082,
    "uuid": "93851f56-1247-4c5c-92c0-65e5589b3dd4",
    "hitokoto": "我们还没年老到，对被注定的未来，欣然接受的年纪。想要去到更高的地方，我们便无所畏惧。",
    "type": "a",
    "from": "数码宝贝：最后的进化 絆",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1620913584",
    "length": 42
  },
  {
    "id": 7089,
    "uuid": "42ee0f05-6b05-46f8-9c73-def29b2625d3",
    "hitokoto": "就一会儿，再在这里待一会儿好吗？我要把你深深地印在脑海里，为了只要闭上眼，就能随时见到花丛中的你。",
    "type": "a",
    "from": "元气少女缘结神◎ 10集 21:55",
    "from_who": "二郎丸",
    "creator": "dai'key",
    "creator_uid": 8728,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615577912",
    "length": 49
  },
  {
    "id": 7106,
    "uuid": "565f6fb0-2fad-4a85-b806-965dd8d1dad6",
    "hitokoto": "独步天下，吾心自洁，无欲无求，如林中之象。",
    "type": "a",
    "from": "攻壳机动队Ⅱ无罪",
    "from_who": "巴特",
    "creator": "20020731",
    "creator_uid": 8820,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616685185",
    "length": 21
  },
  {
    "id": 7111,
    "uuid": "0010884f-79c2-4a6d-9161-5e78631af78b",
    "hitokoto": "连繁星都不是永恒的，何况是人呢。",
    "type": "a",
    "from": "中二病也要谈恋爱！",
    "from_who": "富樫勇太",
    "creator": "Hermione_Granger",
    "creator_uid": 4956,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1617807613",
    "length": 16
  },
  {
    "id": 7117,
    "uuid": "9136da44-1310-460f-a2eb-7e7d21d002bd",
    "hitokoto": "每段灿烂的回忆，都是琐碎的小事，是我一直珍藏的宝物，只要你能将这其中任何一件事记在心里，毫不夸张的说，那便足以支撑我活下去。这世上谁都不及你好。",
    "type": "a",
    "from": "人渣的本愿",
    "from_who": "安乐冈花火",
    "creator": "如月三穗",
    "creator_uid": 8351,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618745116",
    "length": 72
  },
  {
    "id": 7125,
    "uuid": "039d2802-7a60-4240-8312-b5ca85748d7f",
    "hitokoto": "回忆都是美好的，记忆却是痛苦。回忆全部被记录下来，可记忆不一定能想起来。",
    "type": "a",
    "from": "全部成为F",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1619334135",
    "length": 36
  },
  {
    "id": 7127,
    "uuid": "93edcf21-39be-4b49-9aa3-3f3ebd080dca",
    "hitokoto": "我的恋爱还没有开始就结束了。",
    "type": "a",
    "from": "樱花庄的宠物女孩",
    "from_who": "姬宫伊织",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1613909865",
    "length": 14
  },
  {
    "id": 7130,
    "uuid": "f7f06b21-2b5a-45ae-83a2-bb20dca739a3",
    "hitokoto": "十年前的你，喜欢过我吗？",
    "type": "a",
    "from": "路人女主的养成方法",
    "from_who": "泽村·斯潘塞·英梨梨",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614084868",
    "length": 12
  },
  {
    "id": 7141,
    "uuid": "fca77279-1b14-4b1f-b906-2ea4aab10e5d",
    "hitokoto": "有时写信才能表达，平时难以说出口的心声。",
    "type": "a",
    "from": "紫罗兰的永恒花园",
    "from_who": "薇尔莉特·伊芙嘉登",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614341756",
    "length": 20
  },
  {
    "id": 7142,
    "uuid": "fde0112a-fe11-4d87-a588-b8013328163e",
    "hitokoto": "没有一封信不必要被送达，因为没有一份思念不需要被送达。",
    "type": "a",
    "from": "紫罗兰的永恒花园",
    "from_who": "薇尔莉特·伊芙嘉登",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614342110",
    "length": 27
  },
  {
    "id": 7143,
    "uuid": "9fb6e6cf-47d5-463a-b2da-f5b216cfb46c",
    "hitokoto": "唯有前进，才能享受这被诅咒的疯狂。",
    "type": "a",
    "from": "机动战士高达雷霆宙域",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614349660",
    "length": 17
  },
  {
    "id": 7144,
    "uuid": "f49de0d7-451b-411f-af17-7efc4d0569bf",
    "hitokoto": "不可以逃避！活下去！活下去也是一种战斗！",
    "type": "a",
    "from": "机动战士高达独角兽",
    "from_who": "卡嘉丽·尤拉·阿斯哈",
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614349874",
    "length": 20
  },
  {
    "id": 7155,
    "uuid": "94f58b49-a2a3-462a-8061-596cf7befe9f",
    "hitokoto": "你可以祈祷，但神不会倾听。",
    "type": "a",
    "from": "寂静王冠",
    "from_who": "神父",
    "creator": "CBS",
    "creator_uid": 8538,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614403257",
    "length": 13
  },
  {
    "id": 7160,
    "uuid": "c2e6bd3c-29bb-4bd4-83f8-8b239f654f5e",
    "hitokoto": "——比起自己的生命还要重要的东西，并不是这么好找的。",
    "type": "a",
    "from": "末日时在做什么？能不能再见一面？",
    "from_who": "潘丽宝·诺可·卡黛娜",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614514288",
    "length": 26
  },
  {
    "id": 7161,
    "uuid": "90fb2c43-61b7-4be9-b47d-10eddbbc94fe",
    "hitokoto": "恩，好像做了很多梦呢，快乐的，悲伤的，每个都很短，但是全都很珍贵。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "艾陆可·霍克斯登",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614514533",
    "length": 33
  },
  {
    "id": 7168,
    "uuid": "04a99968-0c87-4f70-9905-bf3dbaa5211c",
    "hitokoto": "所以，请你抬起头，笑着为我的旅途祝福吧。 一直以来谢谢你陪伴我，听我的那些谎话。和你的相遇，是我一生最珍贵的记忆。",
    "type": "a",
    "from": "死后文",
    "from_who": "兰",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614945596",
    "length": 57
  },
  {
    "id": 7174,
    "uuid": "08581239-a97e-4949-8286-315235c9fa61",
    "hitokoto": "谁说死后文只能寄信件。 清澄才藏君， 你寄出的，是五十年不变的誓约。",
    "type": "a",
    "from": "死后文",
    "from_who": "清澄千章",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946590",
    "length": 34
  },
  {
    "id": 7175,
    "uuid": "637c691b-193c-44a8-a89b-d90cd6be403f",
    "hitokoto": "所谓的奇迹正是由于其耀眼而短暂的光芒而被成为奇迹。奇迹终将过去，而过去之后一切会归于沉寂。",
    "type": "a",
    "from": "成神之日",
    "from_who": "P.A.WORKS",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946756",
    "length": 45
  },
  {
    "id": 7179,
    "uuid": "86259de2-47db-4395-97c4-73f5fa238f3c",
    "hitokoto": "战争是什么？战争只不过是一群人对于另一群人的屠杀，只不过是屠杀的对象有所不同而已。",
    "type": "a",
    "from": "紫罗兰的永恒花园",
    "from_who": "艾丹",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946963",
    "length": 41
  },
  {
    "id": 7181,
    "uuid": "7b1c50d9-f021-44ea-a63a-9e3440796881",
    "hitokoto": "对于那个被照顾的人，她剩下的人生变得不再孤单寂寞，变得不再因为生命必然的终结而不能沾染上明丽的色彩。",
    "type": "a",
    "from": "仰望半月的夜空",
    "from_who": "Group Tac",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614947469",
    "length": 50
  },
  {
    "id": 7200,
    "uuid": "c8f5fe20-0148-4bf3-b0c9-4fcc8e8fe789",
    "hitokoto": "收获了，名为夏日回忆的宝物。",
    "type": "a",
    "from": "侦探已经死了",
    "from_who": "希耶斯塔",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615082115",
    "length": 14
  },
  {
    "id": 7213,
    "uuid": "8f989ec0-81c2-4f2e-bcba-009a8c18616d",
    "hitokoto": "精神上，没有上进心的人，是笨蛋！",
    "type": "a",
    "from": "归宅部活动记录",
    "from_who": "大荻牡丹",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616845770",
    "length": 16
  },
  {
    "id": 7219,
    "uuid": "e0c4ef75-18a0-4926-9806-08c1ed175aa5",
    "hitokoto": "下次见到你时，希望你也能成为永不凋零的希望之花。",
    "type": "a",
    "from": "火影忍者",
    "from_who": "小南",
    "creator": "亚亚努阿",
    "creator_uid": 8848,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617030126",
    "length": 24
  },
  {
    "id": 7287,
    "uuid": "c8ce8f05-4003-46b8-bdb8-642bbf342005",
    "hitokoto": "有一种说法是「恋爱就是一场梦」，既然是梦的话，只要给她一点时间，总是会醒的。",
    "type": "a",
    "from": "中二病也要谈恋爱！",
    "from_who": "五月七日茴香",
    "creator": "Hermione_Granger",
    "creator_uid": 4956,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617551744",
    "length": 38
  },
  {
    "id": 7290,
    "uuid": "d8e5cf89-96c1-483b-b74a-34ce5b4107c2",
    "hitokoto": "只要轻唤你的名字，我们的羁绊就永远不会消逝。",
    "type": "a",
    "from": "紫罗兰永恒花园",
    "from_who": "晓佳奈",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1620378133",
    "length": 22
  },
  {
    "id": 7329,
    "uuid": "a33332ad-2d6c-46d1-b386-a2fb59eec121",
    "hitokoto": "最后我还想再拜托你一件事，希望你可以把我忘掉。",
    "type": "a",
    "from": "末日时在做什么？有没有空？可以来拯救吗？",
    "from_who": "珂朵莉·诺塔·瑟尼欧里斯",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621775641",
    "length": 23
  },
  {
    "id": 7336,
    "uuid": "4ac6699d-beae-4b7f-9ff5-ecf4fc287f13",
    "hitokoto": "你不能因为喜欢一个人就把自己的生活扰乱​。",
    "type": "a",
    "from": "开心超人",
    "from_who": "博士",
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621919768",
    "length": 21
  },
  {
    "id": 7361,
    "uuid": "8f70babd-dbe7-46b0-8d50-342046885c45",
    "hitokoto": "人生当苦无妨，良人当归即好。",
    "type": "a",
    "from": "雪中悍刀行",
    "from_who": "烽火戏诸侯",
    "creator": "pfzl",
    "creator_uid": 9581,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1624720889",
    "length": 14
  },
  {
    "id": 7367,
    "uuid": "dd07ffb8-f38c-45ea-861a-2989aa7f9304",
    "hitokoto": "跌落谷底之后，唯有向上攀爬。",
    "type": "a",
    "from": "排球少年",
    "from_who": "田中龙之介",
    "creator": "席霖",
    "creator_uid": 9559,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625331913",
    "length": 14
  },
  {
    "id": 7369,
    "uuid": "3869f751-549c-4d07-bfc5-aaa67191710e",
    "hitokoto": "优秀的幼苗应该有与之相称的土壤，贫瘠的土地是无法结出丰盛果实的。",
    "type": "a",
    "from": "排球少年",
    "from_who": "牛岛若利",
    "creator": "席霖",
    "creator_uid": 9559,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1624463251",
    "length": 32
  },
  {
    "id": 7371,
    "uuid": "b6ba9683-3318-48ac-9351-4a4a42131f0f",
    "hitokoto": "不管对手是强是弱，结果只有胜负两种。输了的话，就无法站在球场上了。",
    "type": "a",
    "from": "排球少年",
    "from_who": "日向翔阳",
    "creator": "席霖",
    "creator_uid": 9559,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1624398866",
    "length": 33
  },
  {
    "id": 7372,
    "uuid": "fdfb0a59-2585-410a-b827-ad98252f6035",
    "hitokoto": "才能是可以栽培开花的，灵感是可以研磨雕琢的。",
    "type": "a",
    "from": "排球少年",
    "from_who": "及川彻",
    "creator": "席霖",
    "creator_uid": 9559,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1624398739",
    "length": 22
  },
  {
    "id": 7376,
    "uuid": "78f228e8-9153-47e4-ba76-9d1a3b0d5fed",
    "hitokoto": "如果今天是最糟糕的，那么明天一定比今天美好，不是吗？",
    "type": "a",
    "from": "未来日记",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625400804",
    "length": 26
  },
  {
    "id": 7382,
    "uuid": "fd86a1d0-49a3-41b8-a202-5c68946b299f",
    "hitokoto": "人们把自己不能理解的状态称之为疯狂。",
    "type": "a",
    "from": "尸者的帝国",
    "from_who": null,
    "creator": "YINGMJ",
    "creator_uid": 8456,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625401711",
    "length": 18
  },
  {
    "id": 7453,
    "uuid": "c40793ce-e0a6-4b68-9da1-281e0a5278df",
    "hitokoto": "我的梦想是不失去任何东西让所有人笑着回来。",
    "type": "a",
    "from": "某科学的超电磁炮",
    "from_who": "上条当麻",
    "creator": "IMin",
    "creator_uid": 9835,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626923539",
    "length": 21
  },
  {
    "id": 7461,
    "uuid": "1ed07bc1-78ed-4b8a-9c84-48313b5d5ae3",
    "hitokoto": "在染成红色的天空下，在雨中，流淌着，漂浮着的，最软弱的自己的倒影，朦胧蓝色的回忆。",
    "type": "a",
    "from": "知晓天空之蓝的人啊",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627502420",
    "length": 41
  },
  {
    "id": 7462,
    "uuid": "930aafc2-50c9-412a-a327-5ef3c3c024fd",
    "hitokoto": "彩虹不只是天上才有，也可以在心中架起。",
    "type": "a",
    "from": "P.A.R.T.Y假面骑士ZIO剧场版主题曲",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627502680",
    "length": 19
  },
  {
    "id": 7463,
    "uuid": "65205a74-2620-42e1-8d01-af91bacce77e",
    "hitokoto": "尽管我们的手中空无一物，却能因此紧紧相牵，当你一人时请别迷茫，因为我无论何时都不会放手。",
    "type": "a",
    "from": "尽管我们的手中空无一物",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627502923",
    "length": 44
  },
  {
    "id": 7465,
    "uuid": "a741ce5a-089f-4c68-b1be-37dc3094f56a",
    "hitokoto": "就因为没有好事发生，所以至少要保持微笑。",
    "type": "a",
    "from": "阴晴不定大哥哥",
    "from_who": "表田里道",
    "creator": "朱佳熠",
    "creator_uid": 9963,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627927358",
    "length": 20
  },
  {
    "id": 7467,
    "uuid": "0a759ae9-420e-47a2-939a-dfcf74add0c0",
    "hitokoto": "是你，是你，告诉我，若能在黑暗中绽放光芒，便能化作星空，悲伤化作笑颜，已经无需隐藏，漫天闪耀着的星光，都会为你照亮前行。",
    "type": "a",
    "from": "四月是你的谎言",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627502522",
    "length": 60
  },
  {
    "id": 7468,
    "uuid": "dc24259a-4310-4b18-b17c-436f49274685",
    "hitokoto": "即使得不到旁人的认同，即使不曾拥有像样的地位，我们小小的双手也一定，能为明天的某人带去笑容。",
    "type": "a",
    "from": "尽管我们的手中空无一物",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627502997",
    "length": 46
  },
  {
    "id": 7469,
    "uuid": "1498c578-5ee7-49b2-b888-b3ba9619414e",
    "hitokoto": "宁愿带着浑身伤痛勇敢站起 让泪水洒满尘埃与苍穹之间。",
    "type": "a",
    "from": "机动战士高达NT",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627503125",
    "length": 26
  },
  {
    "id": 7490,
    "uuid": "c63022c7-cbe5-4d62-927c-a6fd98aad067",
    "hitokoto": "来看看你的脚下，这就是你要走的路。",
    "type": "a",
    "from": "未来へ(向着未来)",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629228604",
    "length": 17
  },
  {
    "id": 7495,
    "uuid": "bf3156e9-f312-4c78-abf5-c99c76f2160b",
    "hitokoto": "来看看你的未来，那就是你的未来，向着未来，一步一步地走去。",
    "type": "a",
    "from": "未来へ(向着未来)",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629301385",
    "length": 29
  },
  {
    "id": 7501,
    "uuid": "466f94ce-00a5-4910-af1b-3239116e61aa",
    "hitokoto": "晨意微寒秋渐深，侧伴无事俏佳人。",
    "type": "a",
    "from": "WHITE ALBUM 2",
    "from_who": "Kazusa",
    "creator": "kazusa",
    "creator_uid": 10202,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629792240",
    "length": 16
  }
]